<template>
  <a-modal v-model="editOrderible" footer="" title="编辑订单" width="85%" @cancel="editOrderCancel" :maskClosable="false">
    <!--1、 待办事项提示 -->
    <a-card :bordered="false" id="editOrder">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <div style="background-color: #ffb892; padding-bottom: 1px">
            <a-row style="padding: 0px">
              <a-col :span="24" class="orderKeyword">
                <a v-if="myPendingMatters" href="javascript:;" @click="showmyPendingMatters" style="color: black">您有{{
                  myPendingMatters.length
                }}待办事项 请尽快处理</a>
                <a href="javascript:;" @click="showmyPendingMatters" style="color: black"
                  v-if="!myPendingMatters">您有0待办事项
                  请尽快处理</a>
                <template v-for="item, index in myPendingMatters">
                  <ul v-if="showmyPendingMattersible" :key="index">
                    <li style="margin-top: 5px">
                      <span>【{{ item.matterName }}】</span>
                      <span style="margin-left: 15px">{{ item.content }}</span>
                      <a-button v-if="button1 == 0" type="primary" style="margin-left: 30px"
                        @click="quickProcess(1, item.matterCode, item.processInstanceId)" :disabled="disClick1">
                        通过
                      </a-button>
                      <a-button v-if="button2 == 0" type="primary" style="margin-left: 10px"
                        @click="quickProcess(2, item.matterCode, item.processInstanceId)" :disabled="disClick2">
                        不通过
                      </a-button>
                    </li>
                  </ul>
                </template>
              </a-col>
            </a-row>
            <a-row style="padding: 0px" v-if="openUser">
              <a-col :span="24" class="orderKeyword">
                <span>查看订单最近5分钟打开人</span>
              </a-col>
            </a-row>
            <div v-if="isOrderOpenedmsg && openUser">
              <ul>
                <li v-if="this.isOrderOpenedmsg == 'success'">暂无信息</li>
                <li v-if="this.isOrderOpenedmsg != 'success'">{{ this.isOrderOpenedmsg }}</li>
              </ul>
            </div>
          </div>
        </a-form>
      </div>
    </a-card>
    <!--2、  -->
    <a-card class="car" :bordered="false" style="padding: 0px" v-if="this.reslist">
      <!-- 2.1审核改价等一排按钮 -->
      <a-row :class="[editOrderShow == 0 ? 'disEvents' : '']">
        <a-col>
          <!-- 2.1.1 审核改价等一排按钮 -->
          <div style="margin: 0px 20px 45px; position: relative" v-if="scrollin">
            <a-affix style="position: relative; left: -30px"
              :class="[isOrderOpenedmsg && openUser ? '' : 'nouserlook']">
              <a-row>
                <a-col :span="24">
                  <a-button type="primary" style="margin-left: 10px; float: left" @click="examine"
                    v-if="!orderSubStatus && auditSingle">
                    审核
                  </a-button>
                  <a-button type="primary" v-if="changePriice" style="margin-left: 10px; float: left"
                    @click="changePrice">
                    改价
                  </a-button>

                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'customerServiceApply' && ordercustomerServiceApply"
                    @click="customerServiceApply(0)">
                    通过
                  </a-button>
                  <a-button type="primary" style="margin-left: 10px" v-if="this.reslist.orderStatus == '不显示'"
                    @click="customerServiceApply(2)">
                    不通过
                  </a-button>
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="(this.reslist.orderStatus == 'completeOrder' || this.reslist.orderStatus == 'reviewOrder') && ordercompleteOrder"
                    @click="completeOrder(0)">
                    结单
                  </a-button>
                  <a-button type="primary" style="margin-left: 10px" v-if="this.reslist.orderStatus != 'endOrder' &&
                    this.reslist.orderStatus != 'dispatchOrder' &&
                    this.reslist.orderStatus != 'updateOrder' &&
                    this.reslist.orderStatus != 'customerServiceApply' &&
                    orderreassignment
                  " @click="reassignment()">
                    重新派单
                  </a-button>
                  <!-- <a-button type="primary" @click="reviewOrder(0)" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'reviewOrder' && orderreviewOrder">
                    核销完成
                  </a-button> -->

                  <!-- <a-button type="primary" @click="close(2)" style="margin-left: 10px" v-if="
                    (ordercloseOrder && this.reslist.orderStatus == 'reviewOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'settleOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'receiveOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'reservationOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'installOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'completeOrder')
                  ">
                    关闭
                  </a-button> -->

                  <a-button type="primary" style="margin-left: 10px" @click="leaflets" v-if="this.reslist.orderStatus == 'dispatchOrder' && orderdispatchOrder && this.reslist.grabStatus != 1
                  ">
                    派单
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'assignOrder' && orderreassignment" @click="assignOrder(0)">
                    通过
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'assignOrder' && orderreassignment" @click="assignOrder(1)">
                    不通过
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'updateOrder' && orderupdateOrder" @click="enterpriseUpdate(0)">
                    重新提交
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'updateOrder' && orderupdateOrder" @click="enterpriseUpdate(1)">
                    放弃提交
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px" @click="recovery" :loading="recoveryloading" v-if="(this.reslist.orderStatus == 'closeOrder' && ordercloseOrder) ||
                    (this.reslist.orderStatus == 'returnOrder' && orderreturnOrder)
                  ">
                    恢复
                  </a-button>
                  <!---->
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'returnOrder' && orderreturnOrder"
                    style="margin-left: 10px" @click="returnOrder(8)">
                    结束
                  </a-button>
                  <!---->
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'receiveOrder' && orderreceiveOrder"
                    style="margin-left: 10px" @click="receiveOrder(0)">
                    接单
                  </a-button>
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'receiveOrder' && orderreceiveOrder"
                    style="margin-left: 10px" @click="backCharge(3)">
                    拒单
                  </a-button>
                  <a-button type="primary"
                    v-if="this.reslist.orderStatus == 'reservationOrder' && orderreservationOrder && orderinstallOrder"
                    style="margin-left: 10px" @click="Statement(3)">
                    跳转至结单
                  </a-button>
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'dispatchOrder' && orderdispatchOrder"
                    style="margin-left: 10px" @click="Statement(2)">
                    跳转至结单
                  </a-button>
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'receiveOrder' ||
                    (this.reslist.orderStatus == 'installOrder' && orderreceiveOrder)
                  " style="margin-left: 10px" @click="Statement(4)">
                    跳转至结单
                  </a-button>
                  <!---->
                  <a-button type="primary"
                    v-if="this.reslist.orderStatus == 'reservationOrder' && orderreservationOrder"
                    style="margin-left: 10px" @click="reservationOrder(0)">
                    预约成功
                  </a-button>
                  <a-button type="primary"
                    v-if="reslist.foreignType == 6 && reslist.orderStatus == 'installOrder' && reslist.orderMaster.signStatus == 0"
                    style="margin-left: 10px" @click="signInOrder">
                    签到成功
                  </a-button>
                  <a-button type="primary"
                    v-if="this.reslist.orderStatus == 'reservationOrder' && orderreservationOrder"
                    style="margin-left: 10px" @click="failureReservationOrder">
                    预约异常
                  </a-button>
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'installOrder' && orderinstallOrder"
                    style="margin-left: 10px" @click="installOrder(0)">
                    销单
                  </a-button>
                  <!--<a-button  type="primary" v-if="this.reslist.orderStatus=='installOrder'&&orderinstallOrder"-->
                  <!--style="margin-left: 10px"  @click="installOrder(3)">-->
                  <!--改约成功-->
                  <!--</a-button>-->
                  <!--<a-button  type="primary" v-if="this.reslist.orderStatus=='installOrder'&&orderinstallOrder"-->
                  <!--style="margin-left: 10px"  @click="failureinstallOrder(0)">-->
                  <!--改约失败-->
                  <!--</a-button>-->
                  <a-button v-if="detailNoSettle" :type="showisTemporarilySettleDanger ? 'danger' : 'primary'"
                    @click="isSetNoSettle" style="margin-left: 10px">暂不结算</a-button>
                  <a-button v-if="detailFreeze" :type="this.reslist.freezeStatus == 1 ? 'danger' : 'primary'"
                    @click="selectOrderFrozen" style="margin-left: 10px">冻结订单</a-button>
                </a-col>
              </a-row>
            </a-affix>
          </div>
          <!-- 结单弹窗 -->
          <a-modal title="该订单要求旧件返厂，请核实旧件返厂信息！" :width="400" :visible="showJiedan" :closable="false">
            <div style="color:red">若信息完整无误，请点击“结单”，该订单支持正常结算；若信息未上传或者有误，请点击“暂不结算”，不对师傅进行结算。</div>
            <template slot="footer">
              <a-button @click="showJiedan = false">取消</a-button>
              <a-button type="primary" @click="isSetNoSettle">暂不结算</a-button>
              <a-button type="primary" @click="jiedan">结单</a-button>
            </template>

          </a-modal>
          <!-- 订单的付款方式为客户付款，则给出当前该派单弹框提示 -->
          <a-modal title="该订单为客户付款,请确定是否继续派单?" :width="400" :visible="showpaidan" :closable="false">
            <div style="color:red">请核实本单师傅结算金额是否正确!</div>
            <template slot="footer">
              <a-button @click="showpaidan = false">取消</a-button>
              <a-button type="primary" @click="continueOrder">继续派单</a-button>
            </template>

          </a-modal>
          <!-- 订单的付款方式为客户付款，则给出当前该结单弹框提示 -->
          <a-modal title="该订单为客户付款,请确定是否继续结单?" :width="400" :visible="showStateMent" :closable="false">
            <div style="color:red">请核实本单师傅结算金额是否正确!</div>
            <template slot="footer">
              <a-button @click="showStateMent = false">取消</a-button>
              <a-button type="primary" @click="hanleStateMent">结单</a-button>
            </template>

          </a-modal>
          <!-- 2.1.1 审核改价等一排按钮悬浮在顶部 -->
          <div style="margin: 0px 20px 45px; position: relative" v-if="!scrollin">
            <a-affix style="position: fixed; top: 0px; left: 180px; z-index: 9999">
              <a-row>
                <a-col :span="24">
                  <a-button type="primary" style="margin-left: 10px; float: left" @click="examine"
                    v-if="!orderSubStatus && auditSingle">
                    审核
                  </a-button>
                  <a-button type="primary" v-if="changePriice" style="margin-left: 10px; float: left"
                    @click="changePrice">
                    改价
                  </a-button>

                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'customerServiceApply' && ordercustomerServiceApply"
                    @click="customerServiceApply(0)">
                    通过
                  </a-button>
                  <a-button type="primary" style="margin-left: 10px" v-if="this.reslist.orderStatus == '不显示'"
                    @click="customerServiceApply(2)">
                    不通过
                  </a-button>
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="(this.reslist.orderStatus == 'completeOrder' || this.reslist.orderStatus == 'reviewOrder') && ordercompleteOrder"
                    @click="completeOrder(0)">
                    结单
                  </a-button>
                  <a-button type="primary" style="margin-left: 10px" v-if="this.reslist.orderStatus != 'endOrder' &&
                    this.reslist.orderStatus != 'dispatchOrder' &&
                    this.reslist.orderStatus != 'updateOrder' &&
                    this.reslist.orderStatus != 'customerServiceApply' &&
                    orderreassignment
                  " @click="reassignment()">
                    重新派单
                  </a-button>
                  <!---->
                  <!-- <a-button type="primary" @click="reviewOrder(0)" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'reviewOrder' && orderreviewOrder">
                    核销完成
                  </a-button> -->

                  <!-- <a-button type="primary" @click="close(2)" style="margin-left: 10px" v-if="
                    (ordercloseOrder && this.reslist.orderStatus == 'reviewOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'settleOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'receiveOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'reservationOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'installOrder') ||
                    (ordercloseOrder && this.reslist.orderStatus == 'completeOrder')
                  ">
                    关闭
                  </a-button> -->

                  <!---->
                  <a-button type="primary" style="margin-left: 10px" @click="leaflets" v-if="this.reslist.orderStatus == 'dispatchOrder' && orderdispatchOrder && this.reslist.grabStatus != 1
                  ">
                    派单
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'assignOrder' && orderreassignment" @click="assignOrder(0)">
                    通过
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'assignOrder' && orderreassignment" @click="assignOrder(1)">
                    不通过
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'updateOrder' && orderupdateOrder" @click="enterpriseUpdate(0)">
                    重新提交
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px"
                    v-if="this.reslist.orderStatus == 'updateOrder' && orderupdateOrder" @click="enterpriseUpdate(1)">
                    放弃提交
                  </a-button>
                  <!---->
                  <a-button type="primary" style="margin-left: 10px" @click="recovery" v-if="(this.reslist.orderStatus == 'closeOrder' && ordercloseOrder) ||
                    (ordercloseOrder && this.reslist.orderStatus == 'returnOrder' && orderreturnOrder)
                  ">
                    恢复
                  </a-button>
                  <!---->
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'returnOrder' && orderreturnOrder"
                    style="margin-left: 10px" @click="returnOrder(8)">
                    结束
                  </a-button>
                  <!---->
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'receiveOrder' && orderreceiveOrder"
                    style="margin-left: 10px" @click="receiveOrder(0)">
                    接单
                  </a-button>
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'receiveOrder' && orderreceiveOrder"
                    style="margin-left: 10px" @click="backCharge(3)">
                    拒单
                  </a-button>
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'reservationOrder' &&
                    orderreservationOrder &&
                    orderinstallOrder &&
                    this.$store.getters.userType != 44
                  " style="margin-left: 10px" @click="Statement(3)">
                    跳转至结单
                  </a-button>
                  <a-button type="primary" v-if="this.reslist.orderStatus == 'dispatchOrder' && orderdispatchOrder"
                    style="margin-left: 10px" @click="Statement(2)">
                    跳转至结单
                  </a-button>
                  <a-button type="primary" v-if="(this.reslist.orderStatus == 'receiveOrder' || this.reslist.orderStatus == 'installOrder') &&
                    orderreceiveOrder &&
                    this.$store.getters.userType != 44
                  " style="margin-left: 10px" @click="Statement(4)">
                    跳转至结单
                  </a-button>
                  <!---->
                  <a-button type="primary"
                    v-if="this.reslist.orderStatus == 'reservationOrder' && orderreservationOrder"
                    style="margin-left: 10px" @click="reservationOrder(0)">
                    预约成功
                  </a-button>
                  <!--  -->
                  <a-button type="primary"
                    v-if="reslist.foreignType == 6 && reslist.orderStatus == 'installOrder' && reslist.orderMaster.signStatus == 0"
                    style="margin-left: 10px" @click="signInOrder">
                    签到成功
                  </a-button>
                  <a-button type="primary"
                    v-if="this.reslist.orderStatus == 'reservationOrder' && orderreservationOrder"
                    style="margin-left: 10px" @click="failureReservationOrder">
                    预约异常
                  </a-button>

                  <a-button type="primary" v-if="this.reslist.orderStatus == 'installOrder' && orderinstallOrder"
                    style="margin-left: 10px" @click="installOrder(0)">
                    销单
                  </a-button>
                  <!--<a-button  type="primary" v-if="this.reslist.orderStatus=='installOrder'&&orderinstallOrder"-->
                  <!--style="margin-left: 10px"  @click="installOrder(3)">-->
                  <!--改约成功-->
                  <!--</a-button>-->
                  <!--<a-button  type="primary" v-if="this.reslist.orderStatus=='installOrder'&&orderinstallOrder"-->
                  <!--style="margin-left: 10px"  @click="failureinstallOrder(0)">-->
                  <!--改约失败-->
                  <!--</a-button>-->
                  <a-button v-if="detailNoSettle" :type="showisTemporarilySettleDanger ? 'danger' : 'primary'"
                    @click="isSetNoSettle" style="margin-left: 10px">暂不结算</a-button>
                  <a-button v-if="detailFreeze" :type="this.reslist.freezeStatus == 1 ? 'danger' : 'primary'"
                    @click="selectOrderFrozen" style="margin-left: 10px">冻结订单</a-button>
                </a-col>
              </a-row>
            </a-affix>
          </div>
        </a-col>
      </a-row>
      <a-spin :spinning="spinning" size="large" :delay="0">
        <!-- 2.3 整个详情页的tab切换-->
        <a-tabs type="card" :activeKey="activeKey" @change="callback">
          <a-tab-pane key="1" tab="订单详情" :class="[editOrderShow == 0 ? 'disEvents' : '']" v-if="detailTab">
            <!--基础信息部分-->
            <div class="table-page-search-wrapper" v-if="clientInfoDasic">
              <a-form layout="inline" :form="orderClientform">
                <!-- 基础信息标题行 -->
                <a-row :class="[!editClientInfo ? 'disEvents' : '']">
                  <a-col :span="4">
                    <div class="orderKeyword" style="margin: 20px">
                      <span style="font-size: 24px; font-weight: bold">基础信息</span>
                    </div>
                  </a-col>
                  <a-col :span="20">
                    <div style="">
                      <!--<a-button type="primary"  style="margin: 20px 5px">无需销单</a-button>-->
                      <a-button v-if="detailImportantOrder" :type="orderImportantbool ? 'danger' : 'primary'"
                        @click="orderImportant" style="margin: 20px 10px">重要订单</a-button>
                      <a-button v-if="detailUrgentOrder" :type="isUrgentOrder == 1 ? 'danger' : 'primary'"
                        @click="isOrderUrgent" style="margin: 20px 10px">加急订单</a-button>
                      <a-button v-if="detailSmsNotice" :type="isSmsWarnbool ? 'danger' : 'primary'" @click="isSmsWarn"
                        style="margin: 20px 10px">短信提醒</a-button>
                      <a-button :type="this.reslist.isTimeoutOrder == 1 ? 'danger' : 'primary'"
                        style="margin: 20px 10px">超时订单</a-button>
                      <!--<a-button type="primary"  style="margin: 20px 10px">问题反馈</a-button>-->
                      <a-button v-if="detailSmsNotice" :type="isSerialNotice ? 'danger' : 'primary'" @click="isSmsWarn2"
                        style="margin: 20px 10px">产品条形码</a-button>
                      <a-button :type="factoryStatus ? 'danger' : 'primary'" @click="changeFactory"
                        style="margin: 20px 10px">旧件返厂</a-button>
                    </div>
                  </a-col>
                </a-row>
                <!-- 从客户姓名到客户要求 -->
                <a-row :gutter="6" style="margin-left: 20px">
                  <a-col :md="7" :sm="24" :class="[!editClientInfo ? 'disEvents' : '']">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 43%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          <span style="color: red">*</span> 客户姓名 :
                        </span>
                        <a-input v-decorator="['clientName', { rules: [{ required: true, message: '请填写客户姓名!' }] }]" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="1" :sm="24">
                    <a title="复制">
                      <a-icon type="copy" class="copy" @click="Copys3" />
                    </a>
                  </a-col>
                  <a-col :md="8" :sm="24" v-if="clientNoShow">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="
                          width: 56%;
                          margin-right: 15px;
                          text-align: right;
                          color: rgba(0, 0, 0, 0.85);
                          font-size: 14px;
                        ">
                          <span style="color: red">*</span> 真实号码 :
                        </span>
                        <a-input :disabled="!editClientInfo ? true : false" v-decorator="[
                          'clientPhone',
                          { rules: [{ required: true, message: '请填写真实号码!' }, { validator: validateClientPhone }] }
                        ]" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24" v-if="clientNoShow">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="
                          width: 56%;
                          margin-right: 15px;
                          text-align: right;
                          color: rgba(0, 0, 0, 0.85);
                          font-size: 14px;
                        ">
                          虚拟号码 :
                        </span>
                        <a-input :disabled="!editClientInfo ? true : false" v-decorator="['virtualClientPhone']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24" :class="[!editClientInfo ? 'disEvents' : '']">
                    <a-row>
                      <a-col :md="18" :sm="24">
                        <a-form-item label="">
                          <div style="display: flex">
                            <span
                              style="
                                                                                                                                                                            width: 65%;
                                                                                                                                                                            margin-right: 15px;
                                                                                                                                                                            text-align: right;
                                                                                                                                                                            color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                            font-size: 14px;
                                                                                                                                                                          ">
                              期望安装时间 :
                            </span>
                            <a-date-picker @change="onChangerangepicker" style="width: 100%"
                              v-decorator="['expectinstallTime']" />
                          </div>
                        </a-form-item>
                      </a-col>
                      <a-col :md="6" :sm="24">
                        <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                          <a-select :getPopupContainer="getPopupContainer" @change="onChanginstallTimeible"
                            v-decorator="['installTimePart']" :allowClear="true">
                            <a-select-option v-for="type in originalTimeselect" :key="type.value">{{
                              type.label
                            }}</a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-col>
                  <a-col :md="13" :sm="24" :class="[!editClientInfo ? 'disEvents' : '']">
                    <a-row>
                      <a-col :md="9" :sm="24">
                        <a-form-item label="">
                          <div style="display: flex">
                            <span
                              style="
                                                                                                                                                                            width: 68%;
                                                                                                                                                                            margin-right: 15px;
                                                                                                                                                                            text-align: right;
                                                                                                                                                                            color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                            font-size: 14px;
                                                                                                                                                                          ">
                              <span style="color: red">*</span> 客户地址 :
                            </span>
                            <a-select :getPopupContainer="getPopupContainer" showSearch :filterOption="filterOption"
                              @change="getselect"
                              v-decorator="['provinceId', { rules: [{ required: true, message: '请选择客户地址!' }] }]">
                              <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode"
                                :title="type.provinceName">
                                {{ type.provinceName }}
                              </a-select-option>
                            </a-select>
                          </div>
                        </a-form-item>
                      </a-col>
                      <a-col :md="6" :sm="24">
                        <a-form-item>
                          <a-select :getPopupContainer="getPopupContainer" showSearch :filterOption="filterOption"
                            v-decorator="['cityId', { rules: [{ required: true, message: '请选择客户地址!' }] }]"
                            @change="getprovinceName">
                            <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">
                              {{ type.cityName }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col :md="7" :sm="24">
                        <a-form-item>
                          <a-select :getPopupContainer="getPopupContainer" showSearch :filterOption="filterOption"
                            v-decorator="['countyId', { rules: [{ required: true, message: '请选择客户地址!' }] }]">
                            <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">
                              {{ type.areaName }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-col>
                  <a-col :md="10" :sm="24" :class="[!editClientInfo ? 'disEvents' : '']">
                    <a-form-item label="详细地址" style="width: 100%; margin-left: 22px">
                      <a-input v-decorator="['clientAddress', { rules: [{ required: true, message: '请填写详细地址!' }] }]" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="7" :sm="24">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 43%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          宽带账号 :
                        </span>
                        <a-input v-decorator="['broadbandAccount', { rules: [{ message: '请填写宽带账号!' }] }]" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="7" :sm="24">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 43%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          电信手机号 :
                        </span>
                        <a-input
                          v-decorator="['telecomPhone', { rules: [{ message: '手机号格式错误!', pattern: /^1[3456789]\d{9}$/ }] }]" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :span="24" v-if="userType != '22'" :class="[!editClientInfo ? 'disEvents' : '']">
                    <a-form-item label="">
                      <div style="display: flex;">
                        <span
                          style="
                                                                                                                                                                        width: 9%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">客户要求
                          :
                        </span>
                        <a-input placeholder="注意：此要求师傅可看，仅限派单前填写；" v-decorator="['clientRequire']" type="textarea"
                          style="height:7rem;resize:none" />
                      </div>
                    </a-form-item>
                    <!--<span style="color: red;margin-left: 112px" >注意：此要求师傅可看，仅限派单前填写；</span>-->
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 从订单号到客户下单 -->
            <div style="margin-bottom:4rem"></div>
            <div class="table-page-search-wrapper" v-if="detailTabbaseData">
              <a-form layout="inline" :form="form" :class="[!editBaseData ? 'disEvents' : '']">
                <!--<div class="orderKeyword" style="margin: 20px;"><label style="font-size: 24px;font-weight: bold">基础信息</label>-->
                <!--</div>-->
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">订单号
                          :
                        </span>
                        <a-input v-decorator="['orderNo']" disabled="disabled" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">原始单号
                          :
                        </span>
                        <a-input v-decorator="['originalOrderNo']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">序列号-商端
                          :
                        </span>
                        <a-input v-decorator="['serialNumberMerchant']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatasaleOrderNo">
                    <a-form-item label="" style="margin-left: 45px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">销单码
                          :
                        </span>
                        <a-input v-decorator="['saleCode']" disabled="disabled" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item style="display: none">
                      <a-input v-decorator="['enterpriseId']" />
                    </a-form-item>
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">企业名称
                          :
                        </span>
                        <a-input v-decorator="['enterpriseName']" disabled="disabled" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          <span style="color: red">*</span> 安装类别 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer" disabled="disabled"
                          v-decorator="['installType', { rules: [{ required: true, message: '请选择安装类别!' }] }]"
                          @change="installChange" :allowClear="true">
                          <a-select-option v-for="type in installTypes" :key="type.installationTypeCode">
                            {{ type.installationTypeName }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          <span style="color: red">*</span> 订单类型 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer"
                          v-decorator="['orderType', { rules: [{ required: true, message: '请选择订单类型!' }] }]"
                          @change="orderChange">
                          <a-select-option v-for="type in List" :key="type.orderTypeId">
                            {{ type.typeName }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          <span style="color: red">*</span> 数量 :
                        </span>
                        <a-input-number :min="1"
                          v-decorator="['number', { rules: [{ required: true, message: '请填写数量!' }] }]"
                          style="width: 100%" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          <span style="color: red">*</span>品牌 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer" showSearch optionFilterProp="children"
                          @change="changeBrandName" :filterOption="filterOption"
                          v-decorator="['brandId', { rules: [{ required: true, message: '请选择品牌!' }] }]"
                          :allowClear="true">
                          <a-select-option v-for="type in selectBrand" :key="type.brandId">
                            {{ type.brandName }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          <span style="color: red">*</span>型号 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer" showSearch optionFilterProp="children"
                          @change="changeModelName" :filterOption="filterOption"
                          v-decorator="['modelId', { rules: [{ required: true, message: '请选择型号!' }] }]"
                          :allowClear="true">
                          <a-select-option v-for="type in selectModel" :key="type.modelId">
                            {{ type.modelName }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          规格（长度）(mm) :
                        </span>
                        <a-input :value="modelSpecLength" disabled placeholder="自动带入" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          规格（宽度）(mm) :
                        </span>
                        <a-input :value="modelSpecWidth" disabled placeholder="自动带入" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          购买渠道 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer" showSearch optionFilterProp="children"
                          @change="changesourceName" :filterOption="filterOption" v-decorator="['buyChannelId']"
                          :allowClear="true">
                          <a-select-option v-for="type in selectChannel" :key="type.channelId">{{ type.channelName }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          信息来源 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer" showSearch optionFilterProp="children"
                          @change="changeinfoSourceName" :filterOption="filterOption" v-decorator="['infoSourceId']"
                          :allowClear="true">
                          <a-select-option v-for="type in selectSource" :key="type.sourceId">{{ type.sourceName }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="width: 70%;margin-right: 15px;text-align: right; color: rgba(0, 0, 0, 0.85);font-size: 14px; ">
                          门厚(mm) :
                        </span>
                        <a-input-number style="width:100%" :min="0" :max="99999" :step="1" :precision="0"
                          placeholder="请输入0-99999整数" v-decorator="['doorThickness']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="width: 100%;margin-right: 6px;text-align: right; color: rgba(0, 0, 0, 0.85);font-size: 14px; ">
                          是否有导向片 :
                        </span>
                        <a-select style="width:100%" v-decorator="['isCounterVane']"
                          @change="onHasCounterVaneChange" placeholder="请选择">
                          <a-select-option v-for="item in hasCounterVaneOptions" :key="item.value">
                            {{ item.label }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="showCounterVaneFields">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="width: 100%;margin-right: 6px;text-align: right; color: rgba(0, 0, 0, 0.85);font-size: 14px; ">
                          <span style="color: red">*</span> 导向片长度(mm) :
                        </span>
                        <a-input-number style="width:100%" :min="0" :max="99999" :step="1" :precision="0"
                          placeholder="请输入0-99999整数" v-decorator="['counterVaneLength', { rules: [{ required: true, message: '请输入导向片长度' }] }]" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="showCounterVaneFields">
                    <a-form-item label="">
                      <div style="display: flex">
                        <span
                          style="width: 100%;margin-right: 6px;text-align: right; color: rgba(0, 0, 0, 0.85);font-size: 14px; ">
                          <span style="color: red">*</span> 导向片宽度(mm) :
                        </span>
                        <a-input-number style="width:100%" :min="0" :max="99999" :step="1" :precision="0"
                          placeholder="请输入0-99999整数" v-decorator="['counterVaneWidth', { rules: [{ required: true, message: '请输入导向片宽度' }] }]" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="width: 70%;margin-right: 15px;text-align: right;color: rgba(0, 0, 0, 0.85);font-size: 14px;">是否配件随货:
                        </span>
                        <a-select :getPopupContainer="getPopupContainer" showSearch optionFilterProp="children"
                          @change="changeAccessories" :filterOption="filterOption" v-decorator="['sparepart']"
                          autocomplete="off" :allowClear="true">
                          <a-select-option v-for="type in accessoriesOptions" :title="type.label" :key="type.code">{{
                            type.label }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          核销时间 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['checkTime']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          订单完成时间 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['orderFinishTime']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          建单时间 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['createTime']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          建单人 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['userName']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="settlementInfo">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          <span style="color: red">*</span> 付款方式 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer"
                          v-decorator="['payType', { rules: [{ required: true, message: '请选择付款方式!' }] }]">
                          <a-select-option v-for="type in pay_type" :key="type.dictValue">{{ type.dictLabel }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          订单流程状态 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['orderStatusStr']" />
                      </div>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="24" v-if="settlementInfo">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          企业结算状态 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer" disabled="disabled" showSearch
                          v-decorator="['enterpriseSettleStatus']" :allowClear="true">
                          <a-select-option v-for="type in settlement_status" :key="type.dictValue">
                            {{ type.dictLabel }}
                          </a-select-option>
                        </a-select>
                      </div>
                      <!--<a-input disabled="disabled"-->
                      <!--v-decorator="['settleStatus']" />-->
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="settlementInfo">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          企业结算周期 :
                        </span>
                        <a-select :getPopupContainer="getPopupContainer" v-decorator="['enterpriseSettlementType']"
                          disabled="disabled" :allowClear="true">
                          <a-select-option v-for="type in settle_cycle" :key="type.dictValue">{{ type.dictLabel }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="settlementInfo">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          企业结算时间 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['enterpriseSettleTime']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <!--<a-col :md="6" :sm="24">-->
                  <!--<a-form-item label="付款状态":labelCol="labelCol" :wrapperCol="wrapperCol"style="margin-left: 30px">-->
                  <!--<a-select disabled="disabled"  v-decorator="['payStatus']">-->
                  <!--<a-select-option  v-for="type in pay_status" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>-->
                  <!--</a-select>-->
                  <!--</a-form-item>-->
                  <!--</a-col>-->
                  <a-col :md="6" :sm="24" v-if="baseDatalastInterveneTime">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          最近介入 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['intervenTime']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <!--<a-col :md="6" :sm="24">-->
                  <!--<a-form-item label="付款时间" :labelCol="labelCol" :wrapperCol="wrapperCol"style="margin-left: 30px">-->
                  <!--<a-input  disabled="disabled"  v-decorator="['payTime']"/>-->
                  <!--</a-form-item>-->
                  <!--</a-col>-->
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          订单协助人 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['helperName']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          保修期 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['guaranteeTime']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          客户下单 :
                        </span>
                        <a-select disabled="disabled" v-decorator="['isUserOrder']" :allowClear="true">
                          <a-select-option value="0" title="否"> 否 </a-select-option>
                          <a-select-option value="1" title="是"> 是 </a-select-option>
                        </a-select>
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          订单来源 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['sourceEnterpriseName']" />
                      </div>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="24" v-if="baseDatabasic">
                    <a-form-item   label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span style="
                          width: 75%;
                          margin-right: 15px;
                          text-align: right;
                          color: rgba(0, 0, 0, 0.85);
                          font-size: 14px;
                        ">序列号-扫码:</span>
                        <a-input v-if="reslist.foreignType == 6 && orderTypeName == '安装单'" @click="openYsSnSetting" style="cursor: pointer;"
                          readonly v-decorator="['serialNumber']" />
                        <a-input v-else v-decorator="['serialNumber']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="12" :sm="24" v-for="(type, index) in reslist.installCustomize" :key="index"
                    v-show="orderTypeName == '维修单' && (type.infoName == '维修单故障原因' || type.infoName == '维修单维修方案' || (enterpriseId == '29b229bb034511edaf7bfa163e9992db' && type.infoName == '维修内容'))">
                    <a-form-item :label="type.infoName" style="margin-left: 15px" :labelCol="labelCol"
                      :wrapperCol="wrapperCol" :required="type.isRequired == '0' ? true : false">
                      <a-select :getPopupContainer="getPopupContainer" @change="changeselect(index, $event)"
                        :allowClear="true" v-model="type.infoValue">
                        <a-select-option v-for="tab in type.dictInfo" :key="tab.dictValue">
                          {{ tab.dictLabel }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="12" :sm="24">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 23%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          CTEI码 :
                        </span>
                        <a-input disabled="disabled" v-decorator="['ctei']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="12" :sm="24"
                    v-if="enterpriseId == '30f7cd16e73a11ee87dafa163e9992db' || enterpriseId == '72620e120c3a11ef8a26fa163ec52c23'">
                    <a-form-item label="购买卖场">
                      <a-input v-decorator="['purchaseOfStore']" disabled />
                    </a-form-item>
                  </a-col>
                  <div v-if="factoryStatus">
                    <a-col :md="6" :sm="24">
                      <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <div style="display: flex">
                          <span
                            style="
                                                                                                                                                                    width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                            箱码 :
                          </span>
                          <a-input v-decorator="['caseCode']" />
                        </div>
                      </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                      <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <div style="display: flex">
                          <span
                            style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                            旧件码 :
                          </span>
                          <a-input v-decorator="['oldPartCode']" />
                        </div>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <div style="display: flex">
                          <span
                            style="
                                                                                                                                                                  width: 22%;
                                                                                                                                                                  margin-right: 15px;
                                                                                                                                                                  text-align: right;
                                                                                                                                                                  color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                  font-size: 14px;
                                                                                                                                                                ">
                            <span style="color: red">*</span> 寄回要求 :
                          </span>
                          <a-select :getPopupContainer="getPopupContainer" showSearch optionFilterProp="children"
                            :disabled="EnterDisabled" @change="sendBackListChange($event)" autocomplete="off"
                            v-decorator="['enterpriseSendBackId', { rules: [{ required: true, message: '请选择寄件要求!' }] }]">
                            <a-select-option v-for="type in sendBackList" :key="type.id">{{ type.requirement }}
                            </a-select-option>
                          </a-select>
                        </div>
                      </a-form-item>
                    </a-col>
                    <a-col :md="24" :sm="24">
                      <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <div style="display: flex">
                          <span
                            style="
                                                                                                                                                                        width: 11%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      "><span
                              style="color: red">*</span>
                            旧件寄回地址 :
                          </span>
                          <a-select :getPopupContainer="getPopupContainer"
                            v-decorator="['enterpriseAddressId', { rules: [{ required: true, message: '请选择旧件寄回地址!' }] }]">
                            <a-select-option v-for="type in address_type" :key="type.id">{{
                              type.contact + '-' + type.phoneNumber + '-' + type.address
                            }}
                            </a-select-option>
                          </a-select>
                        </div>
                      </a-form-item>
                    </a-col>
                  </div>
                  <a-col :md="6" :sm="24" v-if="reslist.firstName">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          {{ reslist.firstName }} :
                        </span>
                        <a-input v-decorator="['firstValue']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="reslist.secondName">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          {{ reslist.secondName }} :
                        </span>
                        <a-input v-decorator="['secondValue']" />
                      </div>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="reslist.thirdName">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span
                          style="
                                                                                                                                                                        width: 75%;
                                                                                                                                                                        margin-right: 15px;
                                                                                                                                                                        text-align: right;
                                                                                                                                                                        color: rgba(0, 0, 0, 0.85);
                                                                                                                                                                        font-size: 14px;
                                                                                                                                                                      ">
                          {{ reslist.thirdName }} :
                        </span>
                        <a-input v-decorator="['thirdValue']" />
                      </div>
                    </a-form-item>
                  </a-col>

                  <!-- <a-col :md="6" :sm="24"
                    v-if="reslist.factoryStatus == 1 && reslist.factoryDataStatus == 1 && (reslist.orderStatus == 'reviewOrder' || reslist.orderStatus == 'settleOrder' || reslist.orderStatus == 'endOrder' || reslist.orderStatus == 'completeOrder')">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <div style="display: flex">
                        <span style="
                            width: 75%;
                            margin-right: 15px;
                            text-align: right;
                            color: rgba(0, 0, 0, 0.85);
                            font-size: 14px;
                          ">
                          物流单号 :
                        </span>
                        <a-input disabled v-decorator="['courierNumber']" />
                      </div>
                    </a-form-item>
                  </a-col> -->
                  <!-- <a-col :md="6" :sm="24"
                    v-if="reslist.factoryStatus == 1 && reslist.factoryDataStatus == 1 && (reslist.orderStatus == 'reviewOrder' || reslist.orderStatus == 'settleOrder' || reslist.orderStatus == 'endOrder' || reslist.orderStatus == 'completeOrder')"">
                    <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <div style="display: flex">
                      <span style="
                            width: 38%;
                            margin-right: 15px;
                            text-align: right;
                            color: rgba(0, 0, 0, 0.85);
                            font-size: 14px;
                          ">
                        物流照片 :
                      </span>
                      <img @click="previewVisible1 = true" :src="imgUrl + reslist.courierImg" alt=""
                        style="width:80px;height: 80px" />
                    </div>
                    </a-form-item>
                  </a-col> -->
                </a-row>
              </a-form>
              <a-modal :visible="previewVisible1" :footer="null" @cancel="previewVisible1 = false">
                <img :src="imgUrl + reslist.courierImg" alt="" style="width: 100%; padding: 10px" />
              </a-modal>
            </div>
            <!--师傅信息-->
            <div class="table-page-search-wrapper" v-if="masterInfo">
              <a-form layout="inline" :form="informationMasterform">
                <div class="orderKeyword" style="margin: 20px">
                  <label style="font-size: 24px; font-weight: bold">师傅信息</label>
                </div>
                <a-row :gutter="24" style="margin-left: 20px">
                  <a-col :md="5" :sm="24" v-if="masterInfoName">
                    <a-form-item label="师傅姓名" style="margin-left: 30px">
                      <a-input v-decorator="['workName']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="1" :sm="24" v-if="masterInfoName">
                    <a title="复制">
                      <a-icon type="copy" class="copy" @click="Copys2" />
                    </a>
                  </a-col>

                  <a-col :md="6" :sm="24" v-if="masterInfophoneNoall">
                    <a-form-item label="师傅联系方式">
                      <a-input disabled="disabled" v-decorator="['workPhone']" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="settleInfo">
                    <a-form-item label="师傅结算状态">
                      <a-select :getPopupContainer="getPopupContainer" disabled="disabled" showSearch
                        v-decorator="['masterSettleStatus']" :allowClear="true">
                        <a-select-option v-for="type in settlement_status" :key="type.dictValue">
                          {{ type.dictLabel }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="settleInfo">
                    <a-form-item label="师傅结算时间">
                      <a-input disabled="disabled" v-decorator="['masterSettleTime']" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="settleInfo">
                    <a-form-item label="师傅结算周期">
                      <a-select :getPopupContainer="getPopupContainer" v-decorator="['cashCycle']" disabled="disabled"
                        :allowClear="true">
                        <a-select-option v-for="type in settle_cycle" :key="type.dictValue">{{ type.dictLabel }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatalastdetailTime">
                    <a-form-item label="照片上传时间">
                      <a-date-picker @change="onChangeTime1" format="YYYY-MM-DD HH:mm" showTime
                        v-decorator="['picUploadTime']" :disabled="masterDisabled || !editTime" style="width: 100%" />
                      <!--<a-input :disabled="!editTime"-->
                      <!--v-decorator="['picUploadTime']"/>-->
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatalastdetailTime">
                    <a-form-item label="接单时间" style="margin-left: 30px">
                      <a-date-picker @change="onChangeTime2" format="YYYY-MM-DD HH:mm" showTime
                        v-decorator="['acceptTime']" :disabled="masterDisabled || !editTime" style="width: 100%" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="baseDatalastdetailTime">
                    <!-- 销单时间禁用  :disabled="masterDisabled || !editTime" -->
                    <a-form-item label="销单时间" style="margin-left: 30px">
                      <a-date-picker @change="onChangeTime3" format="YYYY-MM-DD HH:mm" showTime
                        v-decorator="['saleTime']" :disabled="true" style="width: 100%" />
                      <!--<a-input :disabled="!editTime"  v-decorator="['saleTime']"/>-->
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="24" v-if="failure">
                    <a-form-item label="预约异常原因">
                      <a-input :title="reserveFailureReason" v-model="reserveFailureReason" disabled="disabled" />
                      <!--<a-input :disabled="!editTime"  v-decorator="['saleTime']"/>-->
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="24" v-if="failure">
                    <a-form-item label="预约异常类型">
                      <a-input :title="reserveFailureType" v-model="reserveFailureType" disabled="disabled" />
                      <!--<a-input :disabled="!editTime"  v-decorator="['saleTime']"/>-->
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="24" v-if="masterInfoGeneral">
                    <a-row>
                      <a-col :md="17" :sm="24">
                        <a-form-item label="上门预约时间">
                          <a-date-picker @change="onChangereserveTime" style="width: 100%" v-decorator="['reserveTime']"
                            :disabled="masterDisabled || !editTime" />
                        </a-form-item>
                      </a-col>
                      <a-col :md="7" :sm="24">
                        <a-form-item>
                          <a-select :getPopupContainer="getPopupContainer" v-decorator="['reserveTimePart']"
                            :allowClear="true" :disabled="masterDisabled || !editTime">
                            <a-select-option v-for="type in timeselect" :key="type.value">{{
                              type.label
                            }}</a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="fitStatus == 1">
                    <a-form-item label="配件情况">
                      <a-input disabled v-decorator="['turnBack']" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="签到时间" style="margin-left: 30px">
                      <a-date-picker @change="onChangeTime4" format="YYYY-MM-DD HH:mm:ss"
                        :disabled="reslist.foreignType == 6 && (reslist.orderStatus == 'installOrder' || reslist.orderStatus == 'reservationOrder') && reslist.orderMaster.signStatus == 0 ? false : true"
                        showTime v-decorator="['signTime']" style="width: 100%" />
                    </a-form-item>
                  </a-col>

                  <a-col :md="18" :sm="24" v-if="masterInfoName">
                    <a-form-item label="签到地址" style="width: 100%">
                      <a-input v-decorator="['signAddress', { rules: [{ required: false, message: '请填写详细地址!' }] }]"
                        disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="18" :sm="24" v-if="masterInfoName && reslist.orderMaster && reslist.orderMaster.telImg">
                    <a-form-item label="预约异常通话截图" style="width: 100%">
                      <img @click="previewVisible2 = true" :src="imgUrl + reslist.orderMaster.telImg" alt=""
                        style="height: 80px" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-modal :visible="previewVisible2" :footer="null" @cancel="previewVisible2 = false">
                  <img v-if="reslist.orderMaster && reslist.orderMaster.telImg"
                    :src="imgUrl + reslist.orderMaster.telImg" alt="" style="width: 100%; padding: 10px" />
                </a-modal>
                <div v-if="masterInfoName">
                  <div class="orderKeyword" style="margin: 20px">
                    <label style="font-size: 24px; font-weight: bold">安装师傅信息</label>
                  </div>
                  <a-row :gutter="24" style="margin-left: 20px">
                    <a-col :md="5" :sm="24">
                      <a-form-item label="师傅姓名" style="margin-left: 30px">
                        <a-input v-decorator="['installName']" disabled="disabled" />
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="24">
                      <a-form-item label="师傅联系方式">
                        <a-input disabled="disabled" v-decorator="['phoneNumber']" />
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="24">
                      <a-form-item label="信用分">
                        <a-input disabled="disabled" v-decorator="['creditScore']" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="orderKeyword" style="margin: 20px">
                  <label style="font-size: 24px; font-weight: bold">订单提醒</label>
                </div>
                <a-row :gutter="24" style="margin-left: 20px">

                  <a-col :span="4">
                    <a-date-picker disabled v-model="orderReminde.date" />
                  </a-col>
                  <a-col :span="4">
                    <a-time-picker :disabledHours="disabledDate" :disabledMinutes="disabledMinutes"
                      :disabledSeconds="disabledSeconds" format="HH:mm:ss" :disabled="disabledTime"
                      @change="getTimeClick" v-model="timeValueString" />
                  </a-col>
                  <a-col :span="9" style="padding-left:0px;">
                    <a-input :disabled="disabledTime" v-model="orderReminde.remark" :maxLength="20"
                      placeholder="提醒事项" />
                  </a-col>
                  <a-button type="primary" style="" :disabled="disabledTime" @click="handleStart()">启动 </a-button>
                  <a-button type="primary" style="margin-left:12px" v-if="disabledTime" @click="ProcessedClick">处理完成
                  </a-button>

                </a-row>

                <a-row v-if="addMasterRemark">
                  <a-col :span="22" style="margin-bottom: 3px">
                    <div class="orderKeyword" style="margin: 20px">
                      <label style="font-size: 24px; font-weight: bold">师傅备注</label>
                    </div>
                    <div ccdlass="table-page-search-wrapper" style="margin-bottom: 15px">
                      <a-form layout="inline">
                        <div v-if="masterNotesExpand && reslist.masterRemark">
                          <a-table size="default" ref="table" rowKey="accessoryId" :columns="mastercolumns"
                            :dataSource="reslist.masterRemark.slice(0, 8)" :pagination="false">
                            <span slot="action" slot-scope="text, record">
                              <a @click="orderRemarkEdit(record)" v-if="editMasterRemark">编辑</a>
                              <a-divider type="vertical" v-if="editMasterRemark" />
                              <a-popconfirm title="是否要删除此行？" v-if="removeMasterRemark"
                                @confirm="removeorderRemark(record.orderRemarkId)"><a>删除</a>
                              </a-popconfirm>
                            </span>
                          </a-table>
                        </div>
                        <div v-if="!masterNotesExpand && reslist.masterRemark">
                          <a-table size="default" ref="table" rowKey="accessoryId" :columns="mastercolumns"
                            :dataSource="reslist.masterRemark" :pagination="false">
                            <span slot="action" slot-scope="text, record" v-if="remarkLimit">
                              <a @click="orderRemarkEdit(record)" v-if="editMasterRemark">编辑</a>
                              <a-divider type="vertical" v-if="editMasterRemark" />
                              <a-popconfirm title="是否要删除此行？" v-if="removeMasterRemark"
                                @confirm="removeorderRemark(record.orderRemarkId)"><a>删除</a>
                              </a-popconfirm>
                            </span>
                          </a-table>
                        </div>
                      </a-form>
                    </div>
                    <a-row style="margin-left: 20px" v-if="remarkLimit">
                      <a-col :span="22">
                        <a-row style="margin-left: 20px">
                          <a-col :span="20">
                            <a-form-item style="width: 100%; ">
                              <a-textarea :rows="4" v-model.trim="remark.remarkInfo" style="resize:none" />
                            </a-form-item>
                          </a-col>
                          <a-col :span="2">
                            <a-button type="primary" style="margin-left: 20px" @click="Submission()"
                              v-if="addMasterRemark">提交</a-button>
                          </a-col>
                        </a-row>
                      </a-col>
                    </a-row>
                    <a-row v-if="this.reslist.masterRemark.length > 8">
                      <!---->
                      <a-col :span="2" style=""> </a-col>
                      <a-col :span="20">
                        <a-form-item label="" style="margin: 20px">
                          <a-button type="primary" @click="masterNotesExpand = !masterNotesExpand">收起/展开</a-button>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <!--</a-col>-->
                <!--</a-row>-->
                <!-- <a-row v-if="masterInfoRemark" style="margin-top: 8px">
                  <a-col :span="20" style="display: flex; margin-left: 20px">
                    <div class="clearfix" style="margin-top: 8px; display: flex; margin-left: 42px">
                      <a-upload
                        :action="currencyuploadUrl"
                        name="file"
                        list-type="picture-card"
                        :file-list="fileListMaster"
                        :headers="headers"
                        @preview="handlePreview"
                        @change="handleChangeMaster"
                      >
                        <div>
                          <a-icon type="plus" />
                          <div class="ant-upload-text">添加照片</div>
                        </div>
                      </a-upload>
                    </div>
                  </a-col>
                </a-row> -->
              </a-form>
            </div>
            <!--订单备注-->
            <a-row>
              <a-col :span="22">
                <div class="table-page-search-wrapper">
                  <a-form layout="inline">
                    <div class="orderKeyword" style="margin: 60px">
                      <label style="font-size: 24px; font-weight: bold">订单备注</label>
                    </div>
                    <div class="table-page-search-wrapper" style="margin-bottom: 15px">
                      <a-form layout="inline" :form="form">
                        <div v-if="notesOrderExpand">
                          <a-table size="default" ref="table" rowKey="accessoryId" :columns="ordercolumns"
                            :dataSource="this.reslist.orderRemark.slice(0, 8)" :pagination="false">
                            <span slot="action" slot-scope="text, record">
                              <a v-if="record.remarkType == 1 && editOuterrRemark"
                                @click="orderRemarkEdit(record)">编辑</a>
                              <a v-if="record.remarkType == 0 && editInnerRemark"
                                @click="orderRemarkEdit(record)">编辑</a>
                              <a-divider type="vertical" v-if="(record.remarkType == 1 && addOrDeleteOuterRemark) ||
                                (record.remarkType == 0 && addOrDeleteInnerRemark)
                              " />
                              <a-popconfirm title="是否要删除此行？" v-if="record.remarkType == 1 && addOrDeleteOuterRemark"
                                @confirm="removeorderRemark(record.orderRemarkId)"><a>删除</a></a-popconfirm>
                              <a-popconfirm title="是否要删除此行？" v-if="record.remarkType == 0 && addOrDeleteInnerRemark"
                                @confirm="removeorderRemark(record.orderRemarkId)"><a>删除</a></a-popconfirm>
                              <a-divider type="vertical" v-if="(record.remarkType == 1 && addOrDeleteOuterRemark) ||
                                (record.remarkType == 0 && addOrDeleteInnerRemark)
                              " />
                              <a v-if="record.remarkType == 1 && addOrDeleteOuterRemark"
                                @click="internalAdd(record)">追加</a>
                              <a v-if="record.remarkType == 0 && addOrDeleteInnerRemark"
                                @click="internalAdd(record)">追加</a>
                            </span>
                          </a-table>
                        </div>
                        <div v-if="!notesOrderExpand">
                          <a-table size="default" ref="table" rowKey="accessoryId" :columns="ordercolumns"
                            :dataSource="this.reslist.orderRemark" :pagination="false">
                            <span slot="action" slot-scope="text, record">
                              <a v-if="record.remarkType == 1 && editOuterrRemark"
                                @click="orderRemarkEdit(record)">编辑</a>
                              <a v-if="record.remarkType == 0 && editInnerRemark"
                                @click="orderRemarkEdit(record)">编辑</a>
                              <a-divider type="vertical" v-if="(record.remarkType == 1 && editOuterrRemark) ||
                                (record.remarkType == 0 && editInnerRemark)
                              " />
                              <a-popconfirm title="是否要删除此行？" v-if="record.remarkType == 1 && addOrDeleteOuterRemark"
                                @confirm="removeorderRemark(record.orderRemarkId)"><a>删除</a></a-popconfirm>
                              <a-popconfirm title="是否要删除此行？" v-if="record.remarkType == 0 && addOrDeleteInnerRemark"
                                @confirm="removeorderRemark(record.orderRemarkId)"><a>删除</a></a-popconfirm>
                              <a-divider type="vertical" v-if="(record.remarkType == 1 && addOrDeleteOuterRemark) ||
                                (record.remarkType == 0 && addOrDeleteInnerRemark)
                              " />
                              <a v-if="record.remarkType == 1 && addOrDeleteOuterRemark"
                                @click="internalAdd(record)">追加</a>
                              <a v-if="record.remarkType == 0 && addOrDeleteInnerRemark"
                                @click="internalAdd(record)">追加</a>
                            </span>
                          </a-table>
                        </div>
                      </a-form>
                    </div>
                    <a-row>
                      <a-col :span="3"> </a-col>
                      <a-col :span="3" v-if="this.reslist.orderRemark.length > 8">
                        <a-form-item label="" style="margin: 0 20px 20px 0">
                          <a-button type="primary" @click="notesOrderExpand = !notesOrderExpand">收起/展开</a-button>
                        </a-form-item>
                      </a-col>
                      <!-- <a-col :span="3">
                        <a-checkbox
                          v-model="orderexternalible"
                          v-if="viewOuterrRemark && viewInnerRemark"
                          @change="orderexternal"
                          >外部</a-checkbox
                        >
                      </a-col>
                      <a-col :span="3">
                        <a-checkbox v-model="orderinsideible" v-if="viewInnerRemark" @change="orderinside"
                          >内部</a-checkbox
                        >
                      </a-col> -->
                    </a-row>
                    <a-row style="margin-left: -4.5px; margin-left: 20px">
                      <a-col :span="22">
                        <a-row style="margin-left: -4.5px; margin-left: 20px">
                          <a-col :span="1" style="margin-top: 4px; margin-right: 15px"> </a-col>
                          <a-col :span="20">
                            <a-row>
                              <a-form-item label="企业" style="width: 100%; margin-left: -55px">
                                <a-textarea :rows="2" style="resize:none" v-model.trim="orderremark.remark1"
                                  placeholder="企业" />
                              </a-form-item>
                            </a-row>
                            <a-row>
                              <a-form-item label="客户" style="width: 100%; margin:5px 0 30px -55px;">
                                <a-textarea style="resize:none" :rows="2" v-model.trim="orderremark.remark2"
                                  placeholder="客户" />
                              </a-form-item>
                            </a-row>
                            <a-row>
                              <a-form-item label="师傅" style="width: 100%; margin-left: -55px">
                                <a-textarea style="resize:none" :rows="2" v-model.trim="orderremark.remark3"
                                  placeholder="师傅" />
                              </a-form-item>
                            </a-row>
                          </a-col>
                          <a-col :span="2" style="display: flex; flex-wrap: wrap">
                            <a-button type="primary" style="margin-bottom: 20px; margin-left: 20px"
                              v-if="addOuterrRemark && addInnerRemark" @click="external">外部
                            </a-button>
                            <a-button type="primary" style="margin-bottom: 20px; margin-left: 20px"
                              v-if="addOuterrRemark && !addInnerRemark" @click="external">
                              提交
                            </a-button>
                            <a-button type="primary" style="margin-left: 20px" @click="inside" v-if="addInnerRemark">内部
                            </a-button>
                          </a-col>
                        </a-row>
                      </a-col>
                    </a-row>
                  </a-form>
                </div>
              </a-col>
            </a-row>
            <!--包裹-->
            <div class="table-page-search-wrapper" style="margin-top:20px">
              <a-form layout="inline" :form="form">
                <a-row style="margin-left: 36px; margin: 0px">
                  <a-col :span="2"
                    style="display: flex; justify-content: flex-start; margin-left: 36px; margin-left: 20px">
                    <a-button @click="packageAdd()" icon="plus" type="primary" v-if="addPackage" style="margin: 20px 0">
                      新增包裹
                    </a-button>
                  </a-col>
                  <a-col :span="22"></a-col>
                </a-row>
                <a-table size="default" ref="table" :columns="columnspackage" :dataSource="this.reslist.transportList"
                  :pagination="false" bordered>
                  <span slot="action" slot-scope="text, record">
                    <a @click="packageEdit(record)" v-if="editPackage">编辑</a>
                    <a-divider type="vertical" v-if="deletePackage" />
                    <a-popconfirm title="是否要删除此行？" v-if="deletePackage" @confirm="removepackage(record.transportId)">
                      <a>删除</a>
                    </a-popconfirm>
                  </span>
                </a-table>
              </a-form>
            </div>
            <!--配件信息-->
            <div class="table-page-search-wrapper" v-if="reslist.needAccessories == 1">
              <a-form layout="inline" :form="form">
                <div class="orderKeyword" style="margin: 20px">
                  <label style="font-size: 24px; font-weight: bold">配件信息</label>
                </div>
                <a-row style="margin-left: 36px; margin: 0px">
                  <a-col :span="2"
                    style="display: flex; justify-content: flex-start; margin-left: 36px; margin-left: 20px">
                    <a-button v-if="addAccessory" @click="showbtn()" icon="plus" type="primary" style="margin: 20px 0">
                      新增配件
                    </a-button>
                  </a-col>
                  <a-col :span="22"></a-col>
                </a-row>

                <!--<a-table size="default" ref="table"  :columns="columnsAddaccessories"-->
                <!--:dataSource="this.reslist.accessoryList" :pagination="false"-->
                <!--v-if="accessoryBasic || accessoryPrice"-->
                <!--&gt;-->
                <a-table size="default" ref="table" :columns="columnsAddaccessories" :scroll="{ x: 1300 }"
                  :dataSource="this.reslist.accessoryList" :pagination="false" bordered>
                  <span slot="action" slot-scope="text, record">
                    <a v-if="editAccessory && record.accessoryStatus != 1" @click="handleEdit(record)">编辑</a>
                    <a-divider type="vertical" v-if="record.accessoryStatus == 3 && sendBackAccessory" />
                    <a v-if="record.accessoryStatus == 3 && sendBackAccessory" @click="partsReturn(record)">退回</a>
                    <a-divider type="vertical"
                      v-if="record.accessoryStatus != 2 && record.accessoryStatus != 1 && invalidAccessory" />
                    <a-popconfirm title="是否要作废配件？" @confirm="partsObsolete(record.orderAccessoryId)"
                      v-if="record.accessoryStatus != 2 && record.accessoryStatus != 1 && invalidAccessory">
                      <a>作废</a>
                    </a-popconfirm>
                  </span>
                  <span slot="transport" slot-scope="text, record">
                    <!--<a-popconfirm title="是否要查询物流信息？" @confirm="">-->
                    <a @click="gettransport(record.transportNumber, record.transportNo)">{{ record.transportNo }}</a>
                    <!--</a-popconfirm>-->
                  </span>
                </a-table>
              </a-form>
            </div>
            <!--安装信息-->
            <div class="table-page-search-wrapper" v-if="installInfoQuery">
              <a-form layout="inline" :form="form">
                <div class="orderKeyword" style="margin: 20px">
                  <label style="font-size: 24px; font-weight: bold">安装信息</label>
                </div>
                <a-row :class="[!addInstallInfo ? 'disEvents' : '']">
                  <a-col :span="6" v-for="(type, index) in reslist.installCustomize" :key="index"
                    v-show="((orderTypeName == '维修单' && type.infoName != '维修单故障原因' && type.infoName != '维修单维修方案' && type.infoName != '维修内容') || orderTypeName != '维修单')">
                    <a-form-item :label="type.infoName" :labelCol="labelCol" :wrapperCol="wrapperCol"
                      :required="type.isRequired == '0' ? true : false" style="margin-left: 15px">
                      <a-input v-if="type.infoType == 1" @change="changeinput(index, $event)"
                        v-model="type.infoValue" />
                      <a-select showSearch :getPopupContainer="getPopupContainer" style="width: 100%"
                        optionFilterProp="children" :filterOption="filterOption" :allowClear="true"
                        v-if="type.infoType == 3" v-model="type.infoValue">
                        <a-select-option v-for="tab in type.dictInfo" :key="tab.dictValue" :value="tab.dictValue">
                          {{ tab.dictLabel }}</a-select-option>
                      </a-select>
                      <a-select :getPopupContainer="getPopupContainer" style="width: 100%" :allowClear="true"
                        v-if="type.infoType == 0" v-model="type.infoValue">
                        <a-select-option v-for="tab in type.dictInfo" :key="tab.dictValue" :value="tab.dictValue">
                          {{ tab.dictLabel }}</a-select-option>
                      </a-select>
                      <a-select :getPopupContainer="getPopupContainer" style="width: 100%" :allowClear="true"
                        v-if="type.infoType == 2" v-model="type.infoValue">
                        <a-select-option v-for="tab in type.dictInfo" :key="tab.dictValue" :value="tab.dictValue">
                          {{ tab.dictLabel }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <div class="flex_l flex-top" v-if="reslist.ctei && reslist.orderTypeStr == '安装单'">
                  <div class="mr-50" v-if="reslist.guideSizePic && reslist.guideSizePic.length">
                    <div class="mb-20">导向片尺寸图片</div>
                    <div class="flex_l">
                      <img v-for="(item, i) in reslist.guideSizePic" :key="i"
                        @click="previewimgible = true; previewimgurl = imgUrl + item" :src="imgUrl + item" alt=""
                        style="height: 80px;width:80px;margin-right:20px" />
                    </div>
                  </div>
                  <div v-if="reslist.guideTypePic">
                    <div class="mb-20">导向片类型图片</div>
                    <img @click="previewimgible = true; previewimgurl = imgUrl + reslist.guideTypePic"
                      :src="imgUrl + reslist.guideTypePic" alt="" style="height: 80px;width:80px;margin-right:20px" />
                  </div>
                </div>
                <div class="flex_l flex-top" v-if="reslist.ctei && reslist.orderTypeStr == '维修单'">
                  <div class="mr-50">
                    <div class="mb-20">故障图片</div>
                    <div class="flex_l">
                      <img v-for="(item, i) in reslist.faultPic" :key="i"
                        @click="previewimgible = true; previewimgurl = imgUrl + item" :src="imgUrl + item" alt=""
                        style="height: 80px;width:80px;margin-right:20px" />
                    </div>
                  </div>
                  <div>
                    <div class="mb-20">故障视频</div>
                    <div class="flex_l">
                      <video v-for="(item, i) in reslist.faultVideo" :key="i" :src="imgUrl + item" controls
                        style="height: 80px;width:120px;margin-right:20px" />
                    </div>
                  </div>
                </div>
              </a-form>

              <a-row>
                <a-col :span="24">
                  <a-row style="padding: 30px">
                    <a-col :span="20" style="display: flex; margin-left: 11px">
                      <a-upload :multiple="true" name="file" list-type="picture-card" :file-list="orderClientPic"
                        class="avatar-uploader" :disabled="!addCustomerPic" :headers="headers" @preview="handlePreview"
                        :action="currencyuploadUrl" @change="picCurrencyhandleChange">
                        <span>
                          <a-icon type="upload" />
                          <div class="ant-upload-text">客户照片</div>
                        </span>
                      </a-upload>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-row style="padding: 30px">
                    <a-col :span="4" style="display: flex; margin-left: 11px">
                      <!-- 编辑页客户视频-->
                      <a-upload name="file" :multiple="true" list-type="picture" accept="video/*"
                        class="avatar-uploader" v-if="addCustomerPic" :showUploadList="false" :headers="headers"
                        :action="currencyuploadUrl" @change="videoCurrencyhandleChange">
                        <a-button>
                          <a-icon type="upload" /> 客户视频
                        </a-button>
                      </a-upload>
                    </a-col>
                    <div style="display: flex; flex-direction: row; width: 100%">
                      <div v-for="(item, i) in clientVideo">
                        <video class="video" :key="index"
                          :src="'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item" controls></video>
                        <a-icon v-if="addCustomerPic" type="delete" style="fontsize: 20px" class="img"
                          @click="handleSelect(i)" />
                      </div>
                    </div>
                  </a-row>
                </a-col>
              </a-row>
              </a-form>
            </div>
            <!--提交、挂起-->
            <a-row>
              <a-col :span="24">
                <a-affix style="position: fixed; bottom: 25px; left: 40%; z-index: 10">
                  <div style="width: 700px">
                    <!-- 周瀛 -->
                    <a-button style="margin-right: 50px; float: left" type="primary" @click="orderSave()">保存</a-button>
                    <a-button style="margin-right: 50px; float: left" type="primary" @click="orderSubmit()">提交
                    </a-button>
                    <a-button v-if="hodleOrderEditStuda == 0" :loading="hodleOrder2"
                      style="margin-right: 50px; float: left" type="primary" @click="hodleOrder()">挂起</a-button>
                    <a-button v-else style="margin-right: 50px; float: left" @click="hodleOrderEdit()">取消挂起</a-button>
                    <a-button type="primary" style="margin-right: 50px; float: left" @click="orderRefresh">刷新</a-button>
                    <a-button style="margin-right: 50px; float: left" @click="ordercancel">取消</a-button>
                  </div>
                </a-affix>
              </a-col>
            </a-row>
            <!--关联订单-->
            <div class="table-page-search-wrapper" v-if="associatedOrderQuery">
              <a-form layout="inline" :form="form">
                <div class="orderKeyword" style="margin: 20px">
                  <label style="font-size: 24px; font-weight: bold">关联订单</label>
                </div>
                <a-table :loading="editloading" size="default" ref="table" rowKey="orderId" :columns="columnsRelation"
                  :dataSource="this.relationList" bordered :pagination="false">
                  <span slot="action" slot-scope="text, record" v-if="addDasic">
                    <div v-if="orderType == '2' && editAssociatedOrder">
                      <a v-if="record.orderLevel != '主订单'" @click="orderMaster(record)">主订单</a>
                      <a-divider v-if="record.orderLevel != '主订单'" type="vertical" />
                      <a v-else @click="orderMaster(record)">关联</a>
                      <a v-if="record.orderLevel != '主订单'" @click="relation(record)">关联</a>
                    </div>
                    <div v-if="orderType == '1' && editAssociatedOrder">
                      <a @click="cancelOrderRelation(record)">取消</a>
                    </div>
                    <div v-if="orderType == '0' && editAssociatedOrder">
                      <a v-if="record.orderLevel != '子订单'" @click="relation(record)">关联</a>
                      <a v-if="record.orderLevel == '子订单'" @click="orderMaster(record)">主订单</a>
                      <a-divider v-if="record.orderLevel == '子订单'" type="vertical" />
                      <a v-if="record.orderLevel == '子订单'" @click="cancelOrderRelation(record)">取消</a>
                    </div>
                  </span>
                  <span slot="orderNo" slot-scope="text, record">
                    <a @click="showassociatedOrder(record.orderId)">{{ record.orderNo }}</a>
                  </span>
                </a-table>
              </a-form>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="金额信息" force-render :class="[editOrderShow == 0 ? 'disEvents' : '']" v-if="priceTab">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" :form="formmoney">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="订单号" style="margin-left: 60px">
                      <a-input v-decorator="['orderNo']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="安装类别" style="margin-left: 45px">
                      <a-input v-decorator="['installType']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="订单类型" style="margin-left: 45px">
                      <a-input v-decorator="['orderType']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="数量" style="margin-left: 75px">
                      <a-input v-decorator="['count']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="企业名称" style="margin-left: 45px">
                      <a-input v-decorator="['enterpriseName']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="企业负责人" style="margin-left: 30px">
                      <a-input v-decorator="['enterprisePrincipal']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="userType == '00'">
                    <a-form-item label="师傅名称" style="margin-left: 45px">
                      <a-input v-decorator="['workerName']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="userType == '00'">
                    <a-form-item label="联系方式" style="margin-left: 45px">
                      <a-input v-decorator="['workerPhone']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="企业订单总金额 " v-if="priceTabenterprise">
                      <a-input v-decorator="['enterpriseTotalAmmount']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="师傅订单总金额" v-if="priceTabmaster">
                      <a-input v-decorator="['masterTotalAmount']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="订单差额" v-if="priceTabmaster && priceTabenterprise" style="margin-left: 45px">
                      <a-input v-decorator="['differAmount']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="企业结算总金额" v-if="priceTabenterprise">
                      <a-input v-decorator="['enterpriseSettlementAount']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="师傅结算总金额 " v-if="priceTabmaster">
                      <a-input v-decorator="['masterSettlementAount']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="结算差额" v-if="priceTabmaster && priceTabenterprise" style="margin-left: 45px">
                      <a-input v-decorator="['settlementDifference']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <div style="background-color: #1890ff; margin: 20px">
                  <a-row style="padding: 0px">
                    <a-col :span="24" class="orderKeyword">
                      <span>金额要求</span>
                    </a-col>
                  </a-row>
                  <div>
                    <ul v-for="type in this.price_demand">
                      <li>
                        <span>{{ type.demandContent }}</span>
                        <span style="margin-left: 20px">{{ type.createTime }}</span>
                        <span style="margin-left: 20px">{{ type.createBy }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div style="margin: 20px" v-if="falg">
                  <a-row>
                    <a-col :span="24" style="display: flex">
                      <a-button type="primary" @click="moneyadd()">新增</a-button>
                    </a-col>
                  </a-row>
                </div>
                <div style="margin: 20px">
                  <a-row>
                    <a-col :span="20" style="display: flex"> </a-col>
                    <a-col :span="4" v-if="reviewedAmount" style="color: red; font-size: 19px">
                      金额待审核 !
                      <!---->
                    </a-col>
                    <a-col :span="4" v-if="reviewedtobeAmount" style="color: red; font-size: 19px">
                      金额待审核 !
                      <!---->
                    </a-col>
                  </a-row>
                </div>
                <div v-if="priceTabenterprise && changePriceList">
                  <div v-if="this.changePriceList.priceOwnerType == '1'"
                    style="text-align: center; font-size: 24px; font-weight: bold; margin: 20px">
                    企业金额
                  </div>
                  <div v-if="this.changePriceList.priceOwnerType == '2'"
                    style="text-align: center; font-size: 24px; font-weight: bold; margin: 20px">
                    客户自费金额
                  </div>
                  <a-table size="default" ref="table" :columns="columnsenterprise"
                    :dataSource="this.changePriceList.enterprisePrice" :form="form" :pagination="false" bordered>
                    <span v-if="falg" slot="action" slot-scope="text, record, index">
                      <a v-if="record.priceId" @click="submissionPrice(record, index, 'enterprise')">改价</a>
                      <a v-if="!record.priceId" @click="submissionPrice(record, index, 'enterprise')">修改</a>
                    </span>
                  </a-table>
                </div>
                <div v-if="priceTabmaster && changePriceList">
                  <div style="text-align: center; font-size: 24px; font-weight: bold; margin: 20px">师傅金额</div>
                  <a-table size="default" ref="table" :columns="columnsenterprise"
                    :dataSource="this.changePriceList.masterPrice" :form="form" :pagination="false" bordered>
                    <span v-if="falg" slot="action" slot-scope="text, record, index">
                      <a v-if="record.priceId && record.priceTypeName != '平台处罚'"
                        @click="submissionPrice(record, index, 'master')">改价</a>
                      <a v-if="!record.priceId" @click="submissionPrice(record, index, 'master')">修改</a>
                    </span>
                  </a-table>
                </div>
                <a-row>
                  <a-col :span="24" style="display: flex; justify-content: center">
                    <a-button type="primary" style="margin: 30px 0" @click="approved()" v-if="examinefalg">
                      审核通过</a-button>
                    <a-button type="primary" style="margin: 30px" @click="failedAudit()" v-if="examinefalg">审核未通过
                    </a-button>
                    <a-button type="primary" style="margin: 30px 0" @click="submissionAmount()"
                      v-if="newaddprice != -1 || masterpriceindex != -1 || enterpriceindex != -1">
                      提交</a-button>
                  </a-col>
                </a-row>
                <div v-if="priceTabrecord && changePriceList">
                  <div style="text-align: center; font-size: 24px; font-weight: bold; margin: 20px">金额记录</div>
                  <a-table size="default" ref="table" :columns="columnsrecord"
                    :dataSource="this.changePriceList.priceRecord" :form="form" :pagination="false" bordered>
                  </a-table>
                </div>

                <!--<a-row >-->
                <!--<a-col  :span="24" style="display: flex;justify-content: center;">-->
                <!---->

                <!--</a-col>-->
                <!--</a-row>-->
              </a-form>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="销单资料" :class="[editOrderShow == 0 ? 'disEvents' : '']" v-if="endInfoQuery">
            <div  style="display: flex;flex-direction: flex-start;padding: 10px;border-bottom:1px solid #ccc;">
              <span style="
                  width: 88px;
                  line-height: 30px;
                  margin-right: 15px;
                  color: rgba(0, 0, 0, 0.85);
                  font-size: 14px;
                ">序列号-扫码 :
              </span>
              <a-input v-if="reslist.foreignType == 6" v-model="serialNumber" @click="openYsSnSetting"
                style="cursor: pointer;width: 200px;" readonly autocomplete="off" placeholder="请输入序列号-扫码" />
              <a-input v-else v-model="serialNumber" style="width: 200px;" autocomplete="off" placeholder="请输入序列号-扫码" />
            </div>
            <div v-for="(type, index) in salepicList">
              <a-row style="padding: 30px;border-bottom:1px solid #ccc;"
                v-if="(!isYS && (type.infoPath || type.infoName == '安装后') || isYS)">
                <a-col :span="4">
                  <span style="padding: 15px">{{ type.infoName }}照片</span>
                  <div v-if="type.examplePicUrl" style="margin: 10px 0 10px 0;">
                    <div style="margin-bottom: 5px; color: #666; font-size: 12px;">示例图：</div>
                    <img :src="type.examplePicUrl" alt="example"
                      style="width: 104px; height: 104px; object-fit: cover; border-radius: 4px; border: 1px solid #d9d9d9; padding: 4px; cursor: pointer;"
                      @click="previewimg2(type.examplePicUrl)" />
                  </div>
                    <div style="margin-bottom: 5px; color: #666; font-size: 12px;">待上传：</div>
                  <a-upload :multiple="true" name="file" list-type="picture-card" :file-list="type.salepicfileList"
                    class="avatar-uploader" :headers="headers" :data="{ type: type.infoName }" :action="uploadUrl"
                    :before-upload="beforeUpload" @preview="handlePreview"
                    @change="salepichandleChange(type.infoName, type.infoPath, $event, index)" v-if="editEndInfo">
                    <!--<div v-if="fileList.length < 8">-->
                    <a-icon type="upload" />
                    <div class="ant-upload-text">上传照片</div>
                    <!--</div>-->
                  </a-upload>
                </a-col>
                <a-col :span="20">
                  <a-row>
                    <!--border: 1px solid #ccc;-->
                    <a-col :span="5" v-for="tab in type.dataInfoList"
                      style="height: 250px; margin-left: 30px; position: relative">
                      <p style="text-align: center">{{ tab.name }}</p>
                      <!--target="_blank"-->
                      <a href="#" onclick="return false;">
                        <a-icon type="eye" @click="previewimg(tab.url)"
                          style="
                                                                                                                                                                        width: 20px;
                                                                                                                                                                        height: 20px;
                                                                                                                                                                        position: absolute;
                                                                                                                                                                        right: 92px;
                                                                                                                                                                        top: 42px;
                                                                                                                                                                        font-size: 23px;
                                                                                                                                                                        color: #f7f7f7;
                                                                                                                                                                      " />
                        <a-icon type="check-circle" @click="disablesale(tab.uid, 0)"
                          v-if="tab.forbiddenStatus == 1 && editEndInfo"
                          style="
                                                                                                                                                                        width: 20px;
                                                                                                                                                                        height: 20px;
                                                                                                                                                                        position: absolute;
                                                                                                                                                                        right: 57px;
                                                                                                                                                                        top: 42px;
                                                                                                                                                                        font-size: 20px;
                                                                                                                                                                        color: #f7f7f7;
                                                                                                                                                                      " />
                        <a-icon type="stop" @click="disablesale(tab.uid, 1)"
                          v-if="tab.forbiddenStatus == 0 && editEndInfo"
                          style="
                                                                                                                                                                        width: 20px;
                                                                                                                                                                        height: 20px;
                                                                                                                                                                        position: absolute;
                                                                                                                                                                        right: 57px;
                                                                                                                                                                        top: 42px;
                                                                                                                                                                        font-size: 20px;
                                                                                                                                                                        color: #f7f7f7;
                                                                                                                                                                      " />
                        <a-icon type="delete" theme="filled" @click="deletesale('salepicList', tab.uid, tab.url)"
                          v-if="deleteEndInfo"
                          style="
                                                                                                                                                                        width: 20px;
                                                                                                                                                                        height: 20px;
                                                                                                                                                                        position: absolute;
                                                                                                                                                                        right: 25px;
                                                                                                                                                                        top: 42px;
                                                                                                                                                                        font-size: 20px;
                                                                                                                                                                        color: #f7f7f7;
                                                                                                                                                                      " />
                      </a>
                      <viewer style="width: 100%; height: 80%">
                        <img :src="process + '?fileName=' + tab.url + '&token=' + token"
                          style="margin-bottom: 20px; width: 90%; height: 70%" />
                      </viewer>
                      <!--<img-->
                      <!--src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png" style="margin-bottom: 20px;width:90%;height:70%;" class="img-thumbnail img-circle img-responsive" >-->
                      <div>{{ tab.createTime }}</div>
                      <div>{{ tab.createBy }}</div>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
            </div>
            <div v-for="(type, index) in salevideoList" v-if="!isYS">
              <a-row style="padding: 30px;border-bottom:1px solid #ccc;" v-if="type.infoPath || type.infoName == '安装后'"
                class="bb">
                <a-col :span="4">
                  <span style="padding: 15px">{{ type.infoName }}视频</span>
                  <a-upload name="file" :multiple="true" list-type="picture" accept="video/*" class="avatar-uploader"
                    :headers="headers" :data="{ type: type.infoName }" :action="uploadUrl" :showUploadList="false"
                    v-if="editEndInfo && type.infoName == '安装后'"
                    @change="salevideohandleChange(type.infoName, type.infoPath, $event)">
                    <a-button>
                      <a-icon type="upload" /> 上传视频
                    </a-button>
                  </a-upload>
                  <div style="display: flex; flex-direction: row; width: 100%">
                    <video style="width: 135px; margin: 10px; margin-left: 0px" v-for="item in type.clientVideo"
                      :key="index" :src="'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item" controls></video>
                  </div>
                </a-col>
                <!--销单资料-->

                <a-col :span="20">
                  <a-row>
                    <a-col :span="5" v-for="tab in type.dataInfoList" style="height: 250px; margin-left: 30px">
                      <p style="text-align: center">{{ tab.name }}</p>
                      <a href="#" onclick="return false;">
                        <a-icon type="check-circle" @click="disablesale(tab.uid, 0)"
                          v-if="tab.forbiddenStatus == 1 && editEndInfo"
                          style="
                                                                                                                                                                        width: 20px;
                                                                                                                                                                        height: 20px;
                                                                                                                                                                        position: absolute;
                                                                                                                                                                        right: 50px;
                                                                                                                                                                        top: 42px;
                                                                                                                                                                        font-size: 20px;
                                                                                                                                                                        color: #ccc;
                                                                                                                                                                        z-index: 500;
                                                                                                                                                                      " />
                        <a-icon type="stop" @click="disablesale(tab.uid, 1)"
                          v-if="tab.forbiddenStatus == 0 && editEndInfo"
                          style="
                                                                                                                                                                        width: 20px;
                                                                                                                                                                        height: 20px;
                                                                                                                                                                        position: absolute;
                                                                                                                                                                        right: 50px;
                                                                                                                                                                        top: 42px;
                                                                                                                                                                        font-size: 20px;
                                                                                                                                                                        color: #ccc;
                                                                                                                                                                        z-index: 500;
                                                                                                                                                                      " />
                        <a-icon type="delete" theme="filled" @click="deletesale('salevideoList', tab.uid, tab.url)"
                          style="
                                                                                                                                                                        width: 20px;
                                                                                                                                                                        height: 20px;
                                                                                                                                                                        position: absolute;
                                                                                                                                                                        right: 15px;
                                                                                                                                                                        top: 42px;
                                                                                                                                                                        font-size: 20px;
                                                                                                                                                                        color: #ccc;
                                                                                                                                                                        z-index: 500;
                                                                                                                                                                      "
                          v-if="deleteEndInfo" />
                      </a>
                      <video :src="process + '?fileName=' + tab.url + '&token=' + token" style="margin-bottom: 20px"
                        width="100%" height="70%" controls></video>
                      <div>{{ tab.createTime }}</div>
                      <div>{{ tab.createBy }}</div>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
            </div>
            <!-- 旧件返厂 -->
            <!--
              订单中是否选中 旧件返厂 （录入&修改）factoryStatus 1是0否
              三字段非必填，其中一个填 其他必须填（照片至少一张 最多三张）
              只有海尔显示 返厂资料 factoryEnterpriseType 旧件返厂企业类型（0：海尔、1：其他）
              -->
            <div v-if="this.factoryStatus">
              <div class="title mt-10 mb-10" style="font-weight:700;">旧件返厂</div>
              <span class="mb-10 mr-10">物流单号</span>
              <a-input @blur="handleCourierNumber" style="width:40%" v-model="logisticsInfo.courierNumber" />
              <div class="mt-10">
                <span class="mb-10 mr-10">快递公司</span>
                <a-input disabled style="width:40%" v-model="logisticsInfo.courierServicesCompany" />
              </div>
              <!-- :before-upload="pictureCardBeforeUpload"  -->
              <div class="mt-10 mb-10">单号照片</div>
              <a-col :span="24" class="mtb-10">
                <a-upload :action="currencyuploadUrl" listType="picture-card" :fileList="courierImgArr"
                  :headers="headers" @preview="handlePreview" @change="changeCourierImg">
                  <div v-if="courierImgArr.length < 3">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传图片</div>
                  </div>
                </a-upload>
              </a-col>
              <div class="mt-10 mb-10" v-if="this.reslist.factoryEnterpriseType == 0">返厂资料</div>
              <a-col :span="24" class="mtb-10" v-if="this.reslist.factoryEnterpriseType == 0">
                <a-upload :multiple="true" name="file" list-type="picture-card" :headers="headers"
                  @change="changeFactoryImg" :fileList="factoryImgArr" accept="image/*" :action="currencyuploadUrl"
                  @preview="handlePreview">

                  <div v-if="factoryImgArr.length < 3">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传图片</div>
                  </div>

                </a-upload>
              </a-col>
            </div>

            <!-- 客户确认图片 -->
            <div class="mt-30" v-if="reslist.detectContent">
              <div class="title mb-20" style="font-weight:700;">客户确认图片</div>
              <!-- 萤石-若无客户确认图片，则上传 -->
              <div v-if="reslist.foreignType == 6">
                <div v-if="!reslist.detectContent.acceptanceUrl">
                  <a-button type="primary" class="mb-10" @click="signatureSubmit" :disabled="!signatureShow">
                    提交签字图片
                  </a-button>
                  <a-upload name="file" list-type="picture-card" :fileList="signatureFileList" class="avatar-uploader"
                    :headers="headers" :data="{ type: 6 }" :action="uploadSignUrl" :before-upload="beforeUpload"
                    @preview="handlePreview" @change="signatureChange($event, index)">
                    <div v-if="signatureFileList.length < 1">
                      <a-icon type="upload" />
                      <div class="ant-upload-text">上传照片</div>
                    </div>
                  </a-upload>
                </div>
              </div>
              <div class="flex_l mb-20">
                <img v-if="reslist.detectContent && reslist.detectContent.signatureUrl"
                  style="border:1px solid #ccc;width:370px;height:180px;margin-right:30px"
                  :src="imgUrl + reslist.detectContent.signatureUrl" alt="" />
                <img v-if="reslist.detectContent && reslist.detectContent.acceptanceUrl"
                  style="border:1px solid #ccc;width:370px;height:180px"
                  :src="imgUrl + reslist.detectContent.acceptanceUrl" alt="" />
              </div>
              <a-button v-if="reslist.detectContent &&
                reslist.detectContent.resultList &&
                reslist.detectContent.resultList.length > 0
              " @click="showYanshou(1)" type="primary" class="mr-30">安装前检测单</a-button>
              <a-button v-if="reslist.detectContent &&
                reslist.detectContent.acceptanceList &&
                reslist.detectContent.acceptanceList.length > 0
              " @click="showYanshou(2)" type="primary">验收单</a-button>
              <yanshoudan ref="yanshou"></yanshoudan>
            </div>
            <a-row style="margin: 20px">
              <a-col :span="24" style="display: flex; justify-content: center">
                <a-form-item>
                  <a-button style="background-color: #6dbcff; color: white" @click="saleDataSave()"
                    :disabled="!editEndInfo">
                    提交
                  </a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane v-if="(masterStatus && store.getters.userType != '22') || heXiaoValue" key="4" tab="核销信息"
            :class="[editOrderShow == 0 ? 'disEvents' : '']">
            <a-form :form="formWriteon" v-if="examStatus == 0">
              <div style="padding: 10px" v-for="(item, index) in examData1" v-if="item.isRelation == 1" :key="index">
                <a-form-item>
                  <!--判断 没有关联关系的显示-->
                  <div style="padding: 10px">
                    <span v-if="item.isReply == 1" style="color: red; margin-right: 5px">*</span>
                    <span>{{ item.sort }}. </span>
                    <span
                      style="
                                                                                                                                                                    background-color: #1890ff;
                                                                                                                                                                    color: #fff;
                                                                                                                                                                    margin: 0 10px;
                                                                                                                                                                    padding: 2px 10px;
                                                                                                                                                                    border-radius: 6px;
                                                                                                                                                                  ">{{
                                                                                                                                                                    item.subjectType
                                                                                                                                                                  }}</span>
                    <span> {{ item.subjectName }}</span>
                  </div>
                  <div style="margin-left: 95px; padding: 0 15px" class="test">
                    <!--单选-->
                    <div v-if="item.subjectType == '单选题'">
                      <a-radio-group
                        v-decorator="['value' + item.sort, { rules: [{ required: true, message: '请选择' }] }]"
                        :required="false" @change="onChange(index, $event)" v-if="item.isReply == 1">
                        <a-radio v-for="int in item.optionList" :value="int.optionName" :key="int.optionId"
                          style="margin-right: 30px">
                          {{ int.optionName }}
                        </a-radio>
                      </a-radio-group>
                      <a-radio-group v-decorator="['value' + item.sort]" :required="false"
                        @change="onChange(index, $event)" v-else>
                        <a-radio v-for="int in item.optionList" :value="int.optionName" :key="int.optionId"
                          style="margin-right: 30px">
                          {{ int.optionName }}
                        </a-radio>
                      </a-radio-group>
                    </div>
                    <!--评分-->
                    <div v-else-if="item.subjectType == '选择星级'">
                      <a-rate v-decorator="[
                        'value' + item.sort,
                        { rules: [{ required: true, message: '请选择' }], initialValue: 5 }
                      ]" v-if="item.isReply == 1" />
                      <a-rate v-decorator="['value' + item.sort, { initialValue: 5 }]" v-else />
                    </div>
                    <!--多选-->
                    <div v-else-if="item.subjectType == '多选题'">
                      <a-checkbox-group
                        v-decorator="['value' + item.sort, { rules: [{ required: true, message: '请选择' }] }]"
                        @change="handleCheck(index, $event)" v-if="item.isReply == 1">
                        <a-checkbox v-for="type in item.optionList" :key="type.optionId" :value="type.optionName">
                          {{ type.optionName }}
                        </a-checkbox>
                      </a-checkbox-group>
                      <a-checkbox-group v-decorator="['value' + item.sort]" @change="handleCheck(index, $event)" v-else>
                        <a-checkbox v-for="type in item.optionList" :key="type.optionId" :value="type.optionName">
                          {{ type.optionName }}
                        </a-checkbox>
                      </a-checkbox-group>
                    </div>
                    <!--下拉框-->
                    <div v-else-if="item.subjectType == '下拉框'">
                      <a-select v-decorator="['value' + item.sort, { rules: [{ required: true, message: '请输入' }] }]"
                        v-if="item.isReply == 1" @change="handleExamSelect(index, $event)">
                        <a-select-option v-for="type in item.optionList" :key="type.optionName"
                          :value="type.optionName">{{ type.optionName }}</a-select-option>
                      </a-select>
                      <a-select v-decorator="['value' + item.sort]" v-else @change="handleExamSelect(index, $event)">
                        <a-select-option v-for="type in item.optionList" :key="type.optionName"
                          :value="type.optionName">{{ type.optionName }}</a-select-option>
                      </a-select>
                    </div>
                    <!--输入框-->
                    <div v-else-if="item.subjectType == '单项填空题'">
                      <a-input v-decorator="['value' + item.sort, { rules: [{ required: true, message: '请输入' }] }]"
                        v-if="item.isReply == 1"></a-input>
                      <a-input v-decorator="['value' + item.sort]" v-else></a-input>
                    </div>
                  </div>
                </a-form-item>
                <a-divider dashed />
              </div>
              <div style="width: 100%; display: flex; justify-content: center">
                <a-button type="primary" @click="handleExamOn">提 交</a-button>
              </div>
            </a-form>
            <a-form :form="formWriteoff" v-else-if="examStatus == 1">
              <div style="padding: 10px" v-for="(item, index) in examDataList" :key="index">
                <a-form-item>
                  <!--判断 没有关联关系的显示-->
                  <div style="padding: 10px">
                    <strong> {{ item.subjectName }}</strong>
                  </div>
                  <div style="margin-left: 95px; padding: 0 15px" class="test">
                    <span v-for="key in item.optionList" style="margin-right: 40px">
                      <span v-if="item.subjectType == 4">
                        <a-rate v-model="key.optionName" disabled />
                      </span>
                      <span v-else>{{ key.optionName }}</span>
                    </span>
                  </div>
                </a-form-item>
                <a-divider dashed />
              </div>
              <a-button type="primary" style="margin-left: 46%" @click="handleCancel"> 重新核销 </a-button>
            </a-form>
          </a-tab-pane>
          <a-tab-pane key="5" tab="问题反馈" :class="[editOrderShow == 0 ? 'disEvents' : '']" v-if="problem">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" :form="formfeedback">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="订单号" style="margin-left: 45px">
                      <a-input v-decorator="['orderNo']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="安装类别" style="margin-left: 30px">
                      <a-input v-decorator="['installType']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="订单类型" style="margin-left: 30px">
                      <a-input v-decorator="['orderType']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="数量" style="margin-left: 60px">
                      <a-input v-decorator="['quantity']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="客户姓名" style="margin-left: 30px">
                      <a-input v-decorator="['clientName']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="客户联系方式">
                      <a-input v-decorator="['clientPhone']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="userType == '00'">
                    <a-form-item label="师傅姓名" style="margin-left: 30px">
                      <a-input v-decorator="['masterName']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="userType == '00'">
                    <a-form-item label="师傅联系方式">
                      <a-input v-decorator="['masterPhone']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-table size="default" ref="table" :columns="columnfeedback"
                  :dataSource="this.feedbacklist.feedbackList" :pagination="false" :scroll="{ x: 1600 }" bordered
                  style="margin-top: 30px">
                  <span slot="action" slot-scope="text, record">
                    <a @click="problemsDealing(record)"
                      v-if="record.handlingStatus != '结束' && !(record.handlingStatus == '撤单')">处理</a>
                    <a-divider type="vertical" v-if="!(record.handlingStatus == '撤单')" />
                    <a v-if="!(record.handlingStatus == '撤单')" @click="revoke(record)">撤回</a>
                    <a-divider type="vertical" v-if="!(record.handlingStatus == '撤单')" />
                    <a v-if="!(record.handlingStatus == '撤单')" @click="problemsTransfer(record)">转派</a>
                    <a-divider type="vertical" v-if="!(record.handlingStatus == '撤单')" />
                    <a @click="resume(record)">履历</a>
                  </span>
                </a-table>
              </a-form>
            </div>
          </a-tab-pane>
          <a-tab-pane key="6" tab="投诉" :class="[editOrderShow == 0 ? 'disEvents' : '']">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" :form="formcomplaint">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="订单号" style="margin-left: 45px">
                      <a-input v-decorator="['orderNo']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="安装类别" style="margin-left: 30px">
                      <a-input v-decorator="['installType']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="订单类型" style="margin-left: 30px">
                      <a-input v-decorator="['orderType']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="数量" style="margin-left: 60px">
                      <a-input v-decorator="['quantity']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="客户姓名" style="margin-left: 30px">
                      <a-input v-decorator="['clientName']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="客户联系方式">
                      <a-input v-decorator="['clientPhone']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="userType == '00'">
                    <a-form-item label="师傅姓名" style="margin-left: 30px">
                      <a-input v-decorator="['masterName']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24" v-if="userType == '00'">
                    <a-form-item label="师傅联系方式">
                      <a-input v-decorator="['masterPhone']" disabled="disabled" />
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-table size="default" ref="table" :columns="columncomplaints"
                  :dataSource="this.complaintslist.complaints" :pagination="false" :scroll="{ x: 1600 }" bordered
                  style="margin-top: 30px">
                  <span slot="action" slot-scope="text, record">
                    <a @click="complaintDealing(record)"
                      v-if="record.handlingStatus != '结束' && !(record.handlingStatus == '撤单')">处理</a>
                    <a-divider type="vertical"
                      v-if="record.handlingStatus != '结束' && !(record.handlingStatus == '撤单')" />
                    <a v-if="!(record.handlingStatus == '撤单')" @click="complaintrevoke(record)">撤回</a>
                    <a-divider type="vertical" v-if="!(record.handlingStatus == '撤单')" />
                    <a @click="complaintTransfer(record)" v-if="!(record.handlingStatus == '撤单')">转派</a>
                    <a-divider type="vertical" v-if="!(record.handlingStatus == '撤单')" />
                    <a @click="complaintresume(record)">履历</a>
                  </span>
                </a-table>
              </a-form>
            </div>
          </a-tab-pane>
          <a-tab-pane key="7" tab="订单履历" v-if="orderRecord">
            <!--<order-resume :orderId="orderId"></order-resume>-->
            <div class="table-page-search-wrapper">
              <a-form layout="inline" :form="form7">
                <a-row :gutter="16">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select v-model="queryParam9.orderStatus" :allowClear="true">
                        <a-select-option v-for="type in order_status" :key="type.dictValue">{{
                          type.dictLabel
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label="订单模块" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="queryParam9.module" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label="操作类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="queryParam9.operateType" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label="操作人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="queryParam9.operateBy" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label="操作时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-range-picker style="width: 100%" v-model="queryParam9.time" format="YYYY-MM-DD"
                        @change="onChange3" @ok="onOk" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="4" :offset="14" style="text-align: right">
                    <a-button type="primary" style="margin-right: 10px" @click="handleSelect9">查询</a-button>
                    <a-button @click="queryParam9 = {}">清空</a-button>
                  </a-col>
                </a-row>
              </a-form>
              <a-button @click="empty(record)" v-if="callRecord">师傅联系记录</a-button>
            </div>
            <s-table size="default" ref="table9" :loading="loading9" :columns="columns9" :data="loadData9"
              style="margin-top: 25px" bordered :scroll="{ x: '300' }">
              <span slot="action9" slot-scope="text, record">
                <div style="max-height: 150px; overflow-x: auto">
                  <span v-if="record.dataType == 0">{{ text }}</span>

                  <div v-else-if="record.dataType == 1" v-for="(item, index) in JSON.parse(text)">
                    <!--<p v-if="JSON.parse(text).length==1">-->
                    <!--【{{item.label}}】新增1:<span style="color:red">{{item.newValue}}</span>-->
                    <!--</p>-->
                    <p v-if="item.newValue && item.oldValue">
                      <span v-if="JSON.parse(text).length > 1">{{ index + 1 }}.</span>
                      <span>
                        【{{ item.label }}】修改前:<span>{{ item.oldValue }}</span> 修改后:<span style="color: red">{{
                          item.newValue
                        }}</span>
                      </span>
                    </p>
                    <p v-else-if="item.newValue">
                      <span v-if="JSON.parse(text).length > 1">{{ index + 1 }}.</span>
                      <span>
                        【{{ item.label }}】新增:<span style="color: red">{{ item.newValue }}</span>
                      </span>
                    </p>
                    <p v-else-if="item.oldValue">
                      <span v-if="JSON.parse(text).length > 1">{{ index + 1 }}.</span>
                      <span>
                        【{{ item.label }}】删除:<span>{{ item.oldValue }}</span>
                      </span>
                    </p>
                  </div>
                </div>
              </span>
            </s-table>
          </a-tab-pane>
          <!-- <a-tab-pane key="8" tab="客户反馈">
            <kehu-result ref="kehu"></kehu-result>
          </a-tab-pane> -->
          <a-tab-pane key="9" tab="客服反馈">
            <kefu-result ref="kefu"></kefu-result>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
      <!-- 2.3右下角固定定位悬浮窗 -->
      <div :class="[editOrderShow == 0 ? 'disEvents' : '']">
        <a-affix class="scroll" style="position: fixed; right: 5%; bottom: 10px; z-index: 10">
          <div v-if="enterpriseDemandList && enterpriseDemand">
            <a-badge :count="enterpriseDemandList.countOfAll" :number-style="{ backgroundColor: '#000' }"
              v-if="enterpriseDemandList.countOfNew == 0">
              <a-button
                style="
                                                                                                                                                              margin-bottom: 8px;
                                                                                                                                                              width: 110px;
                                                                                                                                                              height: 46px;
                                                                                                                                                              text-align: center;
                                                                                                                                                              background-color: white;
                                                                                                                                                              box-shadow: gainsboro 0px 0px 2px 3px;
                                                                                                                                                            "
                @click="requirementsEnterprise">
                <img src="../../../../public/images/requirements.png" alt="" style="width: 28px; height: 28px" />
                <span style="margin-left: 5px">企业要求</span>
              </a-button>
            </a-badge>
            <a-badge :count="enterpriseDemandList.countOfAll" v-else>
              <a-button
                style="
                                                                                                                                                              margin-bottom: 8px;
                                                                                                                                                              width: 110px;
                                                                                                                                                              height: 46px;
                                                                                                                                                              text-align: center;
                                                                                                                                                              background-color: white;
                                                                                                                                                              box-shadow: gainsboro 0px 0px 2px 3px;
                                                                                                                                                            "
                @click="requirementsEnterprise">
                <img src="../../../../public/images/requirements.png" alt="" style="width: 28px; height: 28px" />
                <span style="margin-left: 5px">企业要求</span>
              </a-button>
            </a-badge>
          </div>
          <!--  客服反馈-->
          <!-- 销毁重建组件 使用v-if -->
          <commontMaster @close="showCommont = false" ref="commont" v-if="showCommont"></commontMaster>
          <div v-if="feedback">
            <a-button
              style="
                                                                                                                                                            margin-bottom: 10px;
                                                                                                                                                            width: 110px;
                                                                                                                                                            height: 46px;
                                                                                                                                                            text-align: center;
                                                                                                                                                            background-color: white;
                                                                                                                                                            box-shadow: gainsboro 0px 0px 2px 3px;
                                                                                                                                                            cursor: pointer;
                                                                                                                                                          "
              @click="toCommon">
              <img src="../../../../public/images/kefu.png" alt="" style="width: 28px; height: 28px" />
              <span style="margin-left: 5px">客服反馈</span>
            </a-button>
          </div>

          <a-button @click="problemInitiate" v-if="createProblem"
            style="
                                                                                                                                                          margin-bottom: 8px;
                                                                                                                                                          width: 110px;
                                                                                                                                                          height: 46px;
                                                                                                                                                          text-align: center;
                                                                                                                                                          background-color: white;
                                                                                                                                                          box-shadow: gainsboro 0px 0px 2px 3px;
                                                                                                                                                        ">
            <img src="../../../../public/images/initiate.png" alt=""
              style="width: 28px; height: 28px; margin-left: -18px" />
            <span style="margin-left: 5px">发起</span>
          </a-button>

          <div>
            <a-button
              style="
                                                                                                                                                            margin-bottom: 20px;
                                                                                                                                                            width: 110px;
                                                                                                                                                            height: 46px;
                                                                                                                                                            text-align: center;
                                                                                                                                                            background-color: white;
                                                                                                                                                            box-shadow: gainsboro 0px 0px 2px 3px;
                                                                                                                                                            cursor: pointer;
                                                                                                                                                          "
              @click="toTop(step)">
              <img src="../../../../public/images/toTop.png" alt="" style="width: 28px; height: 28px" />
              <span style="margin-left: 5px">回到顶部</span>
            </a-button>
          </div>

          <!--<a-button @click="problemInitiate" v-if="createProblem"-->
          <!--style="width: 110px;height: 70px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;">-->
          <!--<i class="iconfont ions">&#xe651;</i>-->
          <!--<p>培训资料</p>-->
          <!--</a-button>-->
          <!--<a-button-->
          <!--style="margin-bottom: 20px;width: 110px;height: 70px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;">-->
          <!--<i class="iconfont ions">&#xe6b3;</i>-->
          <!--<p>知识库</p>-->
          <!--</a-button>-->
        </a-affix>
      </div>
    </a-card>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewhandleCancel">
      <img alt="example" style="width: 100%; padding: 10px" :src="previewImage" />
    </a-modal>
    <a-modal :visible="previewimgible" :footer="null" @cancel="previewimghandleCancel">
      <viewer>
        <img alt="example" style="width: 100%; padding: 10px" :src="previewimgurl" />
      </viewer>
    </a-modal>
    <!--    //添加配件里面的modal-->
    <!--:confirm-loading="accessoriesLoading"-->
    <a-modal v-model="disable" @ok="addAccessories()" @cancel="cancelAccessories" title="配件" :width="1200">
      <a-form :form="formaccessories">
        <a-row>
          <a-col :span="12">
            <a-form-item style="display: none">
              <a-input v-decorator="['transportId']" />
            </a-form-item>
            <a-form-item style="display: none">
              <a-input v-decorator="['orderAccessoryId']" />
            </a-form-item>
            <a-form-item v-if="!nameible" label="配件信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select @change="accessoryChange"
                v-decorator="['accessoryId', { rules: [{ required: true, message: '选择配件信息!' }] }]" :allowClear="true">
                <a-select-option v-for="type in EnterpriseAccessory" :key="type.accessoryId">
                  {{ type.accessoryName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="nameible" label="配件信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled="disabled"
                v-decorator="['accessoryName', { rules: [{ required: true, message: '填写配件信息!' }] }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业配件单价">
              <a-input disabled="disabled"
                v-decorator="['price', { rules: [{ required: true, message: '填写企业配件单价!' }] }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅配件单价">
              <a-input disabled="disabled"
                v-decorator="['masterPrice', { rules: [{ required: true, message: '填写师傅配件单价!' }] }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
              <a-input-number style="width: 100%" min="1" precision="0.1" :formatter="numberRep" :parser="numberRep"
                v-decorator="['accessoryNum', { rules: [{ required: true, message: '填写数量!' }], initialValue: 1 }]"
                @change="accessoryNumChange" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业配件总金额">
              <a-input disabled="disabled"
                v-decorator="['totalAmount', { rules: [{ required: true, message: '企业配件总金额!' }] }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅配件总金额">
              <a-input disabled="disabled"
                v-decorator="['masterTotalAmount', { rules: [{ required: true, message: '师傅配件总金额!' }] }]" />
            </a-form-item>
            <a-form-item v-if="!nameible" :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货仓库">
              <a-select v-decorator="['repositoryId', { rules: [{ required: true, message: '选择发货仓库!' }] }]"
                :allowClear="true" @change="storeChange">
                <a-select-option v-for="type in queryEnterpriseStock" :key="type.storeId" :value="type.storeId">
                  {{ type.storeName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="nameible" label="发货仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled="disabled"
                v-decorator="['repositoryName', { rules: [{ required: true, message: '填写发货仓库!' }] }]" />
            </a-form-item>
            <a-form-item style="display: none">
              <a-input v-decorator="['repositoryType']" />
            </a-form-item>
            <a-divider orientation="left"></a-divider>
            <a-checkbox :labelCol="labelCol" :wrapperCol="wrapperCol" :checked="showh" @change="onChangeinfo">物流信息
            </a-checkbox>
          </a-col>
        </a-row>
        <a-row v-if="showh">
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
              <a-date-picker v-model="time_list" style="width: 100%" @change="onChangeT" format="YYYY-MM-DD" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
              <a-select v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]"
                :allowClear="true">
                <a-select-option v-for="type in delivery_company" :key="type.dictValue">{{ type.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
              <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货人">
              <a-input v-decorator="['sendUser']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货人">
              <a-input v-decorator="['receiveUser']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input v-decorator="['transportRemark']" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--:confirm-loading="packageLoading"-->
    <a-modal v-model="packageable" @ok="addpackage()" title="包裹">
      <a-form :form="formpackage">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-decorator="['transportId']" />
            </a-form-item>
            <a-form-item label="包裹名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['transportName', { rules: [{ required: true, message: '请输入包裹名称!' }] }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
              <a-select v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]"
                :allowClear="true">
                <a-select-option v-for="type in delivery_company" :key="type.dictValue">{{ type.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
              <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '请输入快递单号!' }] }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="包裹备注">
              <a-input v-decorator="['remark']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="">
              <a-checkbox @change="checkboxchange"
                v-decorator="['isMainbool', { valuePropName: 'checked', initialValue: true }]">
                重要</a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--:confirm-loading="orderRemarkbleLoading"-->
    <a-modal v-model="orderRemarkble" @ok="addremark()" title="修改备注" :width="800">
      <a-form :form="form">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-model="orderRemarkmodal.orderRemarkId" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注内容">
              <a-textarea v-model.trim="orderRemarkmodal.remarkInfo" :rows="8" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--:confirm-loading="AddorderRemarkbleLoading"-->
    <a-modal v-model="orderremarkAdditionalible" @ok="remarkAdditional()" title="追加备注" :width="800">
      <a-form :form="additionalform">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-decorator="['orderRemarkId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="追加备注内容">
              <a-input v-model.trim="appendInfo" />
              <!--<a-input v-decorator="['appendInfo', { rules: [{ required: true, message: '请输入追加内容!' }]}]"/>-->
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal v-model="transportble" :footer="null" title="快递物流信息">
      <a-form :form="form" v-if="transportInfo">
        <a-steps progress-dot :current="transportInfo.length" direction="vertical" style="width: 100%">
          <a-step v-for="(type, index) in transportInfo" :key="index" :title="type.ftime" :description="type.context"
            style="width: 100%" />
        </a-steps>
      </a-form>
    </a-modal>
    <a-modal title="填写不完整提醒" style="top: 20px" v-model="incompleteible" @ok="incompleteOk" @cancel="confirmCancel">
      <div style="text-align: center">
        <a-icon type="close-circle" style="font-size: 50px; color: #cf1322; margin: 20px" />
      </div>
      <p style="text-align: center; font-size: 24px">信息填写不完整，请填写完整后保存</p>
    </a-modal>
    <!--:confirmLoading="addmoneymodelLoading"-->
    <a-modal v-model="moneyaddible" @ok="addmoneymodel()" title="新增" :width="1200" :height="1100"
      style="margin-bottom: 10px">
      <a-form :form="formmoneymodal">
        <a-row>
          <a-col :span="12">
            <a-form-item label="金额类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 10px">
              <a-select @change="priceTypeChange"
                v-decorator="['priceType', { rules: [{ required: true, message: '请输入金额类型!' }] }]" :allowClear="true">
                <a-select-option v-for="type in basicPricelist" :key="type.priceType">
                  {{ type.label }}
                </a-select-option>
              </a-select>
              <div v-if="chooseReason">
                <a-checkbox v-model:checked="isSelected">开箱不良</a-checkbox>
              </div>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业原单价金额" style="margin-bottom: 10px">
              <a-input disabled="disabled" v-decorator="['enterpriseOriginalPrice']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业修改金额" style="margin-bottom: 10px">
              <a-input-number style="width: 100%" v-decorator="[
                'enterpriseModified',
                { rules: [{ required: true, message: '请输入企业修改金额!' }], initialValue: 0 }
              ]" @change="enterpriseModify" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量" style="margin-bottom: 10px">
              <a-input-number @change="moneyAmountModify" style="width: 100%"
                v-decorator="['amount', { rules: [{ required: true, message: '请输入数量!' }], initialValue: 1 }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业原总金额" style="margin-bottom: 10px">
              <a-input disabled="disabled" v-decorator="['enterpriseOriginalTotal']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业总金额" style="margin-bottom: 10px">
              <a-input disabled="disabled" v-decorator="['enterpriseNewTotal']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col style="margin-left: -154px">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业金额备注" style="margin-bottom: 10px">
              <a-input v-decorator="['enterpriseRemark']" type="textarea" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅原单价金额" style="margin-bottom: 10px">
              <a-input disabled="disabled" v-decorator="['masterOriginalPrice']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅修改金额" style="margin-bottom: 10px">
              <a-input-number style="width: 100%" v-decorator="[
                'masterModified',
                { rules: [{ required: true, message: '请输入师傅修改金额!' }], initialValue: 0 }
              ]" @change="masterModify" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅原总金额" style="margin-bottom: 10px">
              <a-input disabled="disabled" v-decorator="['masterOriginalTotal']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅总金额" style="margin-bottom: 10px">
              <a-input disabled="disabled" v-decorator="['masterNewTotal']" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col style="margin-left: -154px">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="师傅金额备注" style="margin-bottom: 10px">
              <a-input v-decorator="['masterRemark']" type="textarea" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--:confirmLoading="modifiedamountLoading"-->
    <a-modal v-model="submissionPriceible" @ok="modifiedamount()" :width="600" title="改价">
      <div v-if="changprice != 3">
        <h3>企业金额</h3>
        <a-form :form="modifiedamountmodel">
          <a-row>
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="现总金额" style="margin-bottom: 10px">
                <a-input-number v-decorator="['newTotal']" @change="amountModify" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item label="修改金额" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 10px">
                <a-input disabled="disabled" v-decorator="['modifiedPrice']" style="width: 366px" />
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="金额类型" style="margin-bottom: 10px">
                <a-input disabled="disabled" v-decorator="['priceTypeName']" />
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="金额备注" style="margin-bottom: 10px">
                <a-input v-decorator="['priceRemark']" type="textarea" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-divider v-if="changprice == 1" />
      <div v-if="changprice != 2">
        <h3>师傅金额</h3>
        <a-form :form="masteramountmodel">
          <a-row>
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="现总金额" style="margin-bottom: 10px">
                <a-input-number v-decorator="['newTotal', { rules: [{ validator: handleNewTotal }] }]"
                  @change="masteramountModify" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item label="修改金额" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom: 10px">
                <a-input disabled="disabled" v-decorator="['modifiedPrice']" style="width: 366px" />
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="金额类型" style="margin-bottom: 10px">
                <a-input disabled="disabled" v-decorator="['priceTypeName']" />
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="金额备注" style="margin-bottom: 10px">
                <a-input v-decorator="['priceRemark']" type="textarea" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
    <!--:confirmLoading="addproblemLoading"-->
    <a-modal v-model="problemible" @ok="addproblem()" title="问题反馈/投诉" :width="600">
      <a-form :form="problemform">
        <a-row>
          <a-col>
            <a-form-item style="display: none">
              <a-input v-decorator="['orderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="当前订单号">
              <a-input v-decorator="['orderNo']" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题反馈/投诉">
              <a-radio-group @change="onChangeradio">
                <a-radio :value="1"> 问题反馈 </a-radio>
                <a-radio :value="2"> 投诉 </a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人">
              <a-input v-decorator="['handler']" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉类型" v-if="value == 2">
              <a-select v-decorator="[
                'matterCode',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择投诉类型!'
                    }
                  ]
                }
              ]" @change="onChangecomplaint" :allowClear="true">
                <a-select-option v-for="type in complaintAuthority" :key="type.matterCode">{{ type.matterName }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉对象" v-if="value == 2">
              <a-select v-decorator="[
                'complaintObject',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择投诉对象!'
                    }
                  ]
                }
              ]" v-if="complaintObject" :allowClear="true" @change="handChange">
                <a-select-option v-for="type in complaintObject" :key="type.code">{{ type.name }} </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="被投诉人" v-if="value == 2">
              <a-select v-decorator="[
                'respondent',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择被投诉人!'
                    }
                  ]
                }
              ]" v-if="complaintObject" :allowClear="true">
                <a-select-option v-for="type in masterList" :key="type.userId">
                  {{ type.userName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉内容" v-if="value == 2">
              <!--<a-textarea v-model="complaintsContents"/>-->
              <a-textarea v-decorator="['complaintsContents']" />
            </a-form-item>
            <div v-else>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题类型">
                <a-select v-decorator="[
                  'matterCode',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择问题类型!'
                      }
                    ]
                  }
                ]" :allowClear="true" @change="onChangefeedback">
                  <a-select-option v-for="type in feedbackAuthority" :key="type.code">{{ type.name }} </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
                <a-textarea v-decorator="['contents']" />
              </a-form-item>
            </div>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传图片">
              <a-upload name="file" :multiple="true" :action="currencyuploadUrl" list-type="picture-card"
                class="avatar-uploader" :file-list="problemfileList" :headers="headers" @preview="handlePreview"
                @change="complainthandleChange">
                <a-icon type="upload" />
                <div class="ant-upload-text">图片</div>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal v-model="backChargeible" @ok="addbackCharge()" :title="this.valueRejection == 3 ? '拒单理由' : '退单理由'"
      :width="600">
      <a-form :form="backChargeform">
        <a-row>
          <a-col>
            <a-form-item v-if="this.valueRejection == 3" :labelCol="labelCol" :wrapperCol="wrapperCol" label="拒单类型">
              <a-select v-decorator="[
                'refusalOrderReason',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择拒单类型!'
                    }
                  ]
                }
              ]" :allowClear="true" @change="refusalOrderchange">
                <a-select-option v-for="type in refusal_order_reason" :key="type.dictValue">{{ type.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="this.valueRejection == 1" :labelCol="labelCol" :wrapperCol="wrapperCol" label="退单类型">
              <a-select v-decorator="[
                'subtypeCode',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择退单类型!'
                    }
                  ]
                }
              ]" :allowClear="true" @change="subtypechange">
                <a-select-option v-for="type in typePendingMattersSub" :key="type.code">{{ type.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="this.valueRejection == 1" :labelCol="labelCol" :wrapperCol="wrapperCol" label="退单理由">
              <a-input v-decorator="['content', { rules: [{ required: this.subtypeRequiredBool, message: '请填写理由!' }] }]"
                type="textarea" />
            </a-form-item>
            <a-form-item v-if="this.valueRejection == 3" :labelCol="labelCol" :wrapperCol="wrapperCol" label="拒单理由">
              <a-input v-decorator="[
                'reasonContext',
                {
                  rules: [
                    {
                      required: this.reasonRequiredBool,
                      message: '请填写理由!'
                    }
                  ]
                }
              ]" type="textarea" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--:confirm-loading="orderCloseLoading"-->
    <a-modal v-model="orderCloseible" @ok="addorderClose()" title="关闭理由" :width="600">
      <a-form :form="orderCloseform">
        <a-row>
          <a-col>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关闭类型">
              <a-select v-decorator="[
                'refusalOrderReason',
                {
                  rules: [
                    {
                      required: true,
                      message: '请选择关闭类型!'
                    }
                  ]
                }
              ]" :allowClear="true" @change="orderClosechange">
                <a-select-option v-for="type in close_order_type" :key="type.dictValue">{{ type.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关闭理由">
              <a-input
                v-decorator="['reasonContext', { rules: [{ required: this.orderCloseBool, message: '请填写理由!' }] }]"
                type="textarea" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal title="设置及修改暂不结算订单" style="top: 20px" v-model="setNoSettleible" :width="700" footer="'"
      @cancel="setNoSettlecancel">
      <a-form :form="formsetNoSettle">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="暂不结算原因">
          <a-select v-decorator="[
            'noSettleReason',
            {
              rules: [
                {
                  required: true,
                  message: '请选择暂不结算原因!'
                }
              ]
            }
          ]" @change="onchage44">
            <a-select-option v-for="item in no_settle_reason" :key="item.dictLabel">{{ item.dictLabel }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" v-if="isTemporarilySettle != 1">
          <a-textarea v-decorator="[
            'noSettleRemark',
            {
              rules: [
                {
                  required: false,
                  message: '请填写原因!'
                }
              ]
            }
          ]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业结算后结算">
          <!--,{initialValue: false}/-->
          <a-checkbox @change="settleAfterboolboolchange"
            v-decorator="['settleAfterboolbool', { valuePropName: 'checked', initialValue: false }]">
            是否企业结算后结算
          </a-checkbox>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="暂不结算时间" v-if="!settleAfterboolbool">
          <a-date-picker :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" @change="onChangetemporarily"
            @ok="onOk" v-decorator="[
              'SettleTime',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择暂不结算时间!'
                  }
                ]
              }
            ]" format="YYYY-MM-DD HH:mm:ss" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" v-if="isTemporarilySettle == 1" @click="setNoSettleOk(0)"> 取消暂不结算 </a-button>
          <a-button type="primary" v-else style="margin-left: 20px" @click="setNoSettleOk(1)"> 设置暂不结算 </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--:confirmLoading="confirmLoading"-->
    <a-modal title="加急额度" style="top: 20px" :width="950" v-model="OrderUrgentible" footer="">
      <a-form :form="formOrderUrgent">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本月已使用加急数">
          <a-input disabled="disabled" v-decorator="['usedUrgentNum']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加急费用">
          <a-input disabled="disabled" v-decorator="['urgentMoney']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本月可使用加急数">
          <a-input disabled="disabled" v-decorator="['usefulUrgentNum']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本月总可加急数">
          <a-input disabled="disabled" v-decorator="['totalUrgentNum']" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <a-button type="primary" @click="OrderUrgentOk(0)" v-if="isUrgentOrder == 1"> 取消加急 </a-button>
          <a-button type="primary" style="margin-left: 20px" @click="orderUrgentByMoney(1)" v-if="isUrgentOrder != 1">
            订单加急
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="配件退回" style="top: 20px" v-model="accessoriesReturnidle" @ok="addaccessoriesReturn">
      <a-form :form="formaccessoriesReturn">
        <a-form-item style="display: none">
          <a-input v-decorator="['orderAccessoryId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
          <a-date-picker v-model="accessoriesitem" style="width: 100%" @change="onChangeaccessories"
            format="YYYY-MM-DD" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
          <a-select v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]"
            :allowClear="true">
            <a-select-option v-for="type in delivery_company" :key="type.dictValue">{{ type.dictLabel }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
          <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="师傅通话记录" style="top: 20px" v-model="visible" :width="800" :confirmLoading="confirmLoading"
      @ok="handleSubmit12" :destroyOnClose="true">
      <a-table size="default" ref="table" showHeader="false" :data-source="loadData" :columns="columns2" bordered>
      </a-table>
    </a-modal>
    <a-modal v-model="appointmentVisible" @ok="handleAppointment" title="预约异常" width="650px">
      <a-form :form="appointmentForm">
        <a-row>
          <a-col :span="24">
            <a-form-item label="预约异常类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select @change="reserveFail"
                v-decorator="['reserveType', { rules: [{ required: true, message: '请选择预约异常类型!' }] }]">
                <a-select-option v-for="type in reserve_failed" :title="type.dictValue" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <!-- <a-form-item label="预计上门时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                @change="appointmentTime"
                format="YYYY-MM-DD"
                style="width: 70%"
                v-decorator="['estimateTime', { rules: [{ required: true, message: '请填入预计上门时间!' }] }]"
              />
              <a-select
                style="width: 30%"
                :getPopupContainer="getPopupContainer"
                v-decorator="['estimateTimePart', { rules: [{ required: true, message: '请选择时间段!' }] }]"
                :allowClear="true"
              >
                <a-select-option v-for="type in timeselect" :key="type.value">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item> -->
            <a-form-item label="预约异常原因" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-if="appointmentAble"
                v-decorator="['reason', { rules: [{ required: true, message: '请填写预约异常原因!' }] }]" />
              <a-input v-else v-decorator="['reason']" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <requirements-enterprise-model ref="requirements" @ok="geterpriseDemand"></requirements-enterprise-model>
    <feedbackorder-model ref="feedbackorder" @ok="updateFeedbacklist"></feedbackorder-model>
    <compalanit-modal ref="compalanit" @ok="updateCompalanitlist"></compalanit-modal>
    <leaflets-distribute-model ref="leaflets" @leafletsok="refreshOrder"></leaflets-distribute-model>
    <select-order-frozen-model ref="selectorderfrozen" @selectorderok="refreshOrder"></select-order-frozen-model>
    <associated-order-model ref="associatedorder" @ok="updateFeedbacklist"></associated-order-model>

    <!-- 萤石序列号设置弹窗 -->
    <!-- 萤石序列号设置弹窗 -->
    <ezviz-sn-modal ref="ezvizSnModal" :orderId="orderId" :reslist="reslist" @refresh="showeditOrder(reslist.orderId, '', 1)" />
  </a-modal>
</template>
<script>
// #region 
import ACol from 'ant-design-vue/es/grid/Col'
// import {getDemandList } from '@/api/enterprise/guarantee'
import moment from 'moment'
// import feedbackorderModel from './feedbackorderModel'
// import compalanitModal from './compalanitModal'
// import selectOrderFrozenModel from './selectOrderFrozenModel'
// import requirementsEnterpriseModel from './requirementsEnterpriseModel'
// import orderList from '@/views/order/orderList'
import pick from 'lodash.pick'
import {
  getPendingMatterRoleUserList, // 被投诉人
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getSelectBrand,
  getSelectModel,
  getList,
  getOrderDetail,
  getorderInfo,
  getisOrderOpened,
  getagainDispatchOrder,
  getfindByDeptId,
  getfinddictAll,
  insertHangUpOrder,
  hangUpDelete,
  orderLogList,
  addOrderRemindData,
  updateOrderJobRemind,
  queryRemind,
  expressIdentify,
  insert2
} from '@/api/order/orderList'

import {
  getaddTransport,
  getdelTransport,
  getaddOrderRemark,
  getupdateOrderRemark,
  getdeleteOrderRemark,
  addOrderAccessory,
  getreturnOrderAccessory,
  getinvalidOrderAccessory,
  getsearchOrderRelation,
  getexchangeOrderRelation,
  getcancelOrderRelation,
  getTransportInfo,
  getupdateOrder,
  getchangePriceList,
  getverificationOrder,
  getbasicPricelist,
  getByPriceType,
  queryPriceByIdAndType,
  getaddPrice,
  getchangePrice,
  getaudit,
  getComplaintAuthority,
  getFeedbackAuthority,
  getaddFeedback,
  getaddComplaint,
  getcustomerServiceApply,
  getenterpriseUpdate,
  getreturnOrder,
  getdispatchOrder,
  getreceiveOrder,
  getcloseOrder,
  getreservationOrder,
  getinstallOrder,
  getreviewOrder,
  getcompleteOrder,
  getassignOrder,
  getsetNoSettle,
  getorderImportant,
  getorderUrgent,
  getorderUrgentByMoney,
  getsaleOrderData,
  getdeletesale,
  getdisablesale,
  salevideoList,
  getsaleDataSave,
  getfeedbacklist,
  getcomplaintslist,
  getaddAudit,
  getPendingMattersSubtype,
  getmyPendingMatters,
  getquickProcess,
  getselectNoSettle,
  getselectOrderFrozen,
  getcanAddPriceTypes,
  getprocessor,
  getaddAppendInfo,
  getreserveFailed,
  getchangeReservation,
  getenterpriseDemandList,
  getchangePriceBatch,
  selectEnterpriseinfo,
  addDetectionResultApi,
  getEzvizEnterpriseIdListApi,
  signInOrderApi
} from '@/api/order/editorder'
import {
  getselectChannel,
  getselectSource,
  getselectCombox,
  getPiclist,
  getqueryEnterpriseAccessory,
  getqueryEnterpriseStock,
  getqueryEnterpriseAccessoryPrice,
  addOrderRelation,
  getdemandlist,
  getBaseInfoForOrder,
  getcheckOrderUrgent,
  getenterpriseInstallTypes,
  gettemplatelist,
  getinfoList,
  gettemplateselectInfo,
  getEnterpriseContactsById,
  getSendBackList
} from '@/api/order/NewlyaddedOrderList'
import '@/assets/iconfont/iconfont.css'
import { getInfo } from '@/api/login'
import { mixin, mixinDevice } from '@/utils/mixin'
import { STable } from '@/components'
import { getDictMap } from '@/utils/dict'
import ARow from 'ant-design-vue/es/grid/Row'
import { ACCESS_TOKEN } from '@/store/mutation-types'
// import associatedOrderModel from './associatedOrderModel'
import { checkPermission } from '@/utils/permissions'
import { insert, firstList, editWriteoffUserCharge, getQuestion } from '@/api/order/cancelList'
import store from '@/store'
import _ from 'lodash'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import { imgUrl } from '@/utils/common'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
export default {
  name: 'EditOrderModel',
  mixins: [mixin, mixinDevice],
  props: ['recordList'],
  // OrderDetails ,
  components: {
    kehuResult: () => import('./kehuResult'),
    kefuResult: () => import('./kefuResult'),
    commontMaster: () => import('./commontMaster'),
    ATextarea,
    ACol,
    ARow,
    requirementsEnterpriseModel: () => import('./requirementsEnterpriseModel'),
    selectOrderFrozenModel: () => import('./selectOrderFrozenModel'),
    STable,
    orderList: () => import('@/views/order/orderList'),
    feedbackorderModel: () => import('./feedbackorderModel'),
    compalanitModal: () => import('./compalanitModal'),
    associatedOrderModel: () => import('./associatedOrderModel'),
    leafletsDistributeModel: () => import('./leafletsDistributeModel'),
    yanshoudan: () => import('./yanshoudan'),
    EzvizSnModal: () => import('./EzvizSnModal')
  },
  data() {
    return {
      initialClientPhone: '',
      modelSpecLength: '',
      modelSpecWidth: '',
      showJiedan: false,
      // 派单弹窗
      showpaidan: false,
      // 若订单的付款方式为客户付款，则给出当前该弹框提示结单弹窗
      showStateMent: false,
      applyResult: '',
      previewVisible1: false,
      previewVisible2: false,
      imgUrl,
      // 寄回要求数据
      sendBackList: [],
      // 配件情况是否显示
      fitStatus: null,
      showCommont: false, // 客服反馈组件的销毁创建
      isRefresh: false, // 是否是刷新
      spinning: false,
      estimateTime: null,
      estimateTime1: null,
      appointmentVisible: false,
      appointmentForm: this.$form.createForm(this),
      reserve_failed: [],
      appointmentAble: false,
      reserveFailureType: '',
      reserveFailureReason: '',
      // 师傅备注
      masterRemark: {},
      // 订单备注
      orderRemark: {},
      newaddprice: -1,
      enterpriceindex: -1,
      masterpriceindex: -1,
      store,
      appendInfo: '',
      changprice: 1,
      scrollin: true,
      backlogNum: 0,
      loadData: '',
      visible: false,
      orderCloseLoading: false,
      accessoriesLoading: false,
      packageLoading: false,
      orderRemarkbleLoading: false,
      AddorderRemarkbleLoading: false,
      recoveryloading: false,
      // 提交确认是否校验合格
      informationMasterformOk: false,
      moreOrderList: [],
      orderReminde: {
        remark: ''
      }, // 订单提醒
      orderClientformOk: false,
      formOk: false,
      columns2: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center'
        },
        {
          title: '主账号',
          dataIndex: 'mainMaster',
          align: 'center'
        },
        {
          title: '拨打账号',
          dataIndex: 'nowMaster',
          align: 'center'
        },
        {
          title: '拨打联系方式',
          dataIndex: 'masterPhone',
          align: 'center'
        },
        {
          title: '拨打时间',
          dataIndex: 'relationTime',
          align: 'center'
        }
      ],
      queryParam9: {},
      loadData9: (parameter) => {
        this.queryParam9.orderId = this.orderId
        return orderLogList(Object.assign(parameter, this.queryParam9))
      },
      // 字典为付款状态
      pay_status: [],
      loading9: false,
      columns9: [
        {
          title: '序号',
          width: '80px',
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center'
        },
        {
          title: '订单模块',
          dataIndex: 'module',
          align: 'center'
        },
        {
          title: '操作类型',
          dataIndex: 'operateType',
          align: 'center'
        },
        {
          title: '操作内容',
          dataIndex: 'operateContent',
          scopedSlots: {
            customRender: 'action9'
          },
          align: 'center'
        },
        {
          title: '操作人',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '操作时间',
          dataIndex: 'operateTime',
          align: 'center'
        }
      ],
      pricelabel: [],
      orderClientPic: [],
      orderClientvideo: [],
      problemfileList: [],
      complaintfilelist: [],
      close_order_type: [],
      order_status: '',
      masterNotesExpand: false,
      notesOrderExpand: false,
      orderCloseible: false,
      nameible: false,
      reserveTimePartChange: '',
      findByDeptId: [],
      isOrderOpenedmsg: [],
      valueradio: '',
      feedbacklist: '',
      complaintslist: '',
      previewVisible: false,
      previewImage: '',
      Piclist: [],
      package: {},
      orderClientvalues: '',
      basicPricelist: [],
      price_demand: '',
      changePriceList: '',
      masterPricelength: 0,
      enterprisePricelength: 0,
      staType: '',
      OrderUrgentible: false,
      orderCloseBool: false,
      modifiedamountlist: [],
      enterpriseIdbool: () => {
        if (this.$store.getters.enterpriseId) {
          return true
        } else {
          return false
        }
      },
      setNoSettleible: false,
      feedback: checkPermission('order:list:query:detail:feedback'),
      addPackage: checkPermission('addPackage'),
      editPackage: checkPermission('editPackage'),
      editClientInfo: checkPermission('editClientInfo'),
      deletePackage: checkPermission('deletePackage'),
      addMasterRemark: checkPermission('addMasterRemark'),
      editMasterRemark: checkPermission('editMasterRemark'),
      editTime: checkPermission('editTime'),
      removeMasterRemark: checkPermission('removeMasterRemark'),
      viewInnerRemark: checkPermission('viewInnerRemark'),
      addInnerRemark: checkPermission('addInnerRemark'),
      editInnerRemark: checkPermission('editInnerRemark'),
      addOrDeleteInnerRemark: checkPermission('addOrDeleteInnerRemark'),
      viewOuterrRemark: checkPermission('viewOuterrRemark'),
      addOuterrRemark: checkPermission('addOuterrRemark'),
      editOuterrRemark: checkPermission('editOuterrRemark'),
      addOrDeleteOuterRemark: checkPermission('addOrDeleteOuterRemark'),
      addAccessory: checkPermission('addAccessory'),
      editAccessory: checkPermission('editAccessory'),
      sendBackAccessory: checkPermission('sendBackAccessory'),
      invalidAccessory: checkPermission('invalidAccessory'),
      accessoryBasic: checkPermission('order:list:detail:detailTab:accessory:basic'),
      accessoryPrice: checkPermission('order:list:detail:detailTab:accessory:price'),
      addCustomerPic: checkPermission('addCustomerPic'),
      // 禁用客户视屏、图片
      disableCustomerPic: checkPermission('disableCustomerPic'),
      // 删除客户视屏、图片
      deleteCustomerPic: checkPermission('deleteCustomerPic'),
      // associatedOrder: checkPermission('order:list:detail:detailTab:associatedOrder'),
      changePriice: checkPermission('order:list:detail:changePriice'),
      editAssociatedOrder: checkPermission('editAssociatedOrder'),
      createProblem: checkPermission('createProblem'),
      priceTabenterprise: checkPermission('order:list:detail:priceTab:enterprise'),
      priceTabmaster: checkPermission('order:list:detail:priceTab:master'),
      priceTabrecord: checkPermission('order:list:detail:priceTab:record'),
      ordercustomerServiceApply: checkPermission('customer:service:apply'),
      orderupdateOrder: checkPermission('update:order'),
      orderdispatchOrder: checkPermission('dispatch:order'),
      orderreceiveOrder: checkPermission('receive:order'),
      orderassignOrder: checkPermission('assign:order'),
      orderreservationOrder: checkPermission('reservation:order'),
      orderinstallOrder: checkPermission('install:order'),
      orderreviewOrder: checkPermission('review:order'),
      orderreturnOrder: checkPermission('return:order'),
      ordercompleteOrder: checkPermission('complete:order'),
      ordercloseOrder: checkPermission('close:order'),
      editBaseData: checkPermission('editBaseData'),
      masterInfoName: checkPermission('order:list:detail:detailTab:masterInfo:name'),
      // masterInfoPhoneNo: checkPermission('order:list:detail:detailTab:masterInfo:phoneNo'),
      masterInfophoneNoall: checkPermission('order:list:detail:detailTab:masteInfo:phoneNo:all'),
      orderreassignment: checkPermission('order:list:reassignment'),
      detailTabbaseData: checkPermission('order:list:detail:detailTab:baseData'),
      baseDatasaleOrderNo: checkPermission('order:list:detail:detailTab:baseData:saleOrderNo'),
      baseDatalastInterveneTime: checkPermission('order:list:detail:detailTab:baseData:lastInterveneTime'),
      baseDatalastdetailTime: checkPermission('order:list:detail:detailTab:masterInfo:detailTime'),
      failure: checkPermission('order:list:detail:detailTab:masterInfo:failure'),
      settleInfo: checkPermission('order:list:detail:detailTab:masterInfo:settleInfo'),
      masterInfoRemark: checkPermission('order:list:detail:detailTab:masterInfo:remark'),
      addInstallInfo: checkPermission('addInstallInfo'),
      deleteEndInfo: checkPermission('deleteEndInfo'),
      orderRecord: checkPermission('order:list:detail:orderRecord'),
      problem: checkPermission('order:list:detail:problem:query'),
      endInfo: checkPermission('order:list:detail:endInfo'),
      endInfoQuery: checkPermission('order:list:detail:endInfo:query'),
      priceTab: checkPermission('order:list:detail:priceTab'),
      detailTab: checkPermission('order:list:detail:detailTab'),
      openUser: checkPermission('order:list:detail:openUser'),
      addDasic: checkPermission('order:list:detail:detailTab:associatedOrder:query'),
      detailNoSettle: checkPermission('order:list:detail:noSettle'),
      detailFreeze: checkPermission('order:list:detail:freeze'),
      detailImportantOrder: checkPermission('order:list:detail:importantOrder'),
      detailUrgentOrder: checkPermission('order:list:detail:urgentOrder'),
      detailSmsNotice: checkPermission('order:list:detail:smsNotice'),
      editEndInfo: checkPermission('editEndInfo'),
      problemQuery: checkPermission('order:list:detail:problem:query'),
      associatedOrderQuery: checkPermission('order:list:detail:detailTab:associatedOrder:query'),
      installInfoQuery: checkPermission('order:list:detail:detailTab:installInfo:query'),
      callRecord: checkPermission('order:list:detail:callRecord'),
      clientInfoDasic: checkPermission('order:list:detail:clientInfo:basic'),
      baseDatabasic: checkPermission('order:list:detail:baseData:basic'),
      settlementInfo: checkPermission('order:list:detail:detailTab:baseData:settlementInfo'),
      // detailTabClientNo: checkPermission('order:list:detail:detailTab:clientNo'),
      clientNoShow: checkPermission('order:list:detail:detailTab:clientNo:show'),
      masterInfoGeneral: checkPermission('order:list:detail:detailTab:masterInfo:general'),
      masterInfo: checkPermission('order:list:detail:detailTab:masterInfo'),
      enterpriseDemand: checkPermission('order:list:detail:enterpriseDemand'),
      remarkLimit: checkPermission('order:list:detail:remark'), // 编辑师傅权限
      // 客户联系方式隐藏4位
      // clientNoHidden: checkPermission('order:list:detail:detailTab:clientNo:hidden'),
      // 师傅联系方式隐藏4位
      // phoneNoHidden: checkPermission('order:list:detail:detailTab:masterInfo:phoneNo:hidden'),
      auditSingle: checkPermission('order:audit:single'),
      // reassignment: checkPermission('order:list:reassignment'),
      formOrderUrgent: this.$form.createForm(this),
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      columnsenterprise: [
        // {
        //   title: '操作栏',
        //   dataIndex: 'action',
        //   // className:this.falg ? '':'notshow',
        //   scopedSlots: {customRender: 'action'},
        // },
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '金额类型',
          dataIndex: 'priceTypeName',
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'amount',
          align: 'center'
        },
        {
          title: '初始单价',
          dataIndex: 'originalPrice',
          align: 'center'
        },
        {
          title: '初始金额',
          dataIndex: 'originalTotal',
          align: 'center'
        },
        {
          title: '修改金额',
          dataIndex: 'modifiedPrice',
          align: 'center'
        },
        {
          title: '现订单金额',
          dataIndex: 'newTotal',
          align: 'center'
        },
        {
          title: '提交人',
          dataIndex: 'submitter',
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'submitTime',
          align: 'center'
        },
        {
          title: '金额备注',
          dataIndex: 'priceRemark',
          align: 'center'
        }
      ],

      columnsrecord: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '提交步骤',
          dataIndex: 'submitStep',
          align: 'center'
        },
        {
          title: '提交人',
          dataIndex: 'submitter',
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'submitTime',
          align: 'center'
        },
        {
          title: '角色',
          dataIndex: 'role',
          align: 'center'
        },
        {
          title: '金额类型',
          dataIndex: 'priceType',
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'amount',
          align: 'center'
        },
        {
          title: '初始金额',
          dataIndex: 'originalPrice',
          align: 'center'
        },
        {
          title: '修改金额',
          dataIndex: 'modifiedPrice',
          align: 'center'
        },
        {
          title: '现订单金额',
          dataIndex: 'newPrice',
          align: 'center'
        },
        {
          title: '金额备注',
          dataIndex: 'priceRemark',
          align: 'center'
        }
      ],
      orderType: '',
      installTime: [],
      transportInfo: [],
      relationList: '',
      reviewedtobeAmount: false,
      columnsRelation: [
        {
          title: '操作栏',
          dataIndex: 'action',
          width: 120,
          scopedSlots: {
            customRender: 'action'
          }
        },
        {
          title: '状态栏',
          dataIndex: 'orderLevel',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: {
            customRender: 'orderNo'
          },
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center'
        },
        {
          title: '订单状态',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '品牌型号',
          dataIndex: 'brandName',
          align: 'center'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center'
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center'
        }
      ],
      expectinstallTimeible: false,
      formaccessoriesReturn: this.$form.createForm(this),
      formWritefalg: false,
      masterDisabled: false,
      reasonRequiredBool: false,
      subtypeRequiredBool: false,
      accessoriesReturnidle: false,
      accessoriesitem: '',
      token: Vue.ls.get(ACCESS_TOKEN),
      showorderTypeBool: true,
      columnfeedback: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          }
        },
        {
          title: '处理情况',
          dataIndex: 'handlingStatus',
          align: 'center'
        },
        {
          title: '问题类型',
          dataIndex: 'matterName',
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '申请人',
          dataIndex: 'initiatorName',
          align: 'center'
        },
        {
          title: '申请人联系方式',
          dataIndex: 'initiatorPhone',
          align: 'center'
        },
        {
          title: '问题内容',
          dataIndex: 'contents',
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '当前处理人',
          dataIndex: 'currentHandlerName',
          align: 'center'
        },
        {
          title: '开始处理时间',
          dataIndex: 'handleStartTime',
          align: 'center'
        },
        {
          title: '处理完成时间',
          dataIndex: 'handleEndTime',
          align: 'center'
        },
        {
          title: '处理时长',
          dataIndex: 'processingTimeStr',
          align: 'center'
        },
        {
          title: '处理总时长',
          dataIndex: 'totalProcessingTimeStr',
          align: 'center'
        }
      ],
      columncomplaints: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          }
        },
        {
          title: '处理情况',
          dataIndex: 'handlingStatus',
          align: 'center'
        },
        {
          title: '投诉类型',
          dataIndex: 'matterName',
          align: 'center'
        },
        {
          title: '投诉人',
          dataIndex: 'complainantName',
          align: 'center'
        },
        {
          title: '投诉人联系方式',
          dataIndex: 'complaintPhone',
          align: 'center'
        },
        {
          title: '投诉内容',
          dataIndex: 'contents',
          align: 'center'
        },
        {
          title: '投诉对象',
          dataIndex: 'respondentName',
          align: 'center'
        },
        {
          title: '投诉时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '当前处理人',
          dataIndex: 'currentHandlerName',
          align: 'center'
        },
        {
          title: '开始处理时间',
          dataIndex: 'handleStartTime',
          align: 'center'
        },
        {
          title: '处理完成时间',
          dataIndex: 'handleEndTime',
          align: 'center'
        },
        {
          title: '处理时长',
          dataIndex: 'processingTimeStr',
          align: 'center'
        },
        {
          title: '处理总时长',
          dataIndex: 'totalProcessingTimeStr',
          align: 'center'
        }
      ],
      fileListfour: [{}],
      settlement_status: [],
      time_list: '',
      dateFormat: 'YYYY/MM/DD',
      format: 'YYYY/MM/DD HH:mm:ss',
      queryEnterpriseStock: [],
      enterpriseId: '',
      fileListMaster: [],
      salepicfileList: [],
      formmoneymodalValuesList: [],
      ordercolumns: [
        {
          title: '',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => `${index + 1}`
        },
        {
          title: '',

          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          width: 150
        },
        {
          title: '',
          dataIndex: 'remarkType',
          width: 60,
          customRender: (text) => {
            if (text == 1) {
              return '外部'
            } else {
              return '内部'
            }
          }
        },
        {
          title: '',
          dataIndex: 'remarkInfo'
          /* customRender: (text) => text + ' 订单要求' */
        },
        {
          title: '',
          dataIndex: 'updateBy',
          width: 120
        },
        {
          title: '',
          dataIndex: 'updateTime',
          width: 200
        },
        {
          title: '',
          dataIndex: 'appendInfo'
        }
      ],
      mastercolumns: [
        {
          title: '',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => `${index + 1}`
        },
        {
          title: '',
          dataIndex: 'action',
          width: 120,
          scopedSlots: {
            customRender: 'action'
          }
        } /* { title: '', dataIndex: 'remarkType', customRender: (text) => { if(text==1){return '外部'}else {return'内部'} } }, */,
        {
          title: '',
          dataIndex: 'remarkInfo'
          /* customRender: (text) => text + ' 订单要求' */
        },
        {
          title: '',
          dataIndex: 'updateBy',
          width: 100
        },
        {
          title: '',
          dataIndex: 'updateTime',
          width: 170
        }
      ],
      remark: {},
      orderRemarkmodal: {},
      orderremark: {},
      dtoListtab: {},
      uploadVideo: [],
      uploadclientPic: [],
      uploadclientVideo: [],
      videoState: false,
      orderremarkAdditionalible: false,
      addmoneymodelLoading: false,
      modifiedamountLoading: false,
      addproblemLoading: false,
      // * 添加包裹*/
      columnspackage: [
        {
          title: '序号',
          align: 'center',
          customRender: (text, record, index) => `${index + 1}`,
          width: 60
        },
        {
          title: '操作',
          width: 120,
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          }
        },
        {
          title: '包裹',
          dataIndex: 'transportName',
          align: 'center'
        },
        {
          title: '快递公司',
          dataIndex: 'transportCodeName',
          align: 'center'
        },
        {
          title: '快递单号',
          dataIndex: 'transportNo',
          align: 'center'
        },
        {
          title: '快递状态',
          dataIndex: 'transportStatusStr',
          align: 'center'
        },
        {
          title: '包裹备注',
          dataIndex: 'remark'
        },
        {
          title: '重要',
          dataIndex: 'isMain',
          customRender: (text) => {
            if (text == '1') {
              return '重要'
            } else {
              return ''
            }
          },
          align: 'center'
        }
      ],
      reviewedAmount: false,
      enterpriseDemandList: '',
      reslist: undefined,
      copyData: '',
      masterStatus: false,
      cancelOrderStatus: false,
      columnsAddaccessories: [
        {
          title: '序号',
          align: 'center',
          customRender: (text, record, index) => `${index + 1}`
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: {
            customRender: 'action'
          },
          width: '140px'
        },
        {
          title: '配件状态',
          align: 'center',
          dataIndex: 'accessoryStatus',
          customRender: (text) => {
            if (text == '1') {
              return '已作废'
            } else {
              return '使用中'
            }
          }
        },
        {
          title: '配件名称',
          align: 'center',
          dataIndex: 'accessoryName'
        },
        {
          title: '数量',
          align: 'center',
          dataIndex: 'accessoryNum'
        },
        {
          title: '企业配件单价',
          align: 'center',
          dataIndex: 'price'
        },
        {
          title: '企业配件总金额',
          align: 'center',
          dataIndex: 'totalAmount'
        },
        {
          title: '师傅配件单价',
          align: 'center',
          dataIndex: 'masterPrice'
        },
        {
          title: '师傅配件总金额',
          align: 'center',
          dataIndex: 'masterTotalAmount'
        },
        {
          title: '发货日期',
          align: 'center',
          dataIndex: 'deliveryTime'
        },
        {
          title: '快递公司',
          align: 'center',
          dataIndex: 'transportCode'
        },
        {
          title: '快递单号',
          align: 'center',
          dataIndex: 'transportNo',
          scopedSlots: {
            customRender: 'transport'
          }
        },
        {
          title: '快递状态',
          align: 'center',
          dataIndex: 'transportStatus'
        },
        {
          title: '发货仓库',
          align: 'center',
          dataIndex: 'repositoryName'
        },
        {
          title: '发货人',
          align: 'center',
          dataIndex: 'sendUser'
        },
        {
          title: '收货人',
          align: 'center',
          dataIndex: 'receiveUser'
        }
      ],

      // 判断用户
      userType: '',
      parts: {},
      showh: false,
      packageable: false,
      transportble: false,
      orderRemarkble: false,
      formsetNoSettle: this.$form.createForm(this),
      informationMasterform: this.$form.createForm(this),
      formWriteon: this.$form.createForm(this),
      formWriteoff: this.$form.createForm(this),
      additionalform: this.$form.createForm(this),
      orderCloseform: this.$form.createForm(this),
      masteramountmodel: this.$form.createForm(this),
      data1: '',
      data: '', // 筛选后的题目
      orderMastervalues: '',
      heXiaoValue: false,
      incompleteible: false,
      submissionPriceible: false,
      disable: false,
      loadDataPj: [],
      /* 字典为快递公司 */
      delivery_company: [],
      /* 字典为安装类型 */
      installTypes: [],
      /* 字典为结算周期 */
      settle_cycle: [],
      showCounterVaneFields: false,
      hasCounterVaneOptions: [
        { label: '是', value: 0 },
        { label: '否', value: 1 }
      ],
      selectBrand: [],
      selectModel: [],
      /* 查询信息来源下拉框 */
      selectSource: [],
      /* 查询购买渠道下拉框 */
      selectChannel: [],
      selectCombox: [],
      /* 字典为付款方式 */
      pay_type: [],
      address_type: [],
      /* 字典为暂不结算原因 */
      no_settle_reason: [],
      EnterpriseAccessory: [],
      /* 省 */
      selectAllProvince: [],
      selectCityName: [],
      selectAreaName: [],
      installTimeBegin: '',
      installTimeEnd: '',
      installTimeedit: '',
      accessoriesname2: '',
      form: this.$form.createForm(this),
      formmoney: this.$form.createForm(this),
      formfeedback: this.$form.createForm(this),
      formcomplaint: this.$form.createForm(this),
      formmoneymodal: this.$form.createForm(this),
      modifiedamountmodel: this.$form.createForm(this),
      problemform: this.$form.createForm(this),
      backChargeform: this.$form.createForm(this),
      orderClientform: this.$form.createForm(this),
      formpackage: this.$form.createForm(this),
      formaccessories: this.$form.createForm(this),
      mdl: {},
      editOrderShow: 0,
      button1: 0,
      button2: 0,
      disClick1: false,
      disClick2: false,
      masterList: [],
      timeString: null,
      timeValueString: null,
      disabledTime: false,
      queryParam: {},
      visiable: false,
      count: 2,
      /* 上传2 */
      previewVisibletwo: false,
      previewImagetwo: '',
      fileListtwo: [
        {
          /* uid: '-1', name: 'xxx.png', status: 'done', url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png' */
        }
      ],
      /* 以上上传2 */
      description: '',
      loading: false,
      fileList: [{}],
      memberLoading: false,
      errors: [],
      moneyaddible: false,
      backChargeible: false,
      defaultactivekey: '2',
      activeKey: '1',
      key2: 2,
      falg: false,
      examinefalg: false,
      // 问题反馈model
      problemible: false,
      // 改价那一行数据
      submissionPricerecord: '',
      submissionPriceindex: 0,
      submissionPricetype: '',
      recordList: '',
      // radio问题反馈 投诉
      value: '',
      feedbackAuthority: [],
      complaintAuthority: [],
      complaintObject: [
        {
          code: '',
          name: ''
        }
      ],
      userId: '',
      valueRejection: '',
      customInfo: '',
      orderImportantbool: false,
      isSmsWarnbool: false,
      isSerialNotice: false,
      factoryStatus: false,
      isUrgentOrder: '',
      serialNumber: '', // 序列号-扫码
      salepicList: [], // 安装 前中后 照片
      courierNumber: '',
      logisticsInfo: {}, // 旧件返厂
      courierImgArr: [], // 原有的courierImg-长度(数组)
      factoryImgArr: [], // 原有的factoryImg-长度（数组）
      salevideoList: '',
      saleDataSaveobj: {},
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      // infoName:'',
      process: process.env.VUE_APP_API_BASE_URL + '/dfs/download',
      uploadUrlObj: process.env.VUE_APP_API_BASE_URL + '/dfs/uploadSaleData',
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/uploadSaleOrderData',
      currencyuploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=order',
      uploadSignUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/uploadSaleData',

      clientPic: [],
      clientVideo: [],
      typePendingMattersSub: '',
      userIdWriteoff: '',
      refusal_order_reason: [],
      myPendingMatters: '',
      showmyPendingMattersible: false,
      quickProcessvalue: {},
      isTemporarilySettle: 0,
      showisTemporarilySettleDanger: false,
      settleAfterboolbool: false,
      orderFrozen: '',
      editOrderible: false,
      orderexternalible: true,
      orderinsideible: true,
      orderSubStatus: false,
      previewimgible: false,
      previewimgurl: '',
      filePathsMaster: [],
      hodleOrderEditStuda: 0,
      orderId: '',
      examStatus: 0,
      examData1: [],
      examDataList: [],
      time1: null,
      time2: null,
      time3: null,
      time4: null,
      isTrue: false,
      editloading: false,
      hodleOrder2: false,
      orderId22: '',
      shijian: '',
      flagId: '',
      // 更改仓库后storeType
      storeType: '',
      accessoriesOptions: [],
      // 是否显示-开箱不良
      chooseReason: false,
      isSelected: false,
      priceCode: '',
      orderTypeInit: undefined, // 初始订单类型
      installationInfoList: [], // 初始安装信息
      orderTypeName: '',
      signatureFileList: [], // 签字图片
      signatureShow: false, // 是否可提交签字图片
      idsYS: [], // 萤石ids
      isYS: false,
      originalTimeselect: [
        {
          value: '07-09',
          label: '7-9点'
        },
        {
          value: '09-11',
          label: '9-11点'
        },
        {
          value: '11-13',
          label: '11-13点'
        },
        {
          value: '13-15',
          label: '13-15点'
        },
        {
          value: '15-17',
          label: '15-17点'
        },
        {
          value: '17-19',
          label: '17-19点'
        },
        {
          value: '19-21',
          label: '19-21点'
        },
        {
          value: '21-07',
          label: '21-次日7点'
        }
      ],
      // #endregion
    }
  },
  // #region
  computed: {
    timeselect() {
      if (this.reslist.foreignType != 6) {
        return JSON.parse(JSON.stringify(this.originalTimeselect))
      } else {
        let arr = []
        let twoNum = (num) => {
          if (num >= 10) return num + ''
          else return '0' + num
        }
        for (let i = 0; i < 24; i++) {
          arr.push({
            value: twoNum(i) + '-' + twoNum(i + 1),
            label: i + '-' + (i + 1) + '点'
          })
        }
        return arr
      }
    }
  },
  watch: {
  },
  methods: {
    // 提交签字图片
    signatureSubmit() {
      const url = this.signatureFileList.map((item) => (item.response ? item.response.url : item.url1 ? item.url1 : ''))
        .join(',')
      this.signatureShow = false
      addDetectionResultApi({ acceptanceUrl: url, orderId: this.reslist.orderId }).then(res => {
        if (res.code == 0) {
          this.$message.success('提交签字图片成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              // this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /* 只能输入整数 */
    numberRep(value) {
      if (typeof value == 'string') {
        return !isNaN(Number(value)) ? value.replace(/^(0+)|[^\d]/g, '') : ''
      } else if (typeof value == 'number') {
        return !isNaN(value) ? String(value).replace(/^(0+)|[^\d]/g, '') : ''
      } else {
        return ''
      }
    },
    validateClientPhone(rule, value, callback) {
      if (value && value !== this.initialClientPhone) {
        const mobileRegex = /^1[3-9]\d{9}$/
        const landlineRegex = /^(0\d{2,3}-?)?\d{7,8}$/
        if (!mobileRegex.test(value) && !landlineRegex.test(value)) {
          callback(new Error('请输入正确的手机号或座机号'))
          return
        }
      }
      callback()
    },
    // 验收单弹窗  type 1 安装前  2 验收单
    showYanshou(type) {
      this.$refs.yanshou.init(type, this.reslist.detectContent)
    },
    // 右下角新增客服反馈
    toCommon() {
      this.showCommont = true
      this.$nextTick(() => {
        this.$refs.commont.init(this.reslist.orderId)
      })
    },
    moment,
    reserveFail(e) {
      console.log(e)
      if (e == 8) {
        this.appointmentAble = true
      } else {
        this.appointmentAble = false
      }
    },
    editOrderCancel() {
      this.editOrderible = false
      this.isRefresh = false
      // console.log(this.backlogNum)
      // window.addEventListener('scroll', '', true)
      window.removeEventListener('scroll', this.handleScroll, true)
      if (this.backlogNum == 1) {
        this.$emit('Ok')
      } else if (this.backlogNum == 2) {
        this.$emit('ok')
      } else if (this.backlogNum == 3) {
        this.$emit('moneyok')
      } else if (this.backlogNum == 4) {
        this.$emit('ok')
      } else if (this.backlogNum == 5) {
        this.$emit('ok')
      } else if (this.backlogNum == 6) {
        this.$emit('ok')
      }
    },
    // 手机号码隐藏
    // phoneFormat(phoneNum) {
    //   if (Number(phoneNum) && String(phoneNum).length == 11) {
    //     const mb = String(phoneNum);
    //     const reg = /^(\d{3})\d{4}(\d{4})$/;
    //     return mb.replace(reg, '$1****$2');
    //   } else {
    //     return phoneNum;
    //   }
    // },
    handleScroll() {
      // console.log('滚动高度', document.getElementsByClassName('ant-modal-wrap'))
      const box = document.getElementsByClassName('ant-modal-wrap')
      if (box[box.length - 1].scrollTop < 290) {
        this.scrollin = true
      } else {
        this.scrollin = false
      }
    },
    empty() {
      console.log('record', this.reslist.orderId)
      insert2({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.visible = true
          this.loadData = res.rows
          console.log(res)
        } else {
          that.$message.error(res.msg)
        }
      })
    },

    handleSubmit12() {
      this.visible = false
    },
    // 物流单号调第三方快递公司单号
    handleCourierNumber(e) {
      const params = {}
      params.num = e.target.value
      expressIdentify(params).then((res) => {
        this.$set(this.logisticsInfo, 'courierServicesCompany', res.data.name)
        this.logisticsInfo.courierServicesCode = res.data.comCode
      })
    },
    // 刷新
    orderRefresh() {
      this.isRefresh = true
      this.showeditOrder(this.reslist.orderId, '', 1)
    },

    onChange3(date, dateString) {
      this.queryParam9.operateTimeBegin = dateString[0]
      this.queryParam9.operateTimeEnd = dateString[1]
    },
    handleSelect9() {
      this.$refs.table9.refresh(true)
    },
    isSmsWarn() {
      this.isSmsWarnbool = !this.isSmsWarnbool
    },

    isSmsWarn2() {
      this.isSerialNotice = !this.isSerialNotice
    },
    changeFactory() {
      this.factoryStatus = !this.factoryStatus
    },

    handcopy(data) {
      const url = data
      const oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      console.log(oInput.value)
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    Copys3() {
      let provinceCode = ''
      this.selectAllProvince.forEach((item) => {
        if (this.orderClientform.getFieldValue('provinceId') == item.provinceCode) {
          provinceCode = item.provinceName
        }
      })
      let cityId = ''
      this.selectCityName.forEach((item) => {
        if (this.orderClientform.getFieldValue('cityId') == item.cityCode) {
          cityId = item.cityName
        }
      })
      let countyId = ''
      this.selectAreaName.forEach((item) => {
        if (this.orderClientform.getFieldValue('countyId') == item.areaCode) {
          countyId = item.areaName
        }
      })
      const virtualClientPhone = this.orderClientform.getFieldValue('virtualClientPhone')
      this.copyData =
        `客户姓名:` +
        this.orderClientform.getFieldValue('clientName') +
        '\n' +
        `客户联系方式:` +
        this.orderClientform.getFieldValue('clientPhone') +
        (virtualClientPhone ? '\n' + `虚拟号码:` + virtualClientPhone : '') +
        '\n' +
        `客户地址:` +
        provinceCode +
        cityId +
        countyId +
        this.orderClientform.getFieldValue('clientAddress')
      // console.log(this.copyData)
      this.handcopy(this.copyData)
    },
    Copys2() {
      this.copyData =
        `师傅姓名:` +
        this.informationMasterform.getFieldValue('workName') +
        '\n' +
        `;师傅联系方式:` +
        this.informationMasterform.getFieldValue('workPhone')
      this.handcopy(this.copyData)
    },
    hodleOrderEdit() {
      hangUpDelete({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('订单挂起已取消')
          this.hodleOrderEditStuda = 0
          this.$store.commit('changeAddN')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    hodleOrder() {
      this.hodleOrder2 = true
      insertHangUpOrder({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.hodleOrder2 = false
          this.$message.success('订单已挂起')
          this.hodleOrderEditStuda = 1
          this.$store.commit('changeAdd')
        } else {
          this.$message.error('订单已挂起')
          this.hodleOrder2 = false
        }
      })
    },
    handleSelect(i) {
      // console.log(this.clientVideo[i])
      this.clientVideo.splice(i, 1)
    },
    // 寄回要求下拉框改变
    sendBackListChange(e) {
      this.reslist.requirement = this.sendBackList.find((v) => v.id == e).requirement
    },
    // 企业要求
    geterpriseDemand() {
      getenterpriseDemandList({
        enterpriseId: this.enterpriseId
      }).then((res) => {
        if (res.code == 0) {
          this.enterpriseDemandList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    requirementsEnterprise() {
      this.$refs.requirements.showrequirement(this.enterpriseId)
    },
    remarkAdditional() {
      this.AddorderRemarkbleLoading = true
      this.additionalform.validateFields((err, values) => {
        values.appendInfo = this.appendInfo
        // console.log(values)
        if (!err) {
          if (values.appendInfo == '') {
            this.$message.error('请输入追加备注内容！')
          } else {
            this.orderremarkAdditionalible = false
            getaddAppendInfo(values).then((res) => {
              this.AddorderRemarkbleLoading = false
              if (res.code == 0) {
                getOrderDetail({
                  orderId: this.reslist.orderId
                }).then((res) => {
                  if (res.code == 0) {
                    this.reslist.orderRemark = res.data.orderRemark
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },
    disabledDate(current) {
      const hour = moment().hour()
      var hours = []
      for (var i = 0; i < hour; i++) {
        hours.push(i)
      }
      return hours
    },
    disabledMinutes(current) {
      const hour = moment().hour()
      if (current <= hour) {
        const minute = moment().minutes()
        var minutes = []
        for (var i = 0; i < minute; i++) {
          minutes.push(i)
        }
        return minutes
      }
    },
    disabledSeconds(current) {
      const hour = moment().hour()
      if (current <= hour) {
        const second = moment().seconds()
        var seconds = []
        for (var i = 0; i < second; i++) {
          seconds.push(i)
        }
        console.log(seconds)
        return seconds
      }
    },
    ProcessedClick() {
      this.moreOrderList.status = 1
      updateOrderJobRemind({
        remindId: this.moreOrderList.remindId,
        status: 1,
        orderId: this.moreOrderList.orderId,
        orderNo: this.moreOrderList.orderNo,
        orderStatus: this.moreOrderList.orderStatus,
        remindType: 1
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.getMoreList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getMoreList() {
      queryRemind({
        orderId: this.reslist.orderId,
        remindType: 1,
        status: 0
      }).then((res) => {
        this.$emit('ok3', 0)
        this.$emit('ok3', 1)
        if (res.data == null) {
          this.disabledTime = false
          this.orderReminde.remark = ''
          this.timeValueString = null
        } else {
          this.disabledTime = true
          this.moreOrderList = res.data
          this.orderReminde.remark = res.data.remark
          this.timeValueString = moment(res.data.timeQuantum, 'HH:mm:ss')
        }
      })
    },
    internalAdd(record) {
      this.appendInfo = ''
      this.additionalform.resetFields()
      setTimeout(
        () =>
          this.additionalform.setFieldsValue({
            orderRemarkId: record.orderRemarkId
          }),
        16
      )
      this.orderremarkAdditionalible = true
      this.AddorderRemarkbleLoading = false
    },
    handleChangeMaster({ fileList }) {
      this.fileListMaster = fileList
      console.log(this.fileListMaster)
      if (fileList.length == 0) {
        this.filePathsMaster = []
      } else {
        this.filePathsMaster = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePathsMaster.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePathsMaster.push(fileList[i].url)
          }
        }
      }
    },
    // handlePreviewMaster(file) {
    //   if (!file.url && !file.preview) {
    //     file.preview = getBase64(file.originFileObj);
    //   }
    //   this.previewImage = file.url || file.preview;
    //   this.previewVisible = true;
    // },
    getImgToBase64(url, callback) {
      // 将图片转换为Base64
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
    refreshOrder() {
      this.showeditOrder(this.reslist.orderId, '', 1)
      this.$emit('ok')
    },
    moneyAmountModify(value) {
      const enterpriseOriginalPrice = this.formmoneymodal.getFieldValue('enterpriseOriginalPrice')
      this.formmoneymodal.setFieldsValue({
        enterpriseOriginalTotal: value * enterpriseOriginalPrice
      })
      const masterOriginalPrice = this.formmoneymodal.getFieldValue('masterOriginalPrice')
      this.formmoneymodal.setFieldsValue({
        masterOriginalTotal: value * masterOriginalPrice
      })
      const enterpriseModified = this.formmoneymodal.getFieldValue('enterpriseModified')
      const masterModified = this.formmoneymodal.getFieldValue('masterModified')

      this.enterpriseModify(enterpriseModified)
      this.masterModify(masterModified)
    },
    previewimg(url) {
      this.previewimgurl = this.process + '?fileName=' + url + '&token=' + this.token
      this.previewimgible = true
    },
    previewimg2(url) {
      console.log(url)
      this.previewimgurl = url
      console.log(this.process)
      console.log(this.previewimgurl)
      this.previewimgible = true
    },
    previewimghandleCancel() {
      this.previewimgible = false
    },
    showassociatedOrder(id) {
      this.$refs.associatedorder.showeditOrder(id, '', 0)
    },
    updateModelSpecs(modelId) {
      if (modelId && this.selectModel && this.selectModel.length > 0) {
        const model = this.selectModel.find(item => item.modelId === modelId)
        if (model) {
          this.modelSpecLength = model.specLength
          this.modelSpecWidth = model.specWidth
        } else {
          this.modelSpecLength = ''
          this.modelSpecWidth = ''
        }
      } else {
        this.modelSpecLength = ''
        this.modelSpecWidth = ''
      }
    },
    changeModelName(e) {
      this.updateModelSpecs(e)
    },
    // 被投诉人
    handChange(e) {
      const matterCode = this.problemform.getFieldValue('matterCode')
      this.problemform.setFieldsValue({
        respondent: ''
      })

      getPendingMatterRoleUserList({
        complaintObject: e,
        orderId: this.reslist.orderId
      }).then((res) => {
        this.masterList = res.data
      })
    },
    getPopupContainer(trigger) {
      return trigger.parentElement
    },
    showorderType() {
      this.showorderTypeBool = false
    },
    refusalOrderchange(value) {
      if (value == 5) {
        this.reasonRequiredBool = true
      } else {
        this.reasonRequiredBool = false
      }
    },
    orderClosechange(value) {
      if (value != 0) {
        this.orderCloseBool = true
      } else {
        this.orderCloseBool = false
      }
    },
    subtypechange(value) {
      if (value == 'other') {
        this.subtypeRequiredBool = true
      } else {
        this.subtypeRequiredBool = false
      }
    },
    ChangefindByDeptId(value) { },
    orderexternal(e) {
      if (this.orderexternalible && this.orderinsideible) {
        getOrderDetail({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.reslist.orderRemark = res.data.orderRemark
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (!this.orderexternalible && !this.orderinsideible) {
        this.reslist.orderRemark = this.reslist.orderRemark.filter((item) => item.remarkType == 1)
        this.reslist.orderRemark = this.reslist.orderRemark.filter((item) => item.remarkType == 0)
      }
      if (e.target.checked && !this.orderinsideible) {
        getOrderDetail({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.reslist.orderRemark = res.data.orderRemark
            this.reslist.orderRemark = this.reslist.orderRemark.filter((item) => item.remarkType == 1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (!e.target.checked && this.orderinsideible) {
        getOrderDetail({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.reslist.orderRemark = res.data.orderRemark
            this.reslist.orderRemark = this.reslist.orderRemark.filter((item) => item.remarkType == 0)
          } else {
            this.$message.error(res.msg)
          }
        })
        // console.log(this.reslist.orderRemark)
        // this.reslist.orderRemark
      }
    },
    orderinside(e) {
      if (!this.orderexternalible && !this.orderinsideible) {
        this.reslist.orderRemark = this.reslist.orderRemark.filter((item) => item.remarkType == 1)
        this.reslist.orderRemark = this.reslist.orderRemark.filter((item) => item.remarkType == 0)
      }
      if (this.orderexternalible && this.orderinsideible) {
        getOrderDetail({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.reslist.orderRemark = res.data.orderRemark
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (e.target.checked && !this.orderexternalible) {
        getOrderDetail({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.reslist.orderRemark = res.data.orderRemark
            this.reslist.orderRemark = this.reslist.orderRemark.filter((item) => item.remarkType == 0)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (!e.target.checked && this.orderexternalible) {
        getOrderDetail({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.reslist.orderRemark = res.data.orderRemark
            this.reslist.orderRemark = this.reslist.orderRemark.filter((item) => item.remarkType == 1)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 重新派单
    reassignment() {
      this.$confirm({
        title: '温馨提示',
        content: '您确定要重新派单吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          getagainDispatchOrder({
            orderId: this.reslist.orderId,
            procInstId: this.reslist.procInstId
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.showeditOrder(this.reslist.orderId, '', 1)
              this.$emit('ok')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    Statement(applyResult) {
      if (this.reslist.orderStatus == 'receiveOrder') {
        getreceiveOrder({
          applyResult: applyResult,
          orderId: this.reslist.orderId,
          procInstId: this.reslist.procInstId
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$emit('ok')
            getOrderDetail({
              orderId: this.reslist.orderId
            }).then((res) => {
              if (res.code == 0) {
                this.reslist = res.data
                this.reslist.orderStatus = res.data.orderStatus
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (this.reslist.orderStatus == 'dispatchOrder') {
        getdispatchOrder({
          applyResult: applyResult,
          orderId: this.reslist.orderId,
          procInstId: this.reslist.procInstId
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$emit('ok')
            getOrderDetail({
              orderId: this.reslist.orderId
            }).then((res) => {
              if (res.code == 0) {
                this.reslist = res.data
                this.reslist.orderStatus = res.data.orderStatus
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (this.reslist.orderStatus == 'reservationOrder') {
        getreservationOrder({
          applyResult: applyResult,
          orderId: this.reslist.orderId,
          procInstId: this.reslist.procInstId
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$emit('ok')
            getOrderDetail({
              orderId: this.reslist.orderId
            }).then((res) => {
              if (res.code == 0) {
                this.reslist = res.data
                this.reslist.orderStatus = res.data.orderStatus
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        this.salepicfileList = []
        this.orderId = id
        this.orderClientPic = [] // 客户照片
        this.clientVideo = [] // 客户视频
        // id 订单id   key打开第几个弹框 code 0查看 1编辑  orderSubStatusAll 审核按钮是否可用
        if (staType == 0) {
          console.log('ok92')
          this.staType = true
        } else {
          this.staType = false
        }
        // console.log(orderSubStatusAll)
        if (orderSubStatusAll) {
          if (orderSubStatusAll.split(',').indexOf('金额待审核') > -1) {
            this.orderSubStatus = false // 金额审核状态
          } else if (orderSubStatusAll.split(',').indexOf('金额待审核') == -1) {
            this.orderSubStatus = true
          }
        }
        if (this.reslist.orderStatus == 'installOrder') {
          getinstallOrder({
            applyResult: applyResult,
            orderId: this.reslist.orderId,
            procInstId: this.reslist.procInstId
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.$emit('ok')
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist = res.data
                  this.initialClientPhone = res.data.orderClient.clientPhone
                  this.reslist.orderStatus = res.data.orderStatus
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      }
      //  待安装状态点击跳转至结单调取销单接口
      if (this.reslist.orderStatus == 'installOrder') {
        this.installOrder(applyResult)
      }
    },
    getTimeClick(data, datastring) {
      console.log(datastring)
      this.disabledMinutes()
      this.disabledSeconds()
      this.timeString = datastring
    },
    // 启动提醒
    handleStart() {
      if (this.timeString == null || this.timeString == '') {
        this.$message.error('请选择提醒时间！')
      } else if (this.orderReminde.remark == '') {
        this.$message.error('请输入提醒内容！')
      } else {
        // var orderList = = this.reslist
        const orderRemind = {}
        orderRemind.installType = this.reslist.installType
        orderRemind.orderId = this.reslist.orderId
        orderRemind.orderNo = this.reslist.orderNo
        orderRemind.orderStatus = this.reslist.orderStatus
        orderRemind.orderType = this.reslist.orderType
        orderRemind.remindType = 1
        orderRemind.remark = this.orderReminde.remark
        orderRemind.appointmentTime = moment(new Date()).format('YYYY-MM-DD')
        orderRemind.timeQuantum = this.timeString
        addOrderRemindData(orderRemind).then((res) => {
          if (res.code == 0) {
            this.$message.success('启动成功！')
            this.getMoreList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 改价接口
    showformmoney(id) {
      this.salepicfileList = []
      this.formmoneymodalValuesList = []
      this.modifiedamountlist = []
      this.activeKey = '2'
      getchangePriceList({
        orderId: id
      }).then((res) => {
        if (res.code == 0) {
          // console.log("改价changePriceList", res.data)
          this.changePriceList = res.data
          if (!res.data.masterPrice || res.data.masterPrice.length == 0) {
            this.masterPricelength = []
          } else {
            this.masterPricelength = res.data.masterPrice.length
          }
          this.enterprisePricelength = res.data.enterprisePrice.length
          if (res.data.needAudit != 0) {
            this.reviewedAmount = true
            this.orderSubStatus = false
          } else {
            this.reviewedAmount = false
          }
          this.formmoney.resetFields()
          this.price_demand = ''
          // 查询金额要求列表
          if (this.changePriceList.orderTypeId) {
            getdemandlist({
              demandType: 'price_demand',
              orderType: this.changePriceList.orderTypeId,
              enterpriseId: this.changePriceList.enterpriseId
            }).then((res) => {
              if (res.code == 0) {
                this.price_demand = res.data.demandList.price_demand
              } else {
                this.$message.error(res.msg)
              }
            })
          }
          this.$nextTick(() => {
            this.formmoney.setFieldsValue(
              pick(
                res.data,
                'orderNo',
                'installType',
                'orderType',
                'count',
                'enterpriseName',
                'enterprisePrincipal',
                'enterpriseSettlementAount',
                'masterSettlementAount',
                'settlementDifference',
                'workerName',
                'workerPhone',
                'enterpriseTotalAmmount',
                'masterTotalAmount',
                'differAmount',
                'clientRequire',
                'broadbandAccount',
                'telecomPhone',
                'doorThickness',
                'counterVaneLength',
                'counterVaneWidth',
                'sparepart'
              )
            )
            this.spinning = false
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    init() {
      const dictTypes = [
        'refusal_order_reason',
        'close_order_type',
        'pay_status',
        'order_status',
        'settlement_status',
        'delivery_company',
        'pay_type',
        'settle_cycle',
        'reserve_failed_mark',
        'no_settle_reason'
      ]
      console.log('编辑使用接口2')

      getfinddictAll({
        dictTypes: dictTypes.join()
      }).then((res) => {
        this.delivery_company = res.delivery_company
        this.settle_cycle = res.settle_cycle
        this.order_status = res.order_status
        this.refusal_order_reason = res.refusal_order_reason
        this.pay_type = res.pay_type
        this.close_order_type = res.close_order_type
        this.settlement_status = res.settlement_status
        this.pay_status = res.pay_status
        this.reserve_failed = res.reserve_failed_mark
        this.no_settle_reason = res.no_settle_reason
      })
    },
    // 编辑
    showeditOrder(id, key, code, orderSubStatusAll, auditStatus, staType, backlogStatu, heXiao) {
      this.init()
      getselectAllProvince().then((res) => {
        if (res.code == 0) {
          this.selectAllProvince = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      getEzvizEnterpriseIdListApi().then(res => {
        this.idsYS = res.data
      })
      this.userType = store.getters.userType
      window.addEventListener('scroll', this.handleScroll, true)
      if (this.isRefresh) {
        this.spinning = true
      }
      this.remark = {}
      this.orderremark = {}

      this.button1 = 0 // 通过
      this.button2 = 0 // 不通过
      this.backlogNum = backlogStatu
      this.heXiaoValue = heXiao
      this.disClick1 = false // 通过 禁用
      this.disClick2 = false // 不通过 禁用
      this.salepicList.forEach((item) => {
        item.salepicfileList = [] // 销单资料 图片
      })
      this.logisticsInfo = {} // 销单资料 旧件返厂
      this.salepicfileList = []
      this.orderId = id
      this.orderClientPic = [] // 客户照片
      this.clientVideo = [] // 客户视屏
      // id 订单id   key打开第几个弹框 code 0查看 1编辑  orderSubStatusAll 审核按钮是否可用
      if (staType == 0) {
        console.log('ok92')
        this.staType = true
      } else {
        this.staType = false
      }
      // console.log(orderSubStatusAll)
      if (orderSubStatusAll) {
        if (orderSubStatusAll.split(',').indexOf('金额待审核') > -1) {
          this.orderSubStatus = false // 金额审核状态
        } else if (orderSubStatusAll.split(',').indexOf('金额待审核') == -1) {
          this.orderSubStatus = true
        }
      } else {
        this.orderSubStatus = true
      }
      // console.log(this.orderSubStatus)
      // console.log(auditStatus)
      if (auditStatus) {
        if (auditStatus == '待审核') {
          this.orderSubStatus = false
        } else {
          this.orderSubStatus = true
        }
      }
      // console.log(this.orderSubStatus)
      this.activeKey = '1'
      this.editOrderShow = code // 右下角发起、企业要求 是否可编辑
      this.reserveTimePartChange = ''
      // console.log(this.editOrderShow)
      this.form.resetFields()
      this.orderClientform.resetFields() //  1. 客户信息
      this.informationMasterform.resetFields() // 1. 师傅信息
      this.formmoney.resetFields() // 2.金额信息
      this.falg = false // 2.是否可编辑 金额信息 新增、改价、修改
      this.examinefalg = false // 2.是否可编辑 金额信息 审核通过、不通过
      this.reviewedAmount = false // 2.金额信息 金额待审核 状态
      if (key == undefined) {
        this.activeKey = '1'
      }
      this.userIdWriteoff = store.getters.userId
      this.falg = false
      // console.log('showeditOrder,', id, ', ', key, typeof key)
      if (key == 2) {
        this.showformmoney(id) // 金额信息 回显接口
      }

      if (!this.isRefresh) {
        getisOrderOpened({
          orderId: id
        }).then((res) => {
          if (res.code == 0) {
            this.isOrderOpenedmsg = res.msg // 1.订单详情 顶部 最近打开人 数据
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (this.$route.path == '/order/qyOrderDetail') {
        this.editOrderible = false
      } else {
        // 订单详情接口
        getOrderDetail({ orderId: id }).then((res) => {
          if (res.code == 0) {
            this.editOrderible = true // 打开订单详情弹框
            this.reslist = res.data
            // 初始化是否有导向片
            let isCV = this.reslist.isCounterVane !== undefined && this.reslist.isCounterVane !== null ? this.reslist.isCounterVane : 1
            if (isCV === 1 && ((this.reslist.counterVaneLength && this.reslist.counterVaneLength > 0) ||
              (this.reslist.counterVaneWidth && this.reslist.counterVaneWidth > 0))) {
              isCV = 0
            }
            this.showCounterVaneFields = (isCV === 0)

            if (this.reslist.foreignType == 6) {
              // 萤石订单逻辑已移动到 EzvizSnModal 组件
            }

            console.log('this.reslist.orderMaster', this.reslist.orderMaster)
            this.fitStatus = this.reslist.isBack
            this.reslist.enterpriseSendBackId = String(this.reslist.enterpriseSendBackId)
            this.orderTypeInit = this.reslist.orderType
            this.installationInfoList = this.reslist.installCustomize
            console.log('installCustomize', this.reslist.installCustomize)
            console.log('reslist+masterRemark', this.reslist, this.reslist.masterRemark)

            this.getMoreList()
            this.hodleOrderEditStuda = res.data.hangUpStatus // 订单挂起状态
            // 预约失败原因
            this.reserveFailureReason = this.reslist.reserveFailureReason
            // 预约失败类型
            this.reserveFailureType = this.reslist.reserveFailureType
            this.enterpriseId = this.reslist.enterpriseId
            const isIdInArray = this.idsYS.includes(this.enterpriseId)
            this.isYS = isIdInArray
            // 获取寄回要求数据
            getSendBackList({ enterpriseId: this.enterpriseId }).then((res) => {
              if (res.code == 0) {
                this.sendBackList = res.data
                this.form.setFieldsValue(pick(this.reslist, 'enterpriseSendBackId'))
              } else {
                this.$message.error(res.msg)
              }
            })
            // 新增配件——配件信息下拉
            // this.EnterpriseAccessory = []
            console.log(111111111, this.isRefresh, this.reslist)

            if (!this.isRefresh) {
              this.spinning = true
              this.flagId = this.reslist.brandId
              this.$nextTick(() => {
                // 1.客户信息
                this.initialClientPhone = this.reslist.orderClient.clientPhone
                this.orderClientform.setFieldsValue(
                  pick(
                    this.reslist.orderClient,
                    'clientName',
                    'clientPhone',
                    'virtualClientPhone',
                    'installTimePart',
                    'provinceId',
                    'cityId',
                    'countyId',
                    'clientAddress',
                    'clientRequire',
                    'broadbandAccount',
                    'telecomPhone'
                  )
                )
                if (this.pay_type.length == 0) {
                  console.log('编辑使用接口3')

                  getfinddictAll({
                    dictTypes: 'pay_type'
                  }).then((res) => {
                    this.pay_type = res.pay_type
                    this.form.setFieldsValue(pick(this.reslist, 'payType'))
                  })
                }
                console.log(222222, this.reslist.orderClient, this.orderClientform)

                // 2.基础订单信息
                this.form.setFieldsValue({
                  isCounterVane: this.showCounterVaneFields ? 0 : 1
                })
                this.form.setFieldsValue(
                  pick(
                    this.reslist,
                    'payType',
                    'originalOrderNo',
                    'serialNumber',
                    'serialNumberMerchant',
                    'checkTime',
                    'intervenTime',
                    'orderNo',
                    'number',
                    'orderFinishTime',
                    'userName',
                    'createTime',
                    'enterpriseId',
                    'helperName',
                    'isUserOrder',
                    'ctei',
                    'purchaseOfStore',
                    'caseCode',
                    'oldPartCode',
                    'courierNumber',
                    'sourceEnterpriseName',
                    'guaranteeTime',
                    'enterpriseSettleStatus',
                    'orderStatusStr',

                    'enterpriseSettleTime',
                    'firstValue',
                    'secondValue',
                    'thirdValue',
                    'doorThickness',
                    'counterVaneLength',
                    'counterVaneWidth',
                    'sparepart'
                  )
                )
                // 期望安装时间
                if (this.reslist.orderClient.installTime) {
                  this.installTimeedit = this.reslist.orderClient.installTime
                  this.orderClientform.setFieldsValue({
                    expectinstallTime: moment(this.reslist.orderClient.installTime)
                  })
                }
                // 1.企业结算周期 、企业名称
                this.form.setFieldsValue(pick(this.reslist.enterprise, 'enterpriseSettlementType', 'enterpriseName'))
                // 1.销单码
                this.form.setFieldsValue(pick(this.reslist.orderMaster, 'saleCode'))
                // 购买渠道、信息来源、品牌
                this.selectChannel = []
                this.selectSource = []
                this.selectBrand = []
                this.time1 = null
                this.time3 = null
                // 订单详情 查询企业品牌，渠道，信息来源
                selectEnterpriseinfo({
                  installType: this.reslist.installType,
                  enterpriseId: this.enterpriseId
                }).then((res) => {
                  // console.log(res)
                  this.selectChannel = res.data.channel
                  this.selectSource = res.data.source
                  this.selectBrand = res.data.brand
                  // this.$nextTick(() => {
                  this.form.setFieldsValue(pick(this.reslist, 'brandId', 'infoSourceId', 'buyChannelId'))
                  this.spinning = false
                  // })
                })
                // 安装类别
                getenterpriseInstallTypes({
                  enterpriseId: this.reslist.enterpriseId
                }).then((res) => {
                  if (res.code == 0) {
                    this.installTypes = res.data
                    this.form.setFieldsValue(pick(this.reslist, 'installType'))
                  } else {
                    this.$message.error(res.msg)
                  }
                })
                // 旧件返厂
                getEnterpriseContactsById({ enterpriseId: this.reslist.enterpriseId }).then((res) => {
                  if (res.code == 0) {
                    this.address_type = res.data
                    this.form.setFieldsValue(pick(this.reslist, 'enterpriseAddressId'))
                  } else {
                    this.$message.error(res.msg)
                  }
                })
                // 型号下拉
                this.selectModel = []
                if (this.reslist.brandId) {
                  getSelectModel({
                    brandId: this.reslist.brandId
                  }).then((res) => {
                    if (res.code == 0) {
                      this.selectModel = res.data
                      // this.$nextTick(() => {
                      this.form.setFieldsValue(pick(this.reslist, 'modelId'))
                      this.updateModelSpecs(this.reslist.modelId)
                      // })
                      // console.log(res)
                    } else {
                      this.$message.error(res.msg)
                    }
                  })
                }
                // 订单类型
                this.List = []
                getList(this.reslist.installType).then((res) => {
                  if (res.code == 0) {
                    this.List = res.rows
                    const item = this.List.find(r => r.orderTypeId == this.reslist.orderType)
                    this.orderTypeName = item ? item.typeName : ''
                    this.$nextTick(() => {
                      this.form.setFieldsValue(pick(this.reslist, 'orderType'))
                    })
                    /* console.log(res.rows) */
                  } else {
                    this.$message.error(res.msg)
                  }
                })
                //  todo3
                // 安装师傅信息
                this.informationMasterform.setFieldsValue(
                  pick(this.reslist.installMasterInfo, 'installName', 'phoneNumber', 'creditScore')
                )

                // 1. 师傅信息
                this.informationMasterform.setFieldsValue(
                  pick(this.reslist.orderMaster, 'workName', 'reserveTimePart', 'workPhone', 'cashCycle', 'signAddress')
                )

                this.informationMasterform.setFieldsValue(
                  pick(this.reslist, 'masterSettleTime', 'turnBack', 'masterSettleStatus', 'reserveFailureType')
                )
                // 企业要求
                this.geterpriseDemand()

                if (this.reslist.orderMaster) {
                  this.masterDisabled = false
                  // 上门预约时间
                  if (this.reslist.orderMaster.reserveTime != null) {
                    this.reserveTimePartChange = this.reslist.orderMaster.reserveTime
                    this.informationMasterform.setFieldsValue({
                      reserveTime: moment(this.reslist.orderMaster.reserveTime)
                    })
                  } else {
                    this.informationMasterform.setFieldsValue({
                      reserveTime: null
                    })
                  }
                  // 照片上传时间
                  if (this.reslist.orderMaster.picUploadTime != null) {
                    this.time1 = this.reslist.orderMaster.picUploadTime
                    this.informationMasterform.setFieldsValue({
                      picUploadTime: moment(this.reslist.orderMaster.picUploadTime)
                    })
                  } else {
                    this.time1 = this.reslist.orderMaster.picUploadTime
                    this.informationMasterform.setFieldsValue({
                      picUploadTime: null
                    })
                  }
                  // 接单时间
                  if (this.reslist.orderMaster.acceptTime != null) {
                    this.time2 = this.reslist.orderMaster.acceptTime
                    this.informationMasterform.setFieldsValue({
                      acceptTime: moment(this.reslist.orderMaster.acceptTime)
                    })
                  } else {
                    this.informationMasterform.setFieldsValue({
                      acceptTime: null
                    })
                  }
                  // 销单时间
                  if (this.reslist.orderMaster.saleTime != null) {
                    this.time3 = this.reslist.orderMaster.saleTime
                    this.informationMasterform.setFieldsValue({
                      saleTime: moment(this.reslist.orderMaster.saleTime)
                    })
                  } else {
                    this.time3 = this.reslist.orderMaster.saleTime
                    this.informationMasterform.setFieldsValue({
                      saleTime: null
                    })
                  }
                  // if (this.reslist.orderMaster.signTime != null) {
                  //   //
                  //   if (this.reslist.foreignType == 0 ) {
                  //     this.informationMasterform.setFieldsValue({
                  //       signTime: this.time4,
                  //     })
                  //   } else {

                  //     this.time4 = this.reslist.orderMaster.signTime
                  //     this.informationMasterform.setFieldsValue({
                  //       signTime: moment(this.reslist.orderMaster.signTime),
                  //     })
                  //   }

                  // } else {
                  //   this.informationMasterform.setFieldsValue({
                  //     signTime: null,
                  //   })
                  // }

                  // if (this.reslist.orderMaster.signTime&&this.reslist.foreignType == 0&& (this.reslist.orderStatus == 'installOrder' || this.reslist.orderStatus == 'reservationOrder') && this.reslist.orderMaster.signStatus == 0) {
                  //     this.informationMasterform.setFieldsValue({
                  //       signTime: this.time4?this.time4:moment(this.reslist.orderMaster.signTime),
                  //     })
                  //   } else

                  if (this.reslist.orderMaster.signTime) {
                    this.time4 = this.reslist.orderMaster.signTime
                    this.informationMasterform.setFieldsValue({
                      signTime: moment(this.reslist.orderMaster.signTime)
                    })
                  } else {
                    this.informationMasterform.setFieldsValue({
                      signTime: null
                    })
                  }
                } else {
                  this.masterDisabled = true
                  this.informationMasterform.setFieldsValue({
                    reserveTime: null,
                    picUploadTime: null,
                    acceptTime: null,
                    saleTime: null
                  })
                }
              })
            } else {
              // 初始化是否有导向片
              let isCV = 1
              if ((this.reslist.counterVaneLength && this.reslist.counterVaneLength > 0) ||
                (this.reslist.counterVaneWidth && this.reslist.counterVaneWidth > 0)) {
                isCV = 0
              }
              this.showCounterVaneFields = (isCV === 0)
              this.$nextTick(() => {
                // 1.客户信息
                this.initialClientPhone = this.reslist.orderClient.clientPhone
                this.orderClientform.setFieldsValue(
                  pick(
                    this.reslist.orderClient,
                    'clientName',
                    'clientPhone',
                    'virtualClientPhone',
                    'installTimePart',
                    'provinceId',
                    'cityId',
                    'countyId',
                    'clientAddress',
                    'clientRequire',
                    'broadbandAccount',
                    'telecomPhone'
                  )
                )
                // 2.基础订单信息
                this.form.setFieldsValue({
                  isCounterVane: this.showCounterVaneFields ? 0 : 1
                })
                this.form.setFieldsValue(
                  pick(
                    this.reslist,
                    'originalOrderNo',
                    'serialNumber',
                    'serialNumberMerchant',
                    'installType',
                    'infoSourceId',
                    'checkTime',
                    'payType',
                    'enterpriseAddressId',
                    'intervenTime',
                    'orderNo',
                    'number',
                    'orderFinishTime',
                    'userName',
                    'createTime',
                    'enterpriseId',
                    'helperName',
                    'isUserOrder',
                    'ctei',
                    'purchaseOfStore',
                    'courierNumber',
                    'sourceEnterpriseName',
                    'guaranteeTime',
                    'enterpriseSettleStatus',
                    'orderStatusStr',
                    'isBack',
                    'enterpriseSettleTime',
                    'firstValue',
                    'secondValue',
                    'thirdValue',
                    'brandId',
                    'buyChannelId',
                    'orderType',
                    'doorThickness',
                    'counterVaneLength',
                    'counterVaneWidth',
                    'sparepart'
                  )
                )
                this.spinning = false
                // 期望安装时间
                if (this.reslist.orderClient.installTime) {
                  this.installTimeedit = this.reslist.orderClient.installTime
                  this.orderClientform.setFieldsValue({
                    expectinstallTime: moment(this.reslist.orderClient.installTime)
                  })
                }
                // 型号下拉
                if (this.reslist.brandId && this.flagId != this.reslist.brandId) {
                  getSelectModel({
                    brandId: this.reslist.brandId
                  }).then((res) => {
                    if (res.code == 0) {
                      // this.spinning = false
                      this.selectModel = res.data
                      // this.$nextTick(() => {
                      this.form.setFieldsValue(pick(this.reslist, 'modelId'))
                      this.updateModelSpecs(this.reslist.modelId)
                      // })
                      // console.log(res)
                    } else {
                      this.$message.error(res.msg)
                    }
                  })
                } else {
                  this.form.setFieldsValue(pick(this.reslist, 'modelId'))
                  this.updateModelSpecs(this.reslist.modelId)
                }
                //  else {
                // this.spinning = false
                // }
                // 1.企业结算周期 、企业名称
                this.form.setFieldsValue(pick(this.reslist.enterprise, 'enterpriseSettlementType', 'enterpriseName'))
                // 1.销单码
                this.form.setFieldsValue(pick(this.reslist.orderMaster, 'saleCode'))

                //  todo3
                // 安装师傅信息
                this.informationMasterform.setFieldsValue(
                  pick(this.reslist.installMasterInfo, 'installName', 'phoneNumber', 'creditScore')
                )
                // 1. 师傅信息
                this.informationMasterform.setFieldsValue(
                  pick(this.reslist.orderMaster, 'workName', 'reserveTimePart', 'workPhone', 'cashCycle', 'signAddress')
                )
                this.informationMasterform.setFieldsValue(
                  pick(this.reslist, 'turnBack', 'masterSettleTime', 'masterSettleStatus', 'reserveFailureType')
                )

                if (this.reslist.orderMaster) {
                  this.masterDisabled = false
                  // 上门预约时间
                  if (this.reslist.orderMaster.reserveTime != null) {
                    this.reserveTimePartChange = this.reslist.orderMaster.reserveTime
                    this.informationMasterform.setFieldsValue({
                      reserveTime: moment(this.reslist.orderMaster.reserveTime)
                    })
                  } else {
                    this.informationMasterform.setFieldsValue({
                      reserveTime: null
                    })
                  }
                  // 照片上传时间
                  if (this.reslist.orderMaster.picUploadTime != null) {
                    this.time1 = this.reslist.orderMaster.picUploadTime
                    this.informationMasterform.setFieldsValue({
                      picUploadTime: moment(this.reslist.orderMaster.picUploadTime)
                    })
                  } else {
                    this.time1 = this.reslist.orderMaster.picUploadTime
                    this.informationMasterform.setFieldsValue({
                      picUploadTime: null
                    })
                  }
                  // 接单时间
                  if (this.reslist.orderMaster.acceptTime != null) {
                    this.time2 = this.reslist.orderMaster.acceptTime
                    this.informationMasterform.setFieldsValue({
                      acceptTime: moment(this.reslist.orderMaster.acceptTime)
                    })
                  } else {
                    this.informationMasterform.setFieldsValue({
                      acceptTime: null
                    })
                  }
                  // 销单时间
                  if (this.reslist.orderMaster.saleTime != null) {
                    this.time3 = this.reslist.orderMaster.saleTime
                    this.informationMasterform.setFieldsValue({
                      saleTime: moment(this.reslist.orderMaster.saleTime)
                    })
                  } else {
                    this.time3 = this.reslist.orderMaster.saleTime
                    this.informationMasterform.setFieldsValue({
                      saleTime: null
                    })
                  }

                  if (this.reslist.orderMaster.signTime) {
                    this.time4 = this.reslist.orderMaster.signTime
                    this.informationMasterform.setFieldsValue({
                      signTime: moment(this.reslist.orderMaster.signTime)
                    })
                  } else {
                    this.informationMasterform.setFieldsValue({
                      signTime: null
                    })
                  }
                } else {
                  this.masterDisabled = true
                  this.informationMasterform.setFieldsValue({
                    reserveTime: null,
                    picUploadTime: null,
                    acceptTime: null,
                    saleTime: null
                  })
                }
              })
            }

            // 是否展示 核销信息Tab页
            if (this.reslist.orderMaster != null) {
              this.masterStatus = true
            } else {
              this.masterStatus = false
            }
            // 订单加急
            if (this.reslist.isUrgentOrder) {
              this.isUrgentOrder = this.reslist.isUrgentOrder
            }
            // 重要订单
            if (this.reslist.isMainOrder) {
              this.orderImportantbool = this.reslist.isMainOrder == 1
            }
            // 短信提醒
            if (this.reslist.isSmsWarn) {
              this.isSmsWarnbool = this.reslist.isSmsWarn == 1
            }
            // 产品条形码
            if (this.reslist.isSerialNotice) {
              this.isSerialNotice = this.reslist.isSerialNotice == 1
            }
            // 旧件返厂
            if (this.reslist.factoryStatus) {
              this.factoryStatus = this.reslist.factoryStatus == 1
            }
            // 暂不结算
            if (this.reslist.isTemporarilySettle) {
              this.showisTemporarilySettleDanger = this.reslist.isTemporarilySettle == 1
            }

            // 代办事项内容
            getmyPendingMatters({
              orderId: this.reslist.orderId
            }).then((res) => {
              if (res.code == 0) {
                this.myPendingMatters = res.data
                // console.log(res.data)
              } else {
                this.$message.error(res.msg)
              }
            })

            if (this.reslist.clientVideo) {
              this.clientVideo = []
              this.reslist.clientVideo.forEach((pic) => {
                this.clientVideo.push(pic.costmVideoUrl)
              })
            }
            if (this.reslist.clientPic) {
              const that = this
              this.reslist.clientPic.forEach((pic) => {
                console.log('pic', pic.costmPicUrl)
                // that.getImgToBase64(pic.costmPicUrl,function(data) {
                //   console.log('data',data)
                that.orderClientPic.push({
                  uid: pic.costmPicId,
                  thumbUrl: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + pic.costmPicUrl,
                  url: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + pic.costmPicUrl
                })
                // })
              })
            }
            // 师傅备注 图片回显
            if (this.reslist.masterRequirePic) {
              const that = this
              this.fileListMaster = []
              this.reslist.masterRequirePic.forEach((pic) => {
                // that.getImgToBase64(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + pic.costmPicUrl +
                //   '&token=' + Vue.ls.get(ACCESS_TOKEN),
                //   function(data) {
                that.fileListMaster.push({
                  uid: pic.costmPicId,
                  thumbUrl: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + pic.costmPicUrl,
                  url: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + pic.costmPicUrl
                })
                // })
              })
            }

            // 市
            getselectCityName({
              provinceCode: this.reslist.orderClient.provinceId
            }).then((res) => {
              if (res.code == 0) {
                /* console.log(res) */
                this.selectCityName = res.rows
              } else {
                this.$message.error(res.msg)
              }
            })
            // 区
            getselectAreaName({
              cityCode: this.reslist.orderClient.cityId
            }).then((res) => {
              if (res.code == 0) {
                /* console.log(res) */
                this.selectAreaName = res.rows
              } else {
                this.$message.error(res.msg)
              }
            })
            // 1. 关联订单
            getsearchOrderRelation({
              orderId: this.reslist.orderId,
              clientAddress: this.reslist.orderClient.clientAddress,
              clientPhone: this.reslist.orderClient.clientPhone,
              installType: this.reslist.installType
            }).then((res) => {
              if (res.code == 0) {
                this.relationList = res.data.orderList // 关联订单
                this.orderType = res.data.orderType // 关联订单 操作栏切换
                this.$nextTick(() => {
                  // console.log(auditStatus,this.relationList.length)
                  if (auditStatus == '待审核' && this.relationList.length > 0 && this.associatedOrderQuery) {
                    this.$message.success('此订单有关联订单')
                  }
                })
              } else {
                this.$message.error(res.msg)
              }
            })
            // console.time('2')
          } else {
            this.$message.error(res.msg)
          }
        })
      }

      /* 企业  下来框改变时 */
      // if(this.reslist){}
      if (key == 4) {
        const _this = this
        this.$nextTick(() => {
          _this.callback('4')
        })
      }
    },
    // 打开萤石弹窗
    async openYsSnSetting() {
      this.$refs.ezvizSnModal.open()
    },


    // 冻结订单
    selectOrderFrozen() {
      this.$refs.selectorderfrozen.showselectOrderFrozen(this.reslist.orderId)
    },
    settleAfterboolboolchange(e) {
      this.settleAfterboolbool = e.target.checked
    },
    quickProcess(type, matterCode, pendingId) {
      if (type == 1) {
        this.button2 = 1
        this.disClick1 = true
      } else if ((type = 2)) {
        this.disClick2 = true
        this.button1 = 1
      }
      this.quickProcessvalue.status = type
      this.quickProcessvalue.orderStatus = this.reslist.orderStatus
      this.quickProcessvalue.procInstId = this.reslist.procInstId
      this.quickProcessvalue.pendingId = pendingId
      this.quickProcessvalue.matterCode = matterCode
      getquickProcess(this.quickProcessvalue).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showmyPendingMatters() {
      this.showmyPendingMattersible = !this.showmyPendingMattersible
    },
    complaintrevoke(record) {
      console.log(111111111, record)
      this.$refs.compalanit.revoke(record)
    },
    complaintDealing(record) {
      this.$refs.compalanit.problemsDealing(record)
    },
    complaintTransfer(record) {
      this.$refs.compalanit.problemsTransfer(record)
    },
    complaintresume(record) {
      this.$refs.compalanit.resume(record)
    },
    revoke(record) {
      this.$refs.feedbackorder.revoke(record)
    },
    problemsDealing(record) {
      // console.log(record.handlingStatus)
      this.$refs.feedbackorder.problemsDealing(record)
    },
    problemsTransfer(record) {
      this.$refs.feedbackorder.problemsTransfer(record)
    },
    resume(record) {
      this.$refs.feedbackorder.resume(record)
    },
    disablesale(id, Status) {
      getdisablesale({
        typeId: id,
        forbiddenStatus: Status
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          getsaleOrderData({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.salepicList = res.data.picList
              this.logisticsInfo = res.data.logisticsInfo
              this.salepicList.forEach((item) => {
                item.salepicfileList = []
              })
              this.salevideoList = res.data.videoList
              // this.$message.error(res.msg);
              console.log(this.logisticsInfo, 'this.logisticsInfothis.logisticsInfo')
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    deletesale(type, id, url) {
      if (type == 'salevideoList') {
        this.salevideoList.forEach((item) => {
          if (item.infoPath) {
            if (item.infoPath.length > 0) {
              item.infoPath.forEach((tab) => {
                if (tab == url) {
                  item.infoPath.splice(url, 1)
                }
              })
            }
          }
        })
      }
      if (type == 'salepicList') {
        this.salepicList.forEach((item) => {
          if (item.infoPath) {
            if (item.infoPath.length > 0) {
              item.infoPath.forEach((tab) => {
                if (tab == url) {
                  item.infoPath.splice(url, 1)
                }
              })
            }
          }
        })
      }

      getdeletesale({
        cosmtId: id
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          getsaleOrderData({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              // this.salepicList = res.data.picList
              // console.log(44444444,isIdInArray,this.idsYS,this.enterpriseId)
              this.salepicList = this.isYS ? res.data.picList : res.data.picList.filter(item => item.infoName == '安装后')
              this.logisticsInfo = res.data.logisticsInfo
              this.salepicList.forEach((item) => {
                item.salepicfileList = []
              })
              this.salevideoList = res.data.videoList
              // this.salevideoList =isIdInArray ? res.data.videoList : res.data.videoList.filter(item => item.infoName == '安装后')
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    complainthandleChange(info) {
      this.$nextTick(() => {
        this.problemfileList = info.fileList
      })
      if (info.file.status == 'removed') {
        if (info.file.response.code == 0) {
          const index = this.complaintfilelist.indexOf(info.file.response.url)
          this.complaintfilelist.splice(index, 1)
        }
      }
      if (info.file.status == 'done') {
        if (info.file.response.code == 0) {
          let list = {}
          list.url = info.file.response.url
          list.uid = info.fileList[0].uid
          list.name = info.fileList[0].name
          list = JSON.stringify(list)
          this.complaintfilelist.push(list)
          console.log(this.complaintfilelist)
        }
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status == 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    videoCurrencyhandleChange(info) {
      if (info.file.status == 'removed') {
        if (info.file.response.code == 0) {
          const index = this.clientVideo.indexOf(info.file.response.url)
          this.clientVideo.splice(index, 1)
        }
      }
      if (info.file.status == 'done') {
        // info.file.response.url = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + info.file.response.url
        this.clientVideo.push(info.file.response.url)
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status == 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    picCurrencyhandleChange(info) {
      // console.log(info.file.status)
      if (info.file.status == 'removed' && !this.addCustomerPic) {
        this.$message.error('没有权限')
      } else {
        this.$nextTick(() => {
          this.orderClientPic = info.fileList
        })
        if (info.file.status == 'done') {
          this.$message.success(`${info.file.name}上传成功`)
        } else if (info.file.status == 'error') {
          this.$message.error(`${info.file.name} 上传失败.`)
        }
      }
    },
    previewhandleCancel() {
      this.previewVisible = false
    },

    handleChange({ fileList }) {
      this.fileList = fileList
    },
    beforeUpload(file) {
      // console.log(file)
      const isJpgOrPng = file.type == 'image/jpeg' || file.type == 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        return false
      }
    },
    // 旧件寄回-图片
    pictureCardBeforeUpload(file, fileList) {
      // 长度要加上已上传的文件列表的长度
      const isLimit = this.courierImgArr.length + fileList.length > 3
      const indexOfFile = this.courierImgArr.findIndex((item) => item.uid == file.uid) + this.fileList.length
      console.log(isLimit, indexOfFile)
      if (isLimit && indexOfFile == 3) {
        file.statusText = '最多上传' + 3 + '张图片'
        return false
      }
    },
    // 单号照片上传
    changeCourierImg({ fileList }) {
      this.courierImgArr = fileList
    },
    // 返厂照片上传
    changeFactoryImg({ fileList }) {
      this.factoryImgArr = fileList
    },
    signatureChange({ fileList }) {
      this.signatureFileList = fileList
      this.signatureShow = this.signatureFileList.length != 0
      // console.log('签字-图片-change',this.signatureFileList,this.signatureShow)
    },
    salepichandleChange(infoName, infoPath, info, index) {
      this.$nextTick(() => {
        this.salepicList[index].salepicfileList = info.fileList
      })
      this.salepicList = _.cloneDeep(this.salepicList)
      if (info.file.status == 'removed') {
        if (info.file.response.code == 0) {
          this.salepicList.forEach((tab) => {
            if (tab.infoName == infoName) {
              const index = tab.infoPath.indexOf(info.file.response.url)
              tab.infoPath.splice(index, 1)
            }
          })
        }
      }

      if (info.file.status == 'done') {
        if (info.file.response.code == 0) {
          this.salepicList.forEach((tab) => {
            if (tab.infoName == infoName) {
              if (tab.infoPath) {
                tab.infoPath.push(info.file.response.url)
                console.log(tab.infoPath)
              } else {
                tab.infoPath = []
                tab.infoPath.push(info.file.response.url)
              }
            }
          })
        }
        // console.log(this.salepicList)
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status == 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },

    salevideohandleChange(infoName, infoPath, info) {
      if (info.file.status == 'removed') {
        if (info.file.response.code == 0) {
          this.salevideoList.forEach((tab) => {
            if (tab.infoName == infoName) {
              const index = tab.infoPath.indexOf(info.file.response.url)
              tab.infoPath.splice(index, 1)
            }
          })
        }
      }
      if (info.file.status == 'done') {
        if (info.file.response.code == 0) {
          this.salevideoList.forEach((tab) => {
            if (tab.infoName == infoName) {
              if (tab.infoPath) {
                tab.infoPath.push(info.file.response.url)
              } else {
                tab.infoPath = []
                tab.infoPath.push(info.file.response.url)
              }
            }
          })
        }
        this.salevideoList.forEach((tab) => {
          if (tab.infoName == infoName) {
            this.uploadVideo.push(info.file.response.url)
            tab.clientVideo = this.uploadVideo
          } else {
            this.uploadVideo = []
          }
        })
        this.salevideoList = _.cloneDeep(this.salevideoList)
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status == 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    saleDataSave() {
      this.logisticsInfo.courierImg = this.courierImgArr
        .map((item) => (item.response ? item.response.url : item.url1 ? item.url1 : ''))
        .join(',')
      this.logisticsInfo.factoryImg = this.factoryImgArr
        .map((item) => (item.response ? item.response.url : item.url1 ? item.url1 : ''))
        .join(',')
      this.saleDataSaveobj.picList = this.salepicList
      this.saleDataSaveobj.videoList = this.salevideoList
      this.saleDataSaveobj.logisticsInfo = this.logisticsInfo
      this.saleDataSaveobj.orderId = this.reslist.orderId
      if (this.reslist.factoryEnterpriseType == 0) {
        if (
          (this.logisticsInfo.courierNumber != '' &&
            this.logisticsInfo.courierImg != '' &&
            this.logisticsInfo.factoryImg != '') ||
          (this.logisticsInfo.courierNumber == '' &&
            this.logisticsInfo.courierImg == '' &&
            this.logisticsInfo.factoryImg == '')
        ) {
          getsaleDataSave(this.saleDataSaveobj).then((res) => {
            if (res.code == 0) {
              this.salepicfileList = []
              this.$message.success('提交成功')
              getsaleOrderData({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.salepicList = res.data.picList
                  if (res.data.logisticsInfo == null) {
                    this.logisticsInfo = {}
                  } else {
                    this.logisticsInfo = res.data.logisticsInfo
                  }
                  this.salevideoList = res.data.videoList
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('旧件返厂资料填写不完整!')
        }
      } else {
        if (
          (this.logisticsInfo.courierNumber != '' && this.logisticsInfo.courierImg != '') ||
          (this.logisticsInfo.courierNumber == '' && this.logisticsInfo.courierImg == '')
        ) {
          console.log(123)
          this.saleDataSaveobj.serialNumber = this.serialNumber
          getsaleDataSave(this.saleDataSaveobj).then((res) => {
            if (res.code == 0) {
              this.salepicfileList = []
              this.$message.success('提交成功')
              getsaleOrderData({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.salepicList = res.data.picList
                  if (res.data.logisticsInfo == null) {
                    this.logisticsInfo = {}
                  } else {
                    this.logisticsInfo = res.data.logisticsInfo
                  }
                  this.salevideoList = res.data.videoList
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('旧件返厂资料填写不完整!')
        }
      }
    },
    OrderUrgentOk(isUrgentOrder) {
      this.isUrgentOrder = isUrgentOrder
      getorderUrgent({
        enterpriseId: this.form.getFieldValue('enterpriseId'),
        installType: this.form.getFieldValue('installType'),
        orderId: this.reslist.orderId,
        isUrgentOrder: isUrgentOrder
      }).then((res) => {
        if (res.code == 0) {
          this.OrderUrgentible = false
          // console.log(res)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 订单加急
    orderUrgentByMoney(isUrgentOrder) {
      this.isUrgentOrder = isUrgentOrder

      if (this.formOrderUrgent.getFieldValue('usefulUrgentNum') > 0) {
        getorderUrgent({
          enterpriseId: this.form.getFieldValue('enterpriseId'),
          installType: this.form.getFieldValue('installType'),
          orderId: this.reslist.orderId,
          isUrgentOrder: isUrgentOrder
        }).then((res) => {
          if (res.code == 0) {
            this.OrderUrgentible = false
            this.showeditOrder(this.reslist.orderId, '', 1)
            this.$message.success('订单加急成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        getorderUrgentByMoney({
          orderId: this.reslist.orderId,
          urgentMoney: this.formOrderUrgent.getFieldValue('urgentMoney')
        }).then((res) => {
          if (res.code == 0) {
            this.OrderUrgentible = false
            this.showeditOrder(this.reslist.orderId, '', 1)
            this.$message.success('订单加急成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    isOrderUrgent() {
      if (this.form.getFieldValue('enterpriseId') && this.form.getFieldValue('installType')) {
        getcheckOrderUrgent({
          enterpriseId: this.form.getFieldValue('enterpriseId'),
          installType: this.form.getFieldValue('installType')
        }).then((res) => {
          if (res.code == 0) {
            if (res.usefulUrgentNum == 0) {
              this.$message.success('本月可使用加急数:' + res.usefulUrgentNum)
            }
            this.OrderUrgentible = true
            this.formOrderUrgent.resetFields()
            this.$nextTick(() => {
              this.formOrderUrgent.setFieldsValue(
                pick(res, 'usedUrgentNum', 'urgentMoney', 'usefulUrgentNum', 'totalUrgentNum')
              )
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请选择企业名称和安装类别')
      }
    },

    setNoSettlecancel() {
      // this.formsetNoSettle.resetFields()
      setTimeout(
        () =>
          this.formsetNoSettle.setFieldsValue({
            settleAfterboolbool: false
          }),
        16
      )
      this.settleAfterboolbool = false
    },
    setNoSettleOk(isTemporarilySettle) {
      console.log('22', this.shijian)
      this.formsetNoSettle.validateFields((err, values) => {
        if (values.noSettleReason == '其他原因') {
          if (values.noSettleRemark == '' || values.noSettleRemark == null || values.noSettleRemark == undefined) {
            this.$message.error('请填写备注')
          } else {
            if (!err) {
              this.setNoSettleible = false
                ; (values.orderId = this.reslist.orderId), (values.isTemporarilySettle = isTemporarilySettle)
              values.settleAfterEnterprise = values.settleAfterboolbool == true ? '1' : '0'
              if (values.settleAfterboolbool == 'true') {
                values.temporarilySettleTime = ''
              } else {
                if (
                  this.temporarilySettleTime == '' ||
                  this.temporarilySettleTime == null ||
                  this.temporarilySettleTime == undefined
                ) {
                  values.temporarilySettleTime = this.shijian
                } else {
                  values.temporarilySettleTime = this.temporarilySettleTime
                }
              }
              getsetNoSettle(values).then((res) => {
                if (res.code == 0) {
                  if (isTemporarilySettle == 0) {
                    this.showisTemporarilySettleDanger = false
                  } else {
                    this.showisTemporarilySettleDanger = true
                  }
                  this.isTemporarilySettle = isTemporarilySettle
                  this.$message.success('操作成功')
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }
        } else {
          if (!err) {
            this.setNoSettleible = false
              ; (values.orderId = this.reslist.orderId), (values.isTemporarilySettle = isTemporarilySettle)
            values.settleAfterEnterprise = values.settleAfterboolbool == true ? '1' : '0'
            if (values.settleAfterboolbool == 'true') {
              values.temporarilySettleTime = ''
            } else {
              if (
                this.temporarilySettleTime == '' ||
                this.temporarilySettleTime == null ||
                this.temporarilySettleTime == undefined
              ) {
                values.temporarilySettleTime = this.shijian
              } else {
                values.temporarilySettleTime = this.temporarilySettleTime
              }
            }
            getsetNoSettle(values).then((res) => {
              if (res.code == 0) {
                if (isTemporarilySettle == 0) {
                  this.showisTemporarilySettleDanger = false
                } else {
                  this.showisTemporarilySettleDanger = true
                }
                this.isTemporarilySettle = isTemporarilySettle
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
      // this.formsetNoSettle.resetFields()
      setTimeout(
        () =>
          this.formsetNoSettle.setFieldsValue({
            settleAfterboolbool: false
          }),
        16
      )
      this.settleAfterboolbool = false
    },
    onchage44(value) {
      console.log('value', value)
      if (value == '其他原因') {
      }
    },

    isSetNoSettle() {
      this.showJiedan = false
      var Y = new Date().getFullYear()
      var Y2 = Y + 3
      var M = new Date().getMonth() + 1
      var D = new Date().getDate()
      var H = new Date().getHours()
      var F = new Date().getMinutes()
      var m = new Date().getSeconds()
      M = M > 9 ? M : '0' + M
      D = D > 9 ? D : '0' + D
      H = H > 9 ? H : '0' + H
      F = F > 9 ? F : '0' + F
      m = m > 9 ? m : '0' + m
      console.log('y', Y2)
      console.log('M', M)
      console.log('D', D)
      console.log('H', H)
      console.log('F', F)
      console.log('m', m)
      // this.formsetNoSettle.setFieldsValue({
      //   defaultValue: Y2 + '-' + M + '-' + D,
      // })
      console.log('11', Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m)
      this.shijian = Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m
      console.log('22', this.shijian)
      this.formsetNoSettle.resetFields()
      this.setNoSettleible = true
      getselectNoSettle({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.isTemporarilySettle = res.data.isTemporarilySettle
          if (res.data.isTemporarilySettle == 0) {
            this.settleAfterboolbool = res.data.settleAfterEnterprise == '1'
            this.formsetNoSettle.setFieldsValue({
              SettleTime: moment(Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m, this.format),
              temporarilySettleTime: moment(Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m, this.format)
            })
          } else {
            this.$nextTick(() => {
              this.formsetNoSettle.setFieldsValue(pick(res.data, 'noSettleReason'))
              this.formsetNoSettle.setFieldsValue({
                settleAfterboolbool: res.data.settleAfterEnterprise == '1',
                SettleTime: moment(Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m, this.format),
                temporarilySettleTime: moment(Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m, this.format)
              })
            })
            if (res.data.temporarilySettleTime) {
              this.temporarilySettleTime = res.data.temporarilySettleTime
              this.$nextTick(() => {
                this.formsetNoSettle.setFieldsValue({
                  SettleTime: moment(res.data.temporarilySettleTime, this.format),
                  temporarilySettleTime: moment(Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m, this.format)
                })
              })
            } else {
              this.formsetNoSettle.setFieldsValue({
                SettleTime: moment(Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m, this.format),
                temporarilySettleTime: moment(Y2 + '-' + M + '-' + D + ' ' + H + ':' + F + ':' + m, this.format)
              })
            }
            this.settleAfterboolbool = res.data.settleAfterEnterprise == '1'
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    orderImportant() {
      this.orderImportantbool = !this.orderImportantbool
      const isMainOrder = this.orderImportantbool ? '1' : '0'
      getorderImportant({
        orderId: this.reslist.orderId,
        isMainOrder: isMainOrder
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    //  1.1.4客服指派审核
    assignOrder(applyResult) {
      getassignOrder({
        applyResult: applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 结单
    completeOrder(applyResult) {
      this.applyResult = applyResult
      if (this.reslist.payType == 1) {
        this.showStateMent = true
      } else if (this.factoryStatus == 1) {
        this.showJiedan = true
      } else {
        this.jiedan()
      }
    },
    // 结单弹框里的结单操作
    hanleStateMent() {
      if (this.factoryStatus == 1) {
        this.showStateMent = false
        this.showJiedan = true
      } else {
        this.jiedan()
      }
    },
    // 订单完成 getcompleteOrder
    jiedan() {
      // 原来结单接口——修改为使用核销完成接口
      // getcompleteOrder({
      //   applyResult: this.applyResult,
      //   orderId: this.reslist.orderId,
      //   procInstId: this.reslist.procInstId
      // }).then(res => {
      //   if (res.code == 0) {
      //     this.$message.success('操作成功')
      //     this.showStateMent = false
      //     this.showJiedan = false
      //     this.$emit('ok')
      //     getOrderDetail({
      //       orderId: this.reslist.orderId
      //     }).then(res => {
      //       if (res.code == 0) {
      //         this.reslist = res.data
      //         this.reslist.orderStatus = res.data.orderStatus
      //       } else {
      //         this.$message.error(res.msg)
      //       }
      //     })
      //   } else {
      //     this.$message.error(res.msg)
      //   }
      // })
      getreviewOrder({
        applyResult: this.applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.showStateMent = false
          this.showJiedan = false
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 核销完成 getreviewOrder
    reviewOrder(applyResult) {
      getreviewOrder({
        applyResult: applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //  安装完成 getinstallOrder
    installOrder(applyResult) {
      getinstallOrder({
        saleCode: '123',
        applyResult: applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 预约成功 getreservationOrder
    reservationOrder(applyResult) {
      const reserveTimePart = this.informationMasterform.getFieldValue('reserveTimePart')
      const updateOrderParam = {
        orderMaster: {
          reserveTime: this.reserveTimePartChange,
          reserveTimePart: this.reslist.foreignType == 6 ? moment(reserveTimePart).format('HH:mm') : reserveTimePart
        }
      }
      getreservationOrder({
        applyResult: applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId,
        updateOrderParam: updateOrderParam
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
              console.log('预约成功', this.reslist)
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 签到成功
    signInOrder() {
      const currentPhone = this.orderClientform.getFieldValue('clientPhone')
      if (currentPhone !== this.reslist.orderClient.clientPhone) {
        this.$message.warning('真实号码已修改，请先保存订单后再进行签到')
        return
      }

      const mobileRegex = /^1[3-9]\d{9}$/
      const landlineRegex = /^(0\d{2,3}-?)?\d{7,8}$/
      if (!mobileRegex.test(currentPhone) && !landlineRegex.test(currentPhone)) {
        this.$message.error('真实号码格式不正确（需为手机号或座机号），请修改并保存后再签到')
        return
      }

      console.log(this.reslist.orderMaster.signTime, this.informationMasterform, this.time4, '签到时间')
      if (this.informationMasterform.getFieldValue('signTime')) {
        signInOrderApi({
          orderId: this.reslist.orderId,
          signTime: moment(this.informationMasterform.getFieldValue('signTime')).format('YYYY-MM-DD HH:mm:ss')
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$emit('ok')
            getOrderDetail({
              orderId: this.reslist.orderId
            }).then((res) => {
              if (res.code == 0) {
                this.reslist = res.data
                this.reslist.orderStatus = res.data.orderStatus
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('签到时间不能为空')
      }
    },
    appointmentTime(date, dateString) {
      this.estimateTime1 = dateString
    },
    // 预约失败
    failureReservationOrder() {
      this.appointmentAble = false
      this.estimateTime = null
      this.appointmentVisible = true
      this.appointmentForm.resetFields()
      // // 首次预约失败
      // getreserveFailed({
      //   orderId: this.reslist.orderId,
      //   changeReserveResult: changeReserveResult
      // }).then(res => {
      //   if (res.code == 0) {
      //     this.$message.success('操作成功');
      //     this.$emit('ok')
      //     getOrderDetail({
      //       orderId: this.reslist.orderId
      //     }).then(res => {
      //       if (res.code == 0) {
      //         this.reslist = res.data
      //         this.reslist.orderStatus = res.data.orderStatus
      //       } else {
      //         this.$message.error(res.msg);
      //       }
      //     })
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
    },
    handleAppointment() {
      this.appointmentForm.validateFields((err, values) => {
        if (!err) {
          ; (values.orderId = this.reslist.orderId), (values.estimateTime = this.estimateTime1)
          // console.log('Received values of form: ', values);
          getreserveFailed(values).then((res) => {
            // console.log(res)
            if (res.code == 0) {
              this.$message.success('预约异常成功')
              this.appointmentVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    failureinstallOrder(changeReserveResult) {
      // 师傅改约
      getchangeReservation({
        orderId: this.reslist.orderId,
        changeReserveResult: changeReserveResult
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    addorderClose() {
      this.orderCloseLoading = true
      this.orderCloseform.validateFields((err, values) => {
        values.reasonType = 2
        values.orderId = this.reslist.orderId
        values.procInstId = this.reslist.procInstId
        values.applyResult = this.applyResult
        if (this.reslist.orderStatus == 'reviewOrder') {
          getreviewOrder(values).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.$emit('ok')
              this.orderCloseible = false
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist = res.data
                  this.initialClientPhone = res.data.orderClient.clientPhone
                  this.reslist.orderStatus = res.data.orderStatus
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if (this.reslist.orderStatus == 'receiveOrder') {
          getreceiveOrder(values).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.$emit('ok')
              this.orderCloseible = false
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist = res.data
                  this.initialClientPhone = res.data.orderClient.clientPhone
                  this.reslist.orderStatus = res.data.orderStatus
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if (this.reslist.orderStatus == 'reservationOrder') {
          getreservationOrder(values).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.$emit('ok')
              this.orderCloseible = false
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist = res.data
                  this.reslist.orderStatus = res.data.orderStatus
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if (this.reslist.orderStatus == 'installOrder') {
          getinstallOrder(values).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.$emit('ok')
              this.orderCloseible = false
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist = res.data
                  this.reslist.orderStatus = res.data.orderStatus
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
        if (this.reslist.orderStatus == 'completeOrder') {
          getcompleteOrder(values).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.$emit('ok')
              this.orderCloseible = false
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist = res.data
                  this.reslist.orderStatus = res.data.orderStatus
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 关闭
    close(applyResult) {
      this.orderCloseBool = false
      this.orderCloseform.resetFields()
      this.orderCloseible = true
      this.orderCloseLoading = false
      this.applyResult = applyResult
    },
    onHasCounterVaneChange(value) {
      if (value === 0) {
        this.showCounterVaneFields = true
      } else {
        this.showCounterVaneFields = false
      }
    },
    // 接单
    receiveOrder(applyResult) {
      getreceiveOrder({
        applyResult: applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId
      }).then((res) => {
        if (res.code == 0) {
          this.$emit('ok')
          this.$message.success('操作成功')

          // getOrderDetail({
          //   orderId: this.reslist.orderId
          // }).then(res => {
          //   if (res.code == 0) {
          //     this.reslist = res.data
          //     this.reslist.orderStatus = res.data.orderStatus
          //   } else {
          //     this.$message.error(res.msg)
          //   }
          // })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 派单弹窗里面的继续派单按钮
    continueOrder() {
      getorderInfo({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.showpaidan = false
          this.$refs.leaflets.showleaflets(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 派单
    leaflets() {
      if (this.reslist.payType == 1) {
        this.showpaidan = true
      } else {
        getorderInfo({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.$refs.leaflets.showleaflets(res.data)
            // this.$router.push({name:'leafletsDistribute',params:{
            //   reslist:res.data
            // }})
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 恢复
    recovery() {
      this.recoveryloading = true
      if (this.reslist.orderStatus == 'returnOrder') {
        getreturnOrder({
          applyResult: '',
          orderId: this.reslist.orderId,
          procInstId: this.reslist.procInstId
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$emit('ok')
            getOrderDetail({
              orderId: this.reslist.orderId
            }).then((res) => {
              if (res.code == 0) {
                this.recoveryloading = false
                this.reslist = res.data
                this.reslist.orderStatus = res.data.orderStatus
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (this.reslist.orderStatus == 'closeOrder') {
        getcloseOrder({
          orderId: this.reslist.orderId,
          procInstId: this.reslist.procInstId
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$emit('ok')
            getOrderDetail({
              orderId: this.reslist.orderId
            }).then((res) => {
              if (res.code == 0) {
                this.recoveryloading = false
                this.reslist = res.data
                this.reslist.orderStatus = res.data.orderStatus
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 结束
    returnOrder(applyResult) {
      getreturnOrder({
        applyResult: applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // getenterpriseUpdate
    // 待修改 通过 不通过
    enterpriseUpdate(applyResult) {
      getenterpriseUpdate({
        applyResult: applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 客服审核
    customerServiceApply(applyResult) {
      getcustomerServiceApply({
        applyResult: applyResult,
        orderId: this.reslist.orderId,
        procInstId: this.reslist.procInstId
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.$emit('ok')
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist = res.data
              this.reslist.orderStatus = res.data.orderStatus
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 退单 ,
    backCharge(value) {
      getPendingMattersSubtype({
        matterCode: 'returnOrder'
      }).then((res) => {
        if (res.code == 0) {
          this.typePendingMattersSub = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.backChargeform.resetFields()
      this.backChargeible = true
      this.valueRejection = value
    },
    // 退单理由
    addbackCharge() {
      if (this.valueRejection == 3) {
        this.backChargeform.validateFields((err, values) => {
          values.reasonType = 1
          values.orderId = this.reslist.orderId
          values.procInstId = this.reslist.procInstId
          values.applyResult = 3
          getreceiveOrder(values).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.$emit('ok')
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist = res.data
                  this.initialClientPhone = res.data.orderClient.clientPhone
                  this.reslist.orderStatus = res.data.orderStatus
                } else {
                  this.$message.error(res.msg)
                }
              })
              this.backChargeible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        })
      } else {
        this.backChargeform.validateFields((err, values) => {
          values.orderId = this.reslist.orderId
          values.matterCode = 'returnOrder'
          if (!err) {
            getaddAudit(values).then((res) => {
              if (res.code == 0) {
                this.backChargeible = false
                this.$emit('ok')
                this.$message.success('操作成功')
                getOrderDetail({
                  orderId: this.reslist.orderId
                }).then((res) => {
                  if (res.code == 0) {
                    this.reslist = res.data
                    this.reslist.orderStatus = res.data.orderStatus
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      }
    },
    // 审核
    examine() {
      this.salepicfileList = []
      this.formmoneymodalValuesList = []
      this.modifiedamountlist = []
      this.activeKey = '2'
      getchangePriceList({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.changePriceList = res.data
          this.masterPricelength = res.data.masterPrice.length
          this.enterprisePricelength = res.data.enterprisePrice.length
          if (res.data.needAudit != 0) {
            this.examinefalg = true
            this.reviewedAmount = true
            this.orderSubStatus = false
          } else {
            this.examinefalg = false
            this.reviewedAmount = false
          }

          this.price_demand = ''
          if (this.changePriceList.orderTypeId) {
            // 查询金额要求列表
            getdemandlist({
              demandType: 'price_demand',
              orderType: this.changePriceList.orderTypeId,
              enterpriseId: this.changePriceList.enterpriseId
            }).then((res) => {
              if (res.code == 0) {
                this.price_demand = res.data.demandList.price_demand
              } else {
                this.$message.error(res.msg)
              }
            })
          }

          this.formmoney.resetFields()
          this.$nextTick(() => {
            this.formmoney.setFieldsValue(
              pick(
                this.changePriceList,
                'orderNo',
                'installType',
                'orderType',
                'count',
                'enterpriseName',
                'enterprisePrincipal',
                'enterpriseSettlementAount',
                'masterSettlementAount',
                'settlementDifference',
                'workerName',
                'workerPhone',
                'enterpriseTotalAmmount',
                'masterTotalAmount',
                'differAmount'
              )
            )
          })
        } else {
          this.$message.error(res.msg)
        }
      })
      this.falg = false
    },
    changePrice() {
      this.init()
      this.columnsenterprise = [
        {
          title: '操作栏',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          }
        },
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center'
        },
        {
          title: '金额类型',
          dataIndex: 'priceTypeName',
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'amount',
          align: 'center'
        },
        {
          title: '初始单价',
          dataIndex: 'originalPrice',
          align: 'center'
        },
        {
          title: '初始金额',
          dataIndex: 'originalTotal',
          align: 'center'
        },
        {
          title: '修改金额',
          dataIndex: 'modifiedPrice',
          align: 'center'
        },
        {
          title: '现订单金额',
          dataIndex: 'newTotal',
          align: 'center'
        },
        {
          title: '提交人',
          dataIndex: 'submitter',
          align: 'center'
        },
        {
          title: '提交时间',
          dataIndex: 'submitTime',
          align: 'center'
        },
        {
          title: '金额备注',
          dataIndex: 'priceRemark',
          align: 'center'
        }
      ]
      this.showformmoney(this.orderId)
      this.falg = true
      this.examinefalg = false
      this.reviewedAmount = false
    },
    updateCompalanitlist() {
      getcomplaintslist({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.complaintslist.complaints = res.data.complaints
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    updateFeedbacklist() {
      getfeedbacklist({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.feedbacklist.feedbackList = res.data.feedbackList
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    callback(key) {
      this.isRefresh = true
      // console.log(key)
      this.spinning = true
      this.activeKey = key
      this.falg = false
      this.examinefalg = false
      this.reviewedAmount = false
      if (key == 2) {
        this.showformmoney(this.reslist.orderId)
      } else if (key == 4) {
        this.salepicfileList = []
        getQuestion(this.orderId).then((res) => {
          console.log(res, this.orderId)
          if (res.data == null) {
            this.examStatus = 0
            this.formWriteon.resetFields()
            // 所有题目
            firstList({
              orderId: this.orderId
            }).then((res) => {
              console.log(res.rows)
              const rows = res.rows
              rows.map(function (val) {
                // console.log(val)
                val.text = ''
                val.score = ''
                // if(val.isReply == 1){
                //   val.isReply = 'true'
                // }else{
                //   val.isReply = 'false'
                // }
                if (val.subjectType == 0) {
                  val.subjectType = '单选题'
                } else if (val.subjectType == 1) {
                  val.subjectType = '多选题'
                } else if (val.subjectType == 2) {
                  val.subjectType = '下拉框'
                } else if (val.subjectType == 3) {
                  val.subjectType = '单项填空题'
                } else if (val.subjectType == 4) {
                  val.subjectType = '选择星级'
                }
              })
              this.examData1 = rows
              // console.log('更改题型后的数据', this.examData1)
              this.spinning = false
            })
          } else {
            this.examStatus = 1
            getQuestion(this.orderId).then((res) => {
              console.log('回显', res)
              this.examDataList = res.data.questionnaireList
              this.spinning = false
            })
          }
        })
      } else if (key == 1) {
        this.showeditOrder(this.reslist.orderId, '', this.editOrderShow)
      } else if (key == 5) {
        this.salepicfileList = []
        getfeedbacklist({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.feedbacklist = res.data
            this.feedbacklist.feedbackList = res.data.feedbackList
            this.formfeedback.resetFields()
            this.$nextTick(() => {
              console.log(this.feedbacklist)
              this.formfeedback.setFieldsValue(
                pick(
                  res.data,
                  'orderNo',
                  'installType',
                  'orderType',
                  'quantity',
                  'clientName',
                  'clientPhone',
                  'masterName',
                  'masterPhone'
                )
              )
              this.spinning = false
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (key == 6) {
        this.salepicfileList = []
        getcomplaintslist({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.complaintslist = res.data
            this.formcomplaint.resetFields()
            this.$nextTick(() => {
              this.formcomplaint.setFieldsValue(
                pick(
                  res.data,
                  'orderNo',
                  'installType',
                  'orderType',
                  'quantity',
                  'clientName',
                  'clientPhone',
                  'masterName',
                  'masterPhone'
                )
              )
              this.spinning = false
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (key == 7) {
        this.$nextTick(() => {
          this.spinning = false
          this.$refs.table9.refresh(true)
        })
      } else if (key == 3) {
        // 3. 销单资料 图片、视频、旧件返厂
        getsaleOrderData({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.logisticsInfo = null
            // this.courierImgArr = []
            this.factoryImgArr = []
            this.serialNumber = res.data.serialNumber // 序列号-扫码
            this.salepicList = res.data.picList // 图片列表
            this.logisticsInfo = res.data.logisticsInfo // 旧件返厂列表
            this.salepicList.forEach((item) => {
              item.salepicfileList = []
            })
            this.salevideoList = res.data.videoList
            this.$nextTick(() => {
              this.spinning = false
            })
          } else {
            this.$message.error(res.msg)
          }
          // 获取原有的courierImg-长度  字符串->对象/数组
          if (this.logisticsInfo != null) {
            this.courierImgArr = this.logisticsInfo.courierImgs == null ? [] : this.logisticsInfo.courierImgs
            this.courierImgArr = this.courierImgArr.map((item, index) => {
              return {
                url: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item,
                url1: item,
                uid: index
              }
            })

            this.factoryImgArr = this.logisticsInfo.factoryImgs == null ? [] : this.logisticsInfo.factoryImgs
            this.factoryImgArr = this.factoryImgArr.map((item, index) => {
              return { url: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item, url1: item, uid: index }
            })
          } else {
            this.logisticsInfo = {
              courierImg: '',
              factoryImg: '',
              courierNumber: ''
            }
          }
        })
      } else if (key == 8) {
        this.spinning = false
        this.$nextTick(() => {
          this.$refs.kehu.init(this.reslist.orderId)
        })
      } else if (key == 9) {
        this.spinning = false
        this.$nextTick(() => {
          this.$refs.kefu.init(this.reslist.orderId)
        })
      }
    },
    onChangefeedback(e) {
      const obj = {}
      obj.relationType = 'orderId'
      obj.relationId = this.problemform.getFieldValue('orderId')
      obj.matterCode = e
      getprocessor(obj).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.problemform.setFieldsValue({
            handler: res.rows
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangecomplaint(e) {
      const obj = {}
      obj.relationType = 'orderId'
      obj.relationId = this.problemform.getFieldValue('orderId')
      obj.matterCode = e
      getprocessor(obj).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.problemform.setFieldsValue({
            handler: res.rows
          })
        } else {
          this.$message.error(res.msg)
        }
      })
      this.complaintAuthority.forEach((item) => {
        if (item.matterCode == e) {
          this.complaintObject = item.complaintObject
          console.log(this.complaintObject)
        }
      })
      this.problemform.setFieldsValue({
        complaintObject: '',
        respondent: ''
      })
    },
    onChangeradio(e) {
      this.value = e.target.value
      this.problemform.setFieldsValue({
        handler: ''
      })
      if (this.value == 1) {
        getFeedbackAuthority().then((res) => {
          if (res.code == 0) {
            // console.log(res)
            this.feedbackAuthority = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        getComplaintAuthority().then((res) => {
          if (res.code == 0) {
            this.complaintAuthority = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    problemInitiate() {
      this.problemform.resetFields()
      this.problemible = true
      this.addproblemLoading = false
      this.problemfileList = []
      this.$nextTick(() => {
        this.problemform.setFieldsValue(pick(this.reslist, 'orderNo', 'orderId'))
      })
    },
    addproblem() {
      this.addproblemLoading = true
      this.userId = this.$store.getters.userId
      this.problemform.validateFields((err, values) => {
        values.picUrlList = this.complaintfilelist
        if (!err) {
          this.addproblemLoading = false
          if (this.value == 1) {
            values.initiator = this.userId
            getaddFeedback(values).then((res) => {
              if (res.code == 0) {
                this.problemible = false
                this.$emit('ok')
                this.updateFeedbacklist()

                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            values.complainant = this.userId

            this.problemible = false
            getaddComplaint(values).then((res) => {
              if (res.code == 0) {
                this.$emit('ok')
                this.updateCompalanitlist()
                this.$message.success('操作成功')
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },

    toTop(i) {
      // 参数i表示间隔的幅度大小，以此来控制速度
      document.getElementsByClassName('ant-modal-wrap ')[0].scrollTop = 0
      // document.documentElement.scrollTop -= i
      // if (document.documentElement.scrollTop > 0) {
      //   var c = setTimeout(() => this.toTop(i), 16)
      // } else {
      //   clearTimeout(c)
      // }
    },

    // 审核通过
    approved() {
      getaudit({
        orderId: this.changePriceList.orderId,
        updateTime: this.changePriceList.lastUpdateTime,
        result: 1
      }).then((res) => {
        if (res.code == 0) {
          this.examine()
          this.editOrderible = false
          this.$message.success('操作成功')
          this.reviewedAmount = false
          this.$emit('moneyok')
          this.$emit('ok')
          if (this.staType) {
            this.$emit('ok9')
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 审核未通过
    failedAudit() {
      getaudit({
        orderId: this.changePriceList.orderId,
        updateTime: this.changePriceList.lastUpdateTime,
        result: 0
      }).then((res) => {
        if (res.code == 0) {
          this.examine()
          this.$emit('ok')
          this.editOrderible = false
          this.$message.success('操作成功')
          this.reviewedAmount = false
          this.$emit('moneyok')
          if (this.staType) {
            this.$emit('ok9')
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 计算企业newTotal值
    amountModify(value) {
      this.modifiedamountmodel.setFieldsValue({
        modifiedPrice: value - 0 - (this.submissionPricerecord.originalTotal - 0)
      })
      this.submissionPricerecord.newTotal = value
      this.submissionPricerecord.modifiedPrice = value - this.submissionPricerecord.originalTotal
      // console.log(value)
    },
    // 计算师傅newTotal值
    masteramountModify(value) {
      this.masteramountmodel.setFieldsValue({
        modifiedPrice: (value - 0 - (this.recordList.originalTotal - 0)).toFixed(0)
      })
      this.recordList.newTotal = value
      this.recordList.modifiedPrice = value - this.recordList.originalTotal
      // console.log(value)
    },
    // 改价
    submissionPrice(record, index, type) {
      var that = this
      // this.modifiedamountlist = [] //提交内容
      this.submissionPricerecord = ''
      this.recordList = ''
      this.enterpriceindex = -1
      this.masterpriceindex = -1
      this.modifiedamountmodel.resetFields()
      this.masteramountmodel.resetFields()
      this.submissionPricetype = type
      this.submissionPriceible = true
      var enterprice = this.changePriceList.enterprisePrice
      var masterlist = this.changePriceList.masterPrice
      console.log('enterprice', enterprice, masterlist, record.priceTypeName)
      var priceType = record.priceTypeName
      // 当 type = 企业 enterprise
      if (type == 'enterprise') {
        this.submissionPricerecord = JSON.parse(JSON.stringify(record))
        this.enterpriceindex = index
        if (masterlist.length) {
          masterlist.forEach(function (item, index) {
            if (item.priceTypeName == priceType) {
              that.masterpriceindex = index
              that.recordList = JSON.parse(JSON.stringify(item))
              that.changprice = 1
              that.$nextTick(function () {
                that.masteramountmodel.setFieldsValue(
                  pick(that.recordList, 'role', 'priceTypeName', 'modifiedPrice', 'priceRemark', 'newTotal')
                )
                // that.masteramountmodel.setFieldsValue({
                //   newTotal: (that.recordList.originalTotal - 0) + (item.modifiedPrice - 0)
              })
            }
          })
          if (!that.recordList) {
            this.changprice = 2
          }
        } else {
          this.changprice = 2
        }
        this.$nextTick(function () {
          this.modifiedamountmodel.setFieldsValue(
            pick(record, 'role', 'priceTypeName', 'modifiedPrice', 'priceRemark', 'newTotal')
          )
          // this.modifiedamountmodel.setFieldsValue({
          //   newTotal: (this.submissionPricerecord.originalTotal - 0) + (record.modifiedPrice - 0)
          // })
        })
      }
      // 当 type = 师傅 master
      if (type == 'master') {
        this.recordList = JSON.parse(JSON.stringify(record))
        this.masterpriceindex = index
        if (enterprice.length) {
          enterprice.forEach(function (item, index) {
            if (item.priceTypeName == priceType) {
              that.changprice = 1
              that.enterpriceindex = index
              that.submissionPricerecord = JSON.parse(JSON.stringify(item))
              that.$nextTick(function () {
                that.modifiedamountmodel.setFieldsValue(
                  pick(that.submissionPricerecord, 'role', 'priceTypeName', 'modifiedPrice', 'priceRemark', 'newTotal')
                )
                // that.modifiedamountmodel.setFieldsValue({
                //   newTotal: (that.submissionPricerecord.originalTotal - 0) + (item.modifiedPrice - 0),
                // })
              })
            }
          })
          if (!that.submissionPricerecord) {
            this.changprice = 3
          }
        } else {
          this.changprice = 3
        }
        this.$nextTick(function () {
          this.masteramountmodel.setFieldsValue(
            pick(record, 'role', 'priceTypeName', 'modifiedPrice', 'priceRemark', 'newTotal')
          )
          // this.masteramountmodel.setFieldsValue({
          //   newTotal: (this.recordList.originalTotal - 0) + (record.modifiedPrice - 0),
          // })
        })
      }
    },
    // 改价确定
    modifiedamount() {
      var that = this
      console.log(this.recordList)
      this.masteramountmodel.validateFields((err, values) => {
        if (err) {
          console.log(err, values)
          return false
        } else {
          this.modifiedamountLoading = true
          this.submissionPriceible = false
          this.$nextTick(function () {
            if (this.enterpriceindex != -1) {
              var enterlistfalse = 1
              this.submissionPricerecord.priceRemark = this.modifiedamountmodel.getFieldValue('priceRemark')
              console.log('this.submissionPricerecord', this.submissionPricerecord)
              this.basicPricelist = this.basicPricelist.filter((item) => !that.submissionPricerecord.priceType)
              this.changePriceList.enterprisePrice[this.enterpriceindex] = this.submissionPricerecord
              const changePrice = {}
              var newpriceArry = {
                modifiedPrice: this.submissionPricerecord.modifiedPrice,
                newTotal: this.submissionPricerecord.newTotal,
                priceId: this.submissionPricerecord.priceId,
                priceOwnerType: this.submissionPricerecord.priceOwnerType,
                priceType: this.submissionPricerecord.priceType,
                priceTypeName: this.submissionPricerecord.priceTypeName,
                priceRemark: this.submissionPricerecord.priceRemark
              }
              changePrice.priceInfo = newpriceArry
              changePrice.orderId = this.changePriceList.orderId

              if (this.formmoneymodalValuesList.length) {
                this.formmoneymodalValuesList.forEach(function (item, index) {
                  if (item.priceTypeName == that.submissionPricerecord.priceTypeName) {
                    enterlistfalse = 2
                    item.enterpriseModified = that.submissionPricerecord.modifiedPrice
                    item.enterpriseNewTotal = that.submissionPricerecord.newTotal
                    item.enterpriseRemark = that.submissionPricerecord.priceRemark
                  }
                })
              }
              if (enterlistfalse == 1) {
                that.modifiedamountlist.push(changePrice)
              }
              console.log('changePrice', changePrice)
            }
            // 修改师傅金额
            if (this.masterpriceindex != -1) {
              var masterlistfalse = 1
              this.recordList.priceRemark = this.masteramountmodel.getFieldValue('priceRemark')
              console.log('this.recordList', this.recordList)
              this.basicPricelist = this.basicPricelist.filter((item) => !that.recordList.priceType)
              this.changePriceList.masterPrice[this.masterpriceindex] = this.recordList

              const changePrice = {}
              var newpriceArry = {
                modifiedPrice: this.recordList.modifiedPrice,
                newTotal: this.recordList.newTotal,
                priceId: this.recordList.priceId,
                priceOwnerType: this.recordList.priceOwnerType,
                priceType: this.recordList.priceType,
                priceTypeName: this.recordList.priceTypeName,
                priceRemark: this.recordList.priceRemark
              }
              changePrice.priceInfo = newpriceArry
              changePrice.orderId = this.changePriceList.orderId
              if (this.formmoneymodalValuesList.length) {
                this.formmoneymodalValuesList.forEach(function (item, index) {
                  if (item.priceTypeName == that.recordList.priceTypeName) {
                    masterlistfalse = 2
                    item.masterModified = that.recordList.modifiedPrice
                    item.masterNewTotal = that.recordList.newTotal
                    item.masterRemark = that.recordList.priceRemark
                  }
                })
              }
              if (enterlistfalse == 1) {
                that.modifiedamountlist.push(changePrice)
              }
            }
            this.newaddprice = -1
            if (this.changePriceList.masterPrice.length > 0) {
              let enterprisenewTotal = 0
              this.changePriceList.enterprisePrice.forEach((item) => {
                enterprisenewTotal += item.originalTotal + item.modifiedPrice
              })
              let masternewTotal = 0
              this.changePriceList.masterPrice.forEach((item) => {
                masternewTotal += item.originalTotal + item.modifiedPrice
              })
              if (enterprisenewTotal - masternewTotal <= this.changePriceList.diffPrice) {
                this.reviewedAmount = true
              } else {
                this.reviewedAmount = false
              }
            }

            // console.log('this.changePriceListmod',this.submissionPricerecord,'recordList',this.recordList,'changePriceList',this.changePriceList)
          })
        }
      })

      // 修改企业金额
    },

    // modifiedamount() {
    //   this.modifiedamountLoading = true
    //   let that = this
    //   this.modifiedamountmodel.validateFields((err, values) => {//改价弹窗
    //     if (this.submissionPricerecord.priceId) {
    //       values.priceOwnerType = this.submissionPricerecord.priceOwnerType
    //       values.priceId = this.submissionPricerecord.priceId
    //       values.priceType = this.submissionPricerecord.priceType
    //     }
    //     this.basicPricelist = this.basicPricelist.filter(item => !values.priceType)
    //     this.submissionPriceible = false
    //     if (!err) {
    //       if (that.submissionPricerecord.priceId) {
    //         let changePrice = {}
    //         changePrice.priceInfo = values
    //         changePrice.orderId = this.changePriceList.orderId
    //         that.modifiedamountlist.push(changePrice)
    //         if (that.submissionPricetype == 'enterprise') {
    //           this.changePriceList.enterprisePrice[that.submissionPriceindex].modifiedPrice = values.modifiedPrice
    //           this.changePriceList.enterprisePrice[that.submissionPriceindex].newTotal = values.newTotal
    //         }
    //         if (that.submissionPricetype == 'master') {
    //           this.changePriceList.masterPrice[that.submissionPriceindex].modifiedPrice = values.modifiedPrice
    //           this.changePriceList.masterPrice[that.submissionPriceindex].newTotal = values.newTotal
    //         }
    //       } else {
    //         if (that.submissionPricetype == 'enterprise') {
    //           this.changePriceList.enterprisePrice[that.submissionPriceindex].modifiedPrice = values.modifiedPrice
    //           this.changePriceList.enterprisePrice[that.submissionPriceindex].newTotal = values.newTotal
    //           this.formmoneymodalValuesList[that.submissionPriceindex - this.enterprisePricelength].enterpriseModified =
    //             values.modifiedPrice
    //           this.formmoneymodalValuesList[that.submissionPriceindex - this.enterprisePricelength].enterpriseNewTotal =
    //             values.newTotal
    //         }
    //         if (that.submissionPricetype == 'master') {
    //           this.changePriceList.masterPrice[that.submissionPriceindex].modifiedPrice = values.modifiedPrice
    //           this.changePriceList.masterPrice[that.submissionPriceindex].newTotal = values.newTotal
    //           this.formmoneymodalValuesList[that.submissionPriceindex - this.masterPricelength].masterModified =
    //             values.modifiedPrice
    //           this.formmoneymodalValuesList[that.submissionPriceindex - this.masterPricelength].masterNewTotal =
    //             values.newTotal
    //         }
    //         this.modifiedamountLoading = false
    //       }
    //       if (this.changePriceList.masterPrice.length > 0) {
    //         let enterprisenewTotal = 0
    //         this.changePriceList.enterprisePrice.forEach(item => {
    //           enterprisenewTotal = item.originalTotal + item.modifiedPrice
    //         })
    //         let masternewTotal = 0
    //         this.changePriceList.masterPrice.forEach(item => {
    //           masternewTotal += item.originalTotal + item.modifiedPrice
    //         })
    //         if (enterprisenewTotal - masternewTotal <= this.changePriceList.diffPrice) {
    //           this.reviewedAmount = true
    //         } else {
    //           this.reviewedAmount = false
    //         }
    //       }
    //       // values.orderId=this.changePriceList.orderId
    //     }
    //   })
    // },
    // 金额审核提交
    submissionAmount() {
      // console.log('this.changePriceList.orderId',this.changePriceList.orderId,this.formmoneymodalValuesList,this.modifiedamountlist)
      getchangePriceBatch({
        orderId: this.changePriceList.orderId,
        addPriceParams: this.formmoneymodalValuesList,
        changePriceParams: this.modifiedamountlist
      }).then((res) => {
        if (res.code == 0) {
          this.callback('2')
          this.$message.success('操作成功')
          this.newaddprice = -1
          this.masterpriceindex = -1
          this.enterpriceindex = -1
          // 新增数组
          this.formmoneymodalValuesList = []
          // 改价数组
          this.modifiedamountlist = []
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 新增价格确定
    addmoneymodel() {
      this.addmoneymodelLoading = true
      this.formmoneymodal.validateFields((err, values) => {
        console.log('sasasa', this.formmoneymodal)
        if (!err) {
          values.orderId = this.changePriceList.orderId
          this.moneyaddible = false
          values.priceTypeName = this.pricelabel
          values.selected = this.isSelected
          this.formmoneymodalValuesList.push(values)
          console.log('this.formmoneymodalValuesList', this.formmoneymodalValuesList, values)
          var date = new Date() // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
          var Y = date.getFullYear()
          var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
          var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
          var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
          var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
          var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
          var nickname = this.$store.getters.nickname
          // console.log(nickname)
          var date = new Date()
          // var year = date.getFullYear();
          // var month = date.getMonth() + 1;
          // var day = date.getDate();
          // var hour = date.getHours();
          // var minute = date.getMinutes();
          // var second = date.getSeconds();
          var remarkdate = `${Y}-${M}-${D} ${h}:${m}:${s}`
          this.changePriceList.enterprisePrice.push({
            // '金额类型'
            priceTypeName: this.pricelabel,
            // '数量'
            amount: values.amount,
            // '初始单价'
            originalPrice: values.enterpriseOriginalPrice,
            // '初始金额'
            originalTotal: values.enterpriseOriginalTotal,
            // '修改金额'
            modifiedPrice: values.enterpriseModified,
            // '现订单金额'
            newTotal: values.enterpriseNewTotal,
            // '提交人'
            submitter: nickname,
            // '提交时间'
            submitTime: remarkdate,
            // '金额备注'
            priceRemark: values.enterpriseRemark
          })
          this.changePriceList.masterPrice.push({
            // '金额类型'
            priceTypeName: this.pricelabel,
            // '数量'
            amount: values.amount,
            // '初始单价'
            originalPrice: values.masterOriginalPrice,
            // '初始金额'
            originalTotal: values.masterOriginalTotal,
            // '修改金额'
            modifiedPrice: values.masterModified,
            // '现订单金额'
            newTotal: values.masterNewTotal,
            // '提交人'
            submitter: nickname,
            // '提交时间'
            submitTime: remarkdate,
            // '金额备注'
            priceRemark: values.masterRemark
          })
          let enterprisenewTotal = 0
          this.changePriceList.enterprisePrice.forEach((item) => {
            enterprisenewTotal += item.originalTotal + item.modifiedPrice
          })
          let masternewTotal = 0
          this.changePriceList.masterPrice.forEach((item) => {
            masternewTotal += item.originalTotal + item.modifiedPrice
          })
          if (enterprisenewTotal - masternewTotal <= this.changePriceList.diffPrice) {
            this.reviewedAmount = true
          } else {
            this.reviewedAmount = false
          }
          this.addmoneymodelLoading = false
          this.newaddprice = 1
          console.log(enterprisenewTotal, masternewTotal)
        }
      })
    },
    // 计算企业总金额值
    enterpriseModify(value) {
      const priceType = this.formmoneymodal.getFieldValue('priceType')
      const amount = this.formmoneymodal.getFieldValue('enterpriseOriginalTotal')
      const age = /^[0-9]*$/
      // console.log(amount,age.test(amount))
      if (priceType) {
        if (age.test(amount)) {
          this.formmoneymodal.setFieldsValue({
            enterpriseNewTotal: amount - 0 + (value - 0)
          })
        }
      } else {
        this.$message.error('请先选择金额类型')
      }
    },
    // 计算师傅总金额
    masterModify(value) {
      const priceType = this.formmoneymodal.getFieldValue('priceType')
      const amount = this.formmoneymodal.getFieldValue('masterOriginalTotal')
      const age = /^[0-9]*$/
      if (priceType) {
        if (age.test(amount - 0)) {
          this.formmoneymodal.setFieldsValue({
            masterNewTotal: amount - 0 + (value - 0)
          })
        } else {
          console.log(111)
        }
      } else {
        this.$message.error('请先选择金额类型')
      }
    },
    // 金额类型更改 调接口查询价格
    priceTypeChange(e) {
      this.isSelected = false
      console.log(this.basicPricelist, 'this.basicPricelist', e == this.priceCode)
      this.basicPricelist.forEach((item) => {
        if (item.priceType == e) {
          this.pricelabel = item.label
        }
      })
      if (e == this.priceCode) {
        // 展示 开箱不良勾选
        this.chooseReason = true
      } else {
        this.chooseReason = false
      }
      // console.log(this.changePriceList)
      queryPriceByIdAndType({
        userId: this.changePriceList.masterId,
        priceType: e
      }).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.formmoneymodal.setFieldsValue({
              masterOriginalPrice: res.data.price,
              masterNewTotal: res.data.price
              // amount: 222,
            })
          } else {
            this.formmoneymodal.setFieldsValue({
              masterOriginalPrice: 0,
              masterNewTotal: 0
              // amount: 222,
            })
          }

          const amount = this.formmoneymodal.getFieldValue('amount')
          const masterOriginalPrice = this.formmoneymodal.getFieldValue('masterOriginalPrice')
          this.formmoneymodal.setFieldsValue({
            masterOriginalTotal: amount * masterOriginalPrice
          })
        } else {
          this.$message.error(res.msg)
        }
      })
      getByPriceType({
        enterpriseId: this.changePriceList.enterpriseId,
        priceType: e
      }).then((res) => {
        if (res.code == 0) {
          // console.log(res)
          if (res.data) {
            this.formmoneymodal.setFieldsValue({
              enterpriseOriginalPrice: res.data.price,
              enterpriseNewTotal: res.data.price
            })
          } else {
            this.formmoneymodal.setFieldsValue({
              enterpriseOriginalPrice: 0,
              enterpriseNewTotal: 0
            })
          }

          const amount = this.formmoneymodal.getFieldValue('amount')
          const enterpriseOriginalPrice = this.formmoneymodal.getFieldValue('enterpriseOriginalPrice')
          this.formmoneymodal.setFieldsValue({
            enterpriseOriginalTotal: amount * enterpriseOriginalPrice
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 新增价格按钮
    moneyadd() {
      const that = this
      this.isSelected = false
      this.chooseReason = false
      this.formmoneymodal.resetFields()
      getcanAddPriceTypes({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          this.moneyaddible = true
          this.basicPricelist = res.data
          res.data.forEach((item) => {
            if (item.label == '空跑金额') {
              this.priceCode = item.priceType
            }
          })
          this.formmoneymodalValuesList.forEach((tab) => {
            that.basicPricelist = that.basicPricelist.filter((item) => tab.priceType != item.priceType)
          })
          // this.basicPricelist
        } else {
          this.$message.error(res.msg)
        }
      })
      console.log(this.priceCode, 'this.priceCode ')
    },
    exchangeOrderRelation(record) {
      getexchangeOrderRelation({
        orderId: this.reslist.orderId
      }).then((res) => {
        if (res.code == 0) {
          getsearchOrderRelation({
            orderId: this.reslist.orderId,
            clientAddress: this.reslist.orderClient.clientAddress,
            clientPhone: this.reslist.orderClient.clientPhone,
            installType: this.reslist.installType
          }).then((res) => {
            if (res.code == 0) {
              this.relationList = res.data.orderList
              this.orderType = res.data.orderType
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 主订单
    orderMaster(record) {
      if (record.orderId == this.orderId22) {
      } else {
        this.orderId22 = record.orderId
        if (this.editloading) {
          return false
        } else {
          this.editloading = true
          addOrderRelation({
            masterOrderId: record.orderId,
            servantOrderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.editloading = false
              getsearchOrderRelation({
                orderId: this.reslist.orderId,
                clientAddress: this.reslist.orderClient.clientAddress,
                clientPhone: this.reslist.orderClient.clientPhone,
                installType: this.reslist.installType
              }).then((res) => {
                if (res.code == 0) {
                  this.editloading = false
                  this.relationList = res.data.orderList
                  this.orderType = res.data.orderType
                } else {
                  this.editloading = false
                  this.$message.error(res.msg)
                  this.orderId22 = ''
                }
              })
            } else {
              this.editloading = false
              this.$message.error(res.msg)
            }
          })
        }
      }
    },
    // 关联
    relation(record) {
      console.log('record', record)
      if (record.orderId == this.orderId22) {
      } else {
        this.orderId22 = record.orderId
        if (this.editloading) {
          return false
        } else {
          this.editloading = true
          addOrderRelation({
            masterOrderId: this.reslist.orderId,
            servantOrderId: record.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.editloading = false
              getsearchOrderRelation({
                orderId: this.reslist.orderId,
                clientAddress: this.reslist.orderClient.clientAddress,
                clientPhone: this.reslist.orderClient.clientPhone,
                installType: this.reslist.installType
              }).then((res) => {
                if (res.code == 0) {
                  this.editloading = false
                  this.relationList = res.data.orderList
                  this.orderType = res.data.orderType
                } else {
                  this.$message.error(res.msg)
                  this.editloading = false
                }
              })
            } else {
              this.$message.error(res.msg)
              this.editloading = false
              this.orderId22 = ''
            }
          })
        }
      }
    },
    ordercancel() {
      this.editOrderible = false
      if (this.backlogNum == 1) {
        this.$emit('Ok')
      } else if (this.backlogNum == 2) {
        this.$emit('ok')
      } else if (this.backlogNum == 3) {
        this.$emit('moneyok')
      } else if (this.backlogNum == 4) {
        this.$emit('ok')
      } else if (this.backlogNum == 5) {
        this.$emit('ok')
      } else if (this.backlogNum == 6) {
        this.$emit('ok')
      }
    },
    // 订单提交按钮
    orderSubmit(e) {
      this.remark.orderId = this.reslist.orderId
      this.remark.remarkType = 2
      const remarkInfo = this.remark.remarkInfo
      this.masterRemark = this.remark

      this.orderremark.orderId = this.reslist.orderId
      this.orderremark.remarkType = 1
      const remarkInfo2 = this.orderremark.remarkInfo
      this.orderRemark = this.orderremark
      // e.preventDefault();
      this.orderClientform.validateFields((err, orderClientvalues) => {
        if (!err) {
          this.orderClientformOk = true
          orderClientvalues.installTime = this.installTimeedit
          this.orderClientvalues = orderClientvalues
          console.log(orderClientvalues)
        } else {
          this.orderClientformOk = false
        }
      })
      this.informationMasterform.validateFields((err, informationMastervalues) => {
        if (!err) {
          this.informationMasterformOk = true
          informationMastervalues.picUploadTime = this.time1
          informationMastervalues.acceptTime = this.time2
          informationMastervalues.saleTime = this.time3
          informationMastervalues.signTime = this.time4
          informationMastervalues.reserveTime = this.reserveTimePartChange

          this.orderMastervalues = informationMastervalues
          // console.log(this.orderMastervalues)
        } else {
          this.informationMasterformOk = false
        }
      })
      this.form.validateFields((err, values) => {
        // console.log(this.orderClientvalues)
        if (!err) {
          this.formOk = true
          if (this.reslist.firstName) {
            values.firstName = this.reslist.firstName
          }
          if (this.reslist.secondName) {
            values.secondName = this.reslist.secondName
          }
          if (this.reslist.thirdName) {
            values.thirdName = this.reslist.thirdName
          }
          values.isSmsWarn = this.isSmsWarnbool ? '1' : '0'
          values.isSerialNotice = this.isSerialNotice ? '1' : '0'
          values.factoryStatus = this.factoryStatus ? '1' : '0'
          values.orderId = this.reslist.orderId
          values.requirement = this.reslist.requirement
          values.orderClient = this.orderClientvalues
          if (remarkInfo) {
            values.masterRemark = this.masterRemark
          }
          if (remarkInfo2) {
            values.orderRemark = this.orderRemark
          }
          // console.log(this.orderClientvalues)
          values.orderMaster = this.orderMastervalues
          this.reslist.installCustomize.map(r => {
            console.log('检查安装信息是否为空')
            if ((r.infoValue == '' || !r.infoValue) && r.isRequired == '0') {
              this.formOk = false
            }
          })
          values.installCustomize = this.reslist.installCustomize
          const arrMaster = []
          this.fileListMaster.forEach((item) => {
            if (item.url) {
              arrMaster.push(item.url.replace(/https:\/\/lockan.obs.cn-east-3.myhuaweicloud.com\//, ''))
            } else {
              arrMaster.push(item.response.url)
            }
          })
          console.log(this.fileListMaster, arrMaster)
          values.masterRequirePic = arrMaster
          // console.log( values.masterRequirePic)
          const arr = []
          this.orderClientPic.forEach((tab) => {
            if (tab.response) {
              arr.push(tab.response.url)
            } else {
              arr.push(tab.url.replace(/https:\/\/lockan.obs.cn-east-3.myhuaweicloud.com\//, ''))
            }
          })
          values.clientPic = arr
          values.clientVideo = this.clientVideo
          // values.modelId = values.modelId? values.modelId:''
          // values.buyChannelId =values.buyChannelId? values.buyChannelId:''
          // values.infoSourceId =values.infoSourceId? values.infoSourceId:''
          // values.brandId =values.brandId? values.brandId:''
          // console.log(values.modelId)
        } else {
          this.formOk = false
        }
        console.log(this.formOk, this.informationMasterformOk, this.orderClientformOk, '提交')

        if (this.formOk && this.informationMasterformOk && this.orderClientformOk) {
          console.log(9999, values)
          getupdateOrder(values).then((res) => {
            if (res.code == 0) {
              this.masterRemark = {}
              this.orderRemark = {}
              this.editOrderible = false
              this.$message.success('操作成功')
              this.$emit('ok')
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.incompleteible = true
        }
      })
    },
    // ordercancel(){
    //   this.$router.go(-1)
    // },
    incompleteOk() {
      this.incompleteible = false
    },
    // 移除取消时调用的方法
    confirmCancel() {
      this.incompleteible = false
    },
    gettransport(Code, No) {
      console.log(Code)
      getTransportInfo({
        transportCode: Code,
        transportNo: No
      }).then((res) => {
        if (res.code == 0) {
          this.transportble = true
          this.transportInfo = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 取消
    cancelOrderRelation() {
      if (this.cancelOrderStatus) {
        return false
      } else {
        this.cancelOrderStatus = true
        getcancelOrderRelation({
          orderId: this.reslist.orderId
        }).then((res) => {
          if (res.code == 0) {
            this.orderId22 = ''
            getsearchOrderRelation({
              orderId: this.reslist.orderId,
              clientAddress: this.reslist.orderClient.clientAddress,
              clientPhone: this.reslist.orderClient.clientPhone,
              installType: this.reslist.installType
            }).then((res) => {
              if (res.code == 0) {
                this.relationList = res.data.orderList
                this.orderType = res.data.orderType
                this.cancelOrderStatus = false
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },

    handlePreview(file) {
      console.log(file)
      if (!file.url && !file.preview) {
        file.preview = file.thumbUrl
      } else {
        file.url = file.url
      }
      this.previewImage = file.url || file.preview
      // console.log(this.previewImage)
      this.previewVisible = true
    },
    /* 订单  下来框改变时 */
    orderChange(e) {
      const item = this.List.find(r => r.orderTypeId == e)
      this.orderTypeName = item ? item.typeName : ''
      if (e == this.orderTypeInit) {
        this.reslist.installCustomize = this.installationInfoList
      } else {
        // 安装信息
        gettemplateselectInfo({ orderType: e, installType: this.reslist.installType }).then(res => {
          if (res.code == 0) {
            if (res.data) {
              if (res.data != '无模板可用') {
                if (res.data.installationInfoList.length > 0) {
                  this.reslist.installCustomize = res.data.installationInfoList.map(r => ({
                    dictType: r.fieldValue,
                    dictInfo: r.installTypeValues,
                    infoName: r.installationInfoName,
                    infoType: r.fieldType,
                    infoValue: null,
                    isRequired: r.isMust,
                    orderId: this.reslist.orderId,
                    ...r
                  }))
                } else {
                  this.reslist.installCustomize = []
                }
              } else {
                this.reslist.installCustomize = []
              }
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    changeinput(i, e) {
      // installationInfoList
      this.reslist.installCustomize[i].infoValue = e.target.value
    },
    changeselect(i, e) {
      console.log('select')

      this.reslist.installCustomize[i].infoValue = e
    },
    onChangeaccessories(date, dateString) {
      this.parts.deliveryTimeReturn = dateString
    },
    addaccessoriesReturn() {
      this.formaccessoriesReturn.validateFields((err, values) => {
        values.deliveryTime = this.parts.deliveryTimeReturn
        console.log(values)
        if (!err) {
          this.accessoriesitem = ''
          getreturnOrderAccessory(values).then((res) => {
            if (res.code == 0) {
              this.accessoriesReturnidle = false
              this.$message.success('退回成功')
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist.accessoryList = res.data.accessoryList
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('未填写数据')
        }
      })
    },
    partsReturn(record) {
      this.accessoriesReturnidle = true
      this.formaccessoriesReturn.resetFields()
      this.accessoriesitem = ''
      // if (record.deliveryTime)  {
      //   this.accessoriesitem = moment(record.deliveryTime, this.dateFormat) , 'transportNo'
      // }
      this.$nextTick(() => {
        this.formaccessoriesReturn.setFieldsValue(pick(record, 'orderAccessoryId'))
      })

      // setTimeout(() => {
      //   this.formaccessoriesReturn.setFieldsValue({
      //     transportCode:record.transportNumber
      //   })
      // }, 100)
    },
    partsObsolete(id) {
      getinvalidOrderAccessory({
        orderAccessoryId: id
      }).then((res) => {
        if (res.code == 0) {
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist.accessoryList = res.data.accessoryList
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    cancelAccessories() {
      this.time_list = ''
      this.queryEnterpriseStock = ''
    },
    onChangeT(date, dateString) {
      this.parts.deliveryTime = dateString
    },
    onChangetemporarily(date, dateString) {
      this.temporarilySettleTime = dateString
      // console.log(date, dateString);
    },
    onChangeinfo() {
      this.showh = !this.showh
    },
    orderRemarkEdit(record) {
      this.orderRemarkble = true
      this.orderRemarkbleLoading = false
      this.orderRemarkmodal = record
    },
    removeorderRemark(id) {
      getdeleteOrderRemark({
        orderRemarkId: id
      }).then((res) => {
        if (res.code == 0) {
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist.orderRemark = res.data.orderRemark
              this.reslist.masterRemark = res.data.masterRemark
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    addremark() {
      this.orderRemarkbleLoading = true

      this.orderRemarkble = false
      getupdateOrderRemark(this.orderRemarkmodal).then((res) => {
        this.orderRemarkbleLoading = false
        if (res.code == 0) {
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist.orderRemark = res.data.orderRemark
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    Submission() {
      this.remark.orderId = this.reslist.orderId
      this.remark.remarkType = 2
      const remarkInfo = this.remark.remarkInfo

      if (remarkInfo) {
        if (remarkInfo.trim()) {
          getaddOrderRemark(this.remark).then((res) => {
            if (res.code == 0) {
              this.remark = {}
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist.masterRemark = res.data.masterRemark
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('请填写备注内容')
        }
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    external() {
      this.orderremark.orderId = this.reslist.orderId
      this.orderremark.remarkType = 1
      let str = ''
      if (this.orderremark.remark1) {
        str += '企业：' + this.orderremark.remark1 + '；'
      }
      if (this.orderremark.remark2) {
        str += '客户：' + this.orderremark.remark2 + '；'
      }
      if (this.orderremark.remark3) {
        str += '师傅：' + this.orderremark.remark3 + '；'
      }
      this.orderremark.remarkInfo = str
      const remarkInfo = this.orderremark.remarkInfo

      if (remarkInfo) {
        if (remarkInfo.trim()) {
          getaddOrderRemark(this.orderremark).then((res) => {
            if (res.code == 0) {
              this.orderremark = {}
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist.orderRemark = res.data.orderRemark
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('请填写备注内容')
        }
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    inside() {
      this.orderremark.orderId = this.reslist.orderId
      this.orderremark.remarkType = 0
      let str = ''
      if (this.orderremark.remark1) {
        str += '企业：' + this.orderremark.remark1 + '；'
      }
      if (this.orderremark.remark2) {
        str += '客户：' + this.orderremark.remark2 + '；'
      }
      if (this.orderremark.remark3) {
        str += '师傅：' + this.orderremark.remark3 + '；'
      }
      this.orderremark.remarkInfo = str
      const remarkInfo = this.orderremark.remarkInfo
      if (remarkInfo) {
        if (remarkInfo.trim()) {
          getaddOrderRemark(this.orderremark).then((res) => {
            if (res.code == 0) {
              this.orderremark = {}
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist.orderRemark = res.data.orderRemark
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('请填写备注内容')
        }
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    removepackage(id) {
      /* console.log(id) */
      getdelTransport({
        transportId: id
      }).then((res) => {
        if (res.code == 0) {
          /* console.log(res) */
          getOrderDetail({
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              this.reslist.transportList = res.data.transportList
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    packageEdit(record) {
      this.formpackage.resetFields()

      // this.package = record
      this.packageable = true
      this.packageLoading = false
      this.$nextTick(() => {
        this.formpackage.setFieldsValue(
          pick(record, 'transportId', 'transportCode', 'transportName', 'transportNo', 'remark')
        )
      })
      setTimeout(
        () =>
          this.formpackage.setFieldsValue({
            isMainbool: record.isMain != 0
          }),
        16
      )
    },
    checkboxchange(e) {
      this.package.isMain = e.target.checked
    },
    /* 添加包裹 */
    packageAdd() {
      if (this.reslist.transportList.length < 5) {
        this.packageable = true
        this.packageLoading = false
        this.formpackage.resetFields()
      } else {
        this.$message.error('最多为5条')
      }
    },
    addpackage() {
      this.packageLoading = true

      this.formpackage.validateFields((err, values) => {
        values.orderId = this.reslist.orderId
        values.isMain = values.isMainbool ? '1' : '0'

        if (!err) {
          this.packageable = false
          getaddTransport(values).then((res) => {
            this.packageLoading = false
            if (res.code == 0) {
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist.transportList = res.data.transportList
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('未填写数据')
        }
      })
    },
    /* 配件信息 */
    accessoryChange(e) {
      const accessoryNum =
        this.formaccessories.getFieldValue('accessoryNum') /* 查询企业要求列表 this.queryEnterpriseAccessoryPrice= '' */
      console.log(accessoryNum, 'accessoryNum')
      getqueryEnterpriseAccessoryPrice({
        accessoryId: e,
        enterpriseId: this.enterpriseId,
        orderId: this.reslist.orderId
      }).then((res) => {
        console.log(res, 'res===========')
        if (res.code == 0) {
          if (res.data) {
            if (res.data.price >= 0 || res.data.masterPrice >= 0) {
              setTimeout(() => {
                this.formaccessories.setFieldsValue({
                  price: res.data.price,
                  masterPrice: res.data.masterPrice
                })
                console.log(this.storeType, 'this.storeType====')
                if (this.storeType != 3 && this.storeType) {
                  this.formaccessories.setFieldsValue({
                    masterPrice: 0
                  })
                }
                this.accessoryNumChange(accessoryNum)
              }, 100)
            }
          }
        } else {
          this.$message.error(res.data.masterPrice, 'res.data.masterPrice')
        }
      })
      // console.log(object);
    },
    // 数量更改的时候
    async accessoryNumChange(value) {
      // console.log(object);
      const amount = this.formaccessories.getFieldValue('price') ? this.formaccessories.getFieldValue('price') : 0
      const amountM = this.formaccessories.getFieldValue('masterPrice')
        ? this.formaccessories.getFieldValue('masterPrice')
        : 0
      const valueNum = value || 0

      this.formaccessories.setFieldsValue({
        totalAmount: (amount - 0) * (valueNum - 0),
        masterTotalAmount: (amountM - 0) * (valueNum - 0)
      })
      if (!this.formaccessories.getFieldValue('orderAccessoryId')) {
        console.log(value, 'value========')
        // && value
        if (this.formaccessories.getFieldValue('accessoryId') && this.enterpriseId) {
          /* this.queryEnterpriseStock= []; */
          await getqueryEnterpriseStock({
            accessoryId: this.formaccessories.getFieldValue('accessoryId'),
            enterpriseId: this.enterpriseId,
            repositoryType: this.repositoryType,
            useNum: valueNum,
            orderId: this.reslist.orderId
          }).then((res) => {
            if (res.code == 0) {
              console.log('选择后', res)
              this.queryEnterpriseStock = []
              this.queryEnterpriseStock = res.data.filter((item) => item.storeName)
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('请选择配件，企业名称')
        }
      }

      /* 查询企业可分配仓库 */
    },
    // 更改仓库
    storeChange(value) {
      const EnterpriseStock = this.queryEnterpriseStock.filter((item) => item.storeId == value)
      console.log('EnterpriseStock', EnterpriseStock, 'value', value)
      this.storeType = EnterpriseStock[0].storeType
      if (EnterpriseStock[0].storeType != '3') {
        this.formaccessories.setFieldsValue({
          masterPrice: 0,
          masterTotalAmount: 0
        })
      } else {
        const accessoryId = this.formaccessories.getFieldValue('accessoryId')
        this.accessoryChange(accessoryId)
      }
    },
    addAccessories() {
      this.accessoriesLoading = true
      this.formaccessories.validateFields((err, values) => {
        console.log(values.masterPrice, '提交values.masterPrice==========')
        values.orderId = this.reslist.orderId
        values.deliveryTime = this.parts.deliveryTime
        // 新建时,默认值为0
        // if(!this.nameible){
        //   values.masterPrice = 0
        //   values.masterTotalAmount=0
        // }

        if (!err) {
          this.disable = false
          this.nameible = false
          this.time_list = ''
          addOrderAccessory(values).then((res) => {
            this.accessoriesLoading = false
            if (res.code == 0) {
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist.accessoryList = res.data.accessoryList
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('未填写数据')
        }
      })
    },
    handleEdit(record) {
      //  console.log('编辑获得的record',record)
      // // 获取企业配件金额
      this.formaccessories.resetFields()
      // this.parts = record
      this.time_list = ''
      if (record.deliveryTime) {
        this.time_list = moment(record.deliveryTime, this.dateFormat)
      }
      this.disable = true
      this.accessoriesLoading = false
      if (record.transportNo) {
        this.showh = true
      } else {
        this.showh = false
      }

      this.nameible = true
      this.queryEnterpriseStock = []
      const totalAmount = record.totalAmount
      const masterTotalAmount = record.masterTotalAmount
      // const masterPrice = record.masterPrice
      const accessoryNum = record.accessoryNum
      setTimeout(() => {
        this.formaccessories.setFieldsValue({
          price: (totalAmount - 0) / (accessoryNum - 0),
          masterPrice: (masterTotalAmount - 0) / (accessoryNum - 0),
          transportCode: record.transportNumber,
          totalAmount: totalAmount,
          masterTotalAmount: masterTotalAmount,
          accessoryNum: accessoryNum
        })
      }, 100)
      //  console.log('编辑获得的this.formaccessories',this.formaccessories)

      // repositoryType
      this.$nextTick(() => {
        this.formaccessories.setFieldsValue(
          pick(
            record,
            'orderAccessoryId',
            'accessoryId',
            'transportId',
            'repositoryName',
            'accessoryName',
            'accessoryNum',
            'totalAmount',
            'masterTotalAmount',
            'repositoryId',
            'transportNo',
            'sendUser',
            'receiveUser',
            'transportRemark',
            'repositoryType'
          )
        )
      })
    },
    showbtn() {
      this.EnterpriseAccessory = []
      this.formaccessories.resetFields()
      this.showh = false
      this.nameible = false
      this.accessoriesLoading = false
      this.disable = true
      getqueryEnterpriseAccessory({
        brandId: this.form.getFieldValue('brandId'),
        modelId: this.form.getFieldValue('modelId'),
        installType: this.form.getFieldValue('installType'),
        enterpriseId: this.enterpriseId
      }).then((res) => {
        if (res.code == 0) {
          this.EnterpriseAccessory = res.data
          /* console.log(this.EnterpriseAccessory) console.log(res) */
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /* 品牌框改变时 */
    changeBrandName(e) {
      this.form.setFieldsValue({
        modelId: ''
      })
      this.selectModel = []
      getSelectModel({
        installType: this.form.getFieldValue('installType'),
        enterpriseId: this.enterpriseId,
        brandId: e
      }).then((res) => {
        if (res.code == 0) {
          this.selectModel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /* 企业  下来框改变时 */
    enterpriseChange(e) {
      this.form.setFieldsValue({
        installType: '',
        orderType: '',
        brandId: '',
        modelId: '',
        infoSourceId: '',
        buyChannelId: ''
      })
      this.enterpriseId = e
      getenterpriseInstallTypes({
        enterpriseId: e
      }).then((res) => {
        if (res.code == 0) {
          this.installTypes = res.data
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
      getBaseInfoForOrder({
        enterpriseId: e
      }).then((res) => {
        if (res.code == 0) {
          this.form.setFieldsValue({
            installType: res.data.defaultInstallType,
            payType: res.data.payType
          })
          this.customInfo = res.data.customInfo
          getList(res.data.defaultInstallType).then((res) => {
            if (res.code == 0) {
              this.List = res.rows
              this.orderTypeName = this.List[0].typeName
              console.log(this.orderTypeName, 333333333, res.rows)
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
      /* 发货仓库 */
      this.queryEnterpriseStock = []
      getqueryEnterpriseStock({
        accessoryId: this.parts.accessoryList,
        enterpriseId: e,
        useNum: this.parts.accessoryNum
      }).then((res) => {
        if (res.code == 0) {
          this.queryEnterpriseStock = []
          this.queryEnterpriseStock = res.data.filter((item) => item.storeName)
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectBrand = []
      /* 查询品牌下拉框 */
      getSelectBrand({
        installType: this.form.getFieldValue('installType'),
        enterpriseId: e
      }).then((res) => {
        if (res.code == 0) {
          this.selectBrand = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      /* 查询型号下拉框 */
      this.selectModel = []
      getSelectModel({
        installType: this.form.getFieldValue('installType'),
        enterpriseId: e,
        brandId: this.form.getFieldValue('brandId')
      }).then((res) => {
        if (res.code == 0) {
          this.selectModel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectSource = []
      /* 查询信息来源下拉框 */
      getselectSource({
        installType: this.form.getFieldValue('installType'),
        enterpriseId: e
      }).then((res) => {
        if (res.code == 0) {
          /* console.log(res) */
          this.selectSource = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      /* 查询购买渠道下拉框 */
      this.selectChannel = []
      getselectChannel({
        installType: this.form.getFieldValue('installType'),
        enterpriseId: e
      }).then((res) => {
        if (res.code == 0) {
          /* console.log(res) */
          this.selectChannel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /* 安装类别框改变时 */
    installChange(e) {
      this.form.setFieldsValue({
        orderType: '',
        brandId: '',
        modelId: '',
        infoSourceId: '',
        buyChannelId: ''
      })
      this.List = []
      getList(e).then((res) => {
        if (res.code == 0) {
          this.List = res.rows
          this.orderTypeName = this.List[0].typeName
          console.log(this.orderTypeName, 1111111111)

          /* console.log(res.rows) */
        } else {
          this.$message.error(res.msg)
        }
      })
      this.EnterpriseAccessory = []

      this.selectBrand = []
      getSelectBrand({
        installType: e,
        enterpriseId: this.enterpriseId
      }).then((res) => {
        if (res.code == 0) {
          this.selectBrand = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectModel = []
      getSelectModel({
        installType: e,
        enterpriseId: this.enterpriseId,
        brandId: this.form.getFieldValue('brandId')
      }).then((res) => {
        if (res.code == 0) {
          this.selectModel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectSource = []
      /* 查询信息来源下拉框 */
      getselectSource({
        installType: e,
        enterpriseId: this.enterpriseId
      }).then((res) => {
        if (res.code == 0) {
          /* console.log(res) */
          this.selectSource = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectChannel = []
      getselectChannel({
        installType: e,
        enterpriseId: this.enterpriseId
      }).then((res) => {
        if (res.code == 0) {
          this.selectChannel = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /* 区 */
    getprovinceName(e) {
      getselectAreaName({
        cityCode: e
      }).then((res) => {
        if (res.code == 0) {
          /* console.log(res) */
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      this.form.setFieldsValue({
        countyId: ''
      })
    },
    /* 市 */
    getselect(e) {
      getselectCityName({
        provinceCode: e
      }).then((res) => {
        if (res.code == 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      this.orderClientform.setFieldsValue({
        cityId: ''
      })
      this.orderClientform.setFieldsValue({
        countyId: ''
      })
    },
    onChanginstallTimeible(value) {
      if (value) {
        this.expectinstallTimeible = true
      } else {
        this.expectinstallTimeible = false
      }
    },
    onChangerangepicker(date, dateString) {
      this.installTimeedit = dateString
      if (dateString) {
        this.expectinstallTimeible = true
      } else {
        this.expectinstallTimeible = false
      }
    },
    onChangereserveTime(date, dateString) {
      if (dateString != '') {
        this.reserveTimePartChange = dateString
      } else {
        this.reserveTimePartChange = null
      }
    },
    onChangeTime1(date, dateString) {
      if (dateString != '') {
        this.time1 = dateString
      } else {
        this.time1 = null
      }
    },
    onChangeTime2(date, dateString) {
      if (dateString != '') {
        this.time2 = dateString
      } else {
        this.time2 = null
      }
    },
    onChangeTime3(date, dateString) {
      if (dateString != '') {
        this.time3 = dateString
      } else {
        this.time3 = null
      }
    },
    onChangeTime4(date, dateString) {
      if (dateString != '') {
        this.time4 = dateString
      } else {
        this.time4 = null
      }
      console.log(this.time4, dateString, 'onChangeTime4')
    },
    handleCanceltwo() {
      this.previewVisibletwo = false
    },
    handlePreviewtwo(file) {
      this.previewImagetwo = file.url || file.thumbUrl
      this.previewVisibletwo = true
      /* 在里面调禁用的接口 */
    },
    handleChangetwo({ fileListtwo }) {
      this.fileListtwo = fileListtwo
    },
    // 核销
    // 单选题
    onChange(index, e) {
      // console.log('单选',index,e.target.value);
      // console.log('当前所选题目',this.data1[index])
      for (const item of this.examData1[index].optionList) {
        // 所选题目的选项
        var text = this.examData1[index].text // 选项关联的初始值
        if (item.optionName == e.target.value) {
          // 如果题目选项中name值，与被选中的value值相同
          // console.log('被选中项的关联id',item.optionSubjectId)  //被选中项的关联id
          this.examData1[index].score = item.penaltyValue
          // console.log(this.data1[index].score)
          if (item.optionSubjectId.length != 0) {
            if (text.length != 0) {
              // 先隐藏之前选项的关联题
              for (let a = 0; a < this.examData1.length; a++) {
                for (let b = 0; b < text.length; b++) {
                  if (this.examData1[a].subjectId == text[b]) {
                    // console.log('需要隐藏的题目',this.data1[a])
                    this.examData1[a].isRelation = 0
                  }
                }
              }
              console.log(item.optionSubjectId, item.penaltyValue)
              // 显示当前选项的关联题,并给text 重新赋值
              this.examData1[index].text = item.optionSubjectId
              for (let tet = 0; tet < this.examData1.length; tet++) {
                // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                for (let val = 0; val < item.optionSubjectId.length; val++) {
                  if (this.examData1[tet].subjectId == item.optionSubjectId[val]) {
                    this.examData1[tet].isRelation = 1
                  }
                }
              }
            } else {
              console.log(item.optionSubjectId, item.penaltyValue)
              this.examData1[index].text = item.optionSubjectId
              console.log('text新值2', this.examData1[index].text)
              for (let tet = 0; tet < this.examData1.length; tet++) {
                // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                for (let val = 0; val < item.optionSubjectId.length; val++) {
                  if (this.examData1[tet].subjectId == item.optionSubjectId[val]) {
                    this.examData1[tet].isRelation = 1
                  }
                }
              }
            }
          } else {
            for (const tet of this.examData1) {
              // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
              if (text.length != 0) {
                // 将之前选中的关联题隐藏
                for (let i = 0; i < text.length; i++) {
                  if (tet.subjectId == text[i]) {
                    console.log(tet)
                    tet.isRelation = 0
                    console.log('进入清空')
                    text = []
                  }
                }
              }
            }
          }
        }
      }
    },
    // 下拉单选框
    handleExamSelect(index, value) {
      // console.log('单选框',index,value)
      for (const item of this.examData1[index].optionList) {
        // 所选题目的选项
        var text = this.examData1[index].text // 选项关联的初始值
        if (item.optionName == value) {
          // 如果题目选项中name值，与被选中的value值相同
          // console.log('被选中项的关联id',item.optionSubjectId)  //被选中项的关联id
          this.examData1[index].score = item.penaltyValue
          if (item.optionSubjectId.length != 0) {
            if (text.length != 0) {
              // 先隐藏之前选项的关联题
              for (let a = 0; a < this.examData1.length; a++) {
                for (let b = 0; b < text.length; b++) {
                  if (this.examData1[a].subjectId == text[b]) {
                    // console.log('需要隐藏的题目',this.data1[a])
                    this.examData1[a].isRelation = 0
                    this.examData1[a].score = 0
                    // console.log('已隐藏')
                  }
                }
              }
              // 显示当前选项的关联题,并给text 重新赋值
              this.examData1[index].text = item.optionSubjectId
              for (let tet = 0; tet < this.examData1.length; tet++) {
                // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                for (let val = 0; val < item.optionSubjectId.length; val++) {
                  if (this.examData1[tet].subjectId == item.optionSubjectId[val]) {
                    this.examData1[tet].isRelation = 1
                    console.log('已显示')
                  }
                }
              }
            } else {
              console.log(item.optionSubjectId)
              this.examData1[index].text = item.optionSubjectId
              console.log('text新值2', this.examData1[index].text)
              for (let tet = 0; tet < this.examData1.length; tet++) {
                // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
                for (let val = 0; val < item.optionSubjectId.length; val++) {
                  if (this.examData1[tet].subjectId == item.optionSubjectId[val]) {
                    this.examData1[tet].isRelation = 1
                  }
                }
              }
            }
          } else {
            for (const tet of this.examData1) {
              // 试题的id 与 选项中的关联id 做对比，如果相同，显示当前被关联的题目
              if (text.length != 0) {
                // 将之前选中的关联题隐藏
                for (let i = 0; i < text.length; i++) {
                  if (tet.subjectId == text[i]) {
                    console.log(tet)
                    tet.isRelation = 0
                    console.log('进入清空')
                    text = []
                  }
                }
              }
            }
          }
        }
      }
    },
    // 多选题
    handleCheck(index, values) {
      const that = this
      console.log('多选', index, values)
      const arr11 = []
      const arr12 = []
      const text = this.examData1[index].text
      let arr = [] // 合并所有关联的id
      for (const item of this.examData1[index].optionList) {
        // console.log(item)
        for (const tet of values) {
          if (item.optionName == tet) {
            arr = arr.concat(item.optionSubjectId)
            arr11.push(item.penaltyValue)
            arr12.push(item.optionSubjectId)
          }
        }
      }
      this.examData1[index].score = arr11
      const arr1 = [] // 合并id去重
      for (let i = 0; i < arr.length; i++) {
        if (arr1.indexOf(arr[i]) == -1) {
          arr1.push(arr[i])
        }
      }
      // console.log(arr1,arr11,arr12)  //最终关联id集合数组
      if (arr1.length != 0 && text.length == 0) {
        // 当有关联id，text初始为【】，初次赋值text
        this.examData1[index].text = arr1
        for (const item of this.data1) {
          for (let a = 0; a < arr1.length; a++) {
            // console.log(arr1[a])
            if (item.subjectId == arr1[a]) {
              // console.log(item,that.data1[index].subjectId)
              item.isRelation = 1
            }
          }
        }
      } else if (arr1.length != 0 && text.length != 0) {
        // 当有关联id，text有值，先隐藏text中的id，再重新赋值text，新的关联id显示
        for (const item of this.examData1) {
          for (let a = 0; a < text.length; a++) {
            // console.log(arr1[a])
            if (item.subjectId == text[a]) {
              // console.log(item)
              item.isRelation = 0
            }
          }
        }
        this.examData1[index].text = arr1
        for (const item of this.examData1) {
          for (let a = 0; a < arr1.length; a++) {
            // console.log(arr1[a])
            if (item.subjectId == arr1[a]) {
              // console.log(item)
              item.isRelation = 1
            }
          }
        }
      } else if (arr1.length == 0 && text.length != 0) {
        // 当没有关联id,text有值时，将之前显示的题目隐藏
        for (const item of this.examData1) {
          for (let a = 0; a < text.length; a++) {
            // console.log(arr1[a])
            if (item.subjectId == text[a]) {
              // console.log(item)
              item.isRelation = 0
              item.text = []
            }
          }
        }
      }
      console.log(this.examData1)
    },
    handleExamOn(e) {
      e.preventDefault()
      var that = this
      const userid = store.getters.userId
      // console.log(this.data1)
      this.formWriteon.validateFields((err, values) => {
        // console.log(err,values)
        if (!err) {
          // this.confirmLoading = true
          const data2 = []
          const answer = []
          for (let i = 0; i < this.examData1.length; i++) {
            if (this.examData1[i].isRelation == 1) {
              data2.push(this.examData1[i])
            }
          }
          // 多選
          for (const key in values) {
            if (Array.isArray(values[key])) {
              values[key] = values[key].join('-')
            }
          }
          // console.log(values)
          // console.log(data2,'data2999') // 所有显示出来的题目
          for (let s = 0; s < data2.length; s++) {
            // console.log(data2[s])
            const str = {}
            str.subjectId = data2[s].subjectId
            str.createBy = userid
            str.updateBy = userid
            if (data2[s].subjectType == '多选题') {
              str.orderId = this.orderId
              str.subjectName = data2[s].subjectName
              str.optionName = values['value' + data2[s].sort]
              answer.push(str)
              if (data2[s].score.length != 0) {
                str.penaltyValue = data2[s].score.join('-')
              } else {
                str.penaltyValue = data2[s].score
              }
            } else {
              str.orderId = this.orderId
              str.subjectName = data2[s].subjectName
              str.penaltyValue = data2[s].score
              str.optionName = values['value' + data2[s].sort]
              answer.push(str)
            }
          }
          // console.log(answer)
          const arrList = []
          for (const i of answer) {
            arrList.push(i.optionName)
          }
          if (arrList.indexOf(undefined) > -1) {
            const that = this
            this.$confirm({
              title: '',
              content: '您还有问题未答完，是否确认提交数据？',
              okType: 'danger',
              onOk() {
                insert(answer)
                  .then((res) => {
                    if (res.code == 0) {
                      that.$nextTick(() => {
                        that.$message.success('保存成功')
                        that.$emit('ok')
                        that.examStatus = 1
                        getQuestion(that.orderId).then((res) => {
                          // console.log(res)
                          that.examDataList = res.data.questionnaireList
                        })
                      })
                    } else {
                      that.$message.success(res.msg)
                    }
                  })
                  .catch(() => {
                    that.$message.error('系统错误，请稍后再试')
                  })
                  .finally(() => {
                    that.confirmLoading = false
                  })
              },
              onCancel() {
                console.log('Cancel')
              }
            })
          } else {
            insert(answer)
              .then((res) => {
                if (res.code == 0) {
                  that.$nextTick(() => {
                    that.$message.success('保存成功')
                    that.$emit('ok')
                    that.examStatus = 1
                    getQuestion(that.orderId).then((res) => {
                      // console.log(res)
                      that.examDataList = res.data.questionnaireList
                    })
                  })
                } else {
                  that.$message.success(res.msg)
                }
              })
              .catch(() => {
                that.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        }
      })
    },
    handleCancel() {
      this.examStatus = 0
      this.formWriteon.resetFields()
      // 所有题目
      firstList({
        orderId: this.orderId
      }).then((res) => {
        console.log(res.rows)
        const rows = res.rows
        rows.map(function (val) {
          // console.log(val)
          val.text = ''
          val.score = ''
          // if(val.isReply == 1){
          //   val.isReply = 'true'
          // }else{
          //   val.isReply = 'false'
          // }
          if (val.subjectType == 0) {
            val.subjectType = '单选题'
          } else if (val.subjectType == 1) {
            val.subjectType = '多选题'
          } else if (val.subjectType == 2) {
            val.subjectType = '下拉框'
          } else if (val.subjectType == 3) {
            val.subjectType = '单项填空题'
          } else if (val.subjectType == 4) {
            val.subjectType = '选择星级'
          }
        })
        this.examData1 = rows
        console.log('更改题型后的数据', this.examData1)
      })
    },
    dianji() {
      var txt = $(this).first().find('p').html()
      // console.log(txt);
      $(this)
        .find('p')
        .html(txt.replace(/[\n\r]/g, '<br>'))
    },

    // 师傅金额现总金额校验
    handleNewTotal(rule, value, callback) {
      if (this.recordList.priceTypeName == '安装金额') {
        if (this.recordList.originalTotal == 0) {
          callback()
        } else if (value > this.recordList.originalTotal) {
          callback('修改金额不允许大于初始金额，初始金额0除外')
        } else if (value <= this.recordList.originalTotal) {
          callback()
        }
      }
      callback()
    },
    // 保存订单修改信息
    orderSave() {
      this.remark.orderId = this.reslist.orderId
      this.remark.remarkType = 2
      const remarkInfo = this.remark.remarkInfo
      this.masterRemark = this.remark

      this.orderremark.orderId = this.reslist.orderId
      this.orderremark.remarkType = 1
      const remarkInfo2 = this.orderremark.remarkInfo
      this.orderRemark = this.orderremark
      // e.preventDefault();
      this.orderClientform.validateFields((err, orderClientvalues) => {
        if (!err) {
          this.orderClientformOk = true
          orderClientvalues.installTime = this.installTimeedit
          this.orderClientvalues = orderClientvalues
          console.log(orderClientvalues)
        } else {
          this.orderClientformOk = false
        }
      })
      this.informationMasterform.validateFields((err, informationMastervalues) => {
        if (!err) {
          this.informationMasterformOk = true
          informationMastervalues.picUploadTime = this.time1
          informationMastervalues.acceptTime = this.time2
          informationMastervalues.saleTime = this.time3
          informationMastervalues.signTime = this.time4
          informationMastervalues.reserveTime = this.reserveTimePartChange

          this.orderMastervalues = informationMastervalues
          // console.log(this.orderMastervalues)
        } else {
          this.informationMasterformOk = false
        }
      })
      this.form.validateFields((err, values) => {
        // console.log(this.orderClientvalues)
        if (!err) {
          this.formOk = true
          if (this.reslist.firstName) {
            values.firstName = this.reslist.firstName
          }
          if (this.reslist.secondName) {
            values.secondName = this.reslist.secondName
          }
          if (this.reslist.thirdName) {
            values.thirdName = this.reslist.thirdName
          }
          values.isSmsWarn = this.isSmsWarnbool ? '1' : '0'
          values.isSerialNotice = this.isSerialNotice ? '1' : '0'
          values.factoryStatus = this.factoryStatus ? '1' : '0'
          values.orderId = this.reslist.orderId
          values.requirement = this.reslist.requirement
          values.orderClient = this.orderClientvalues
          if (remarkInfo) {
            values.masterRemark = this.masterRemark
          }
          if (remarkInfo2) {
            values.orderRemark = this.orderRemark
          }
          // console.log(this.orderClientvalues)
          values.orderMaster = this.orderMastervalues
          
          if (values.isCounterVane === 1) {
            values.counterVaneLength = 0
            values.counterVaneWidth = 0
          }

          this.reslist.installCustomize.map(r => {
            if ((r.infoValue == '' || !r.infoValue) && r.isRequired == '0') {
              this.formOk = false
            }
          })
          values.installCustomize = this.reslist.installCustomize
          const arrMaster = []
          this.fileListMaster.forEach((item) => {
            if (item.url) {
              arrMaster.push(item.url.replace(/https:\/\/lockan.obs.cn-east-3.myhuaweicloud.com\//, ''))
            } else {
              arrMaster.push(item.response.url)
            }
          })
          console.log(this.fileListMaster, arrMaster)
          values.masterRequirePic = arrMaster
          // console.log( values.masterRequirePic)
          const arr = []
          this.orderClientPic.forEach((tab) => {
            if (tab.response) {
              arr.push(tab.response.url)
            } else {
              arr.push(tab.url.replace(/https:\/\/lockan.obs.cn-east-3.myhuaweicloud.com\//, ''))
            }
          })
          values.clientPic = arr
          values.clientVideo = this.clientVideo
          // values.modelId = values.modelId? values.modelId:''
          // values.buyChannelId =values.buyChannelId? values.buyChannelId:''
          // values.infoSourceId =values.infoSourceId? values.infoSourceId:''
          // values.brandId =values.brandId? values.brandId:''
          // console.log(values.modelId)}
        } else {
          this.formOk = false
        }
        console.log(this.formOk, this.informationMasterformOk, this.orderClientformOk, '保存')

        if (this.formOk && this.informationMasterformOk && this.orderClientformOk) {
          getupdateOrder(values).then((res) => {
            if (res.code == 0) {
              this.masterRemark = {}
              this.orderRemark = {}
              this.$message.success('操作成功')
              this.$emit('ok')
              getOrderDetail({
                orderId: this.reslist.orderId
              }).then((res) => {
                if (res.code == 0) {
                  this.reslist = res.data
                  this.initialClientPhone = res.data.orderClient.clientPhone
                  this.reslist.orderStatus = res.data.orderStatus
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.incompleteible = true
        }
      })
    }
  },
  async created() {
    const accessoriesOptions = await getDictMap('accessories_type')
    // console.log(getDictMap('accessories_type'), 'accessoriesOptions')
    accessoriesOptions.forEach((value, key) => {
      this.accessoriesOptions.push({ code: key, label: value })
    })
    this.orderReminde.date = moment(moment().format('YYYY-MM-DD '))
    const arrar1 = []
    const res = ['配件单价', '配件总金额']
    // console.log(this.accessoryBasic ,this.accessoryPrice)
    if (this.accessoryBasic && !this.accessoryPrice) {
      for (const index in this.columnsAddaccessories) {
        if (res.indexOf(this.columnsAddaccessories[index].title) == -1) {
          arrar1.push(this.columnsAddaccessories[index])
        }
      }
      this.columnsAddaccessories = arrar1
    } else if (this.accessoryPrice && !this.accessoryBasic) {
      for (const index in this.columnsAddaccessories) {
        if (res.indexOf(this.columnsAddaccessories[index].title) != -1) {
          arrar1.push(this.columnsAddaccessories[index])
        }
      }
      this.columnsAddaccessories = arrar1
    }
    // console.log(this.columnsAddaccessories)
    if (!this.viewInnerRemark) {
      for (const i in this.ordercolumns) {
        if (this.ordercolumns[i].dataIndex == 'remarkType') {
          this.ordercolumns.splice(i, 1)
        }
      }
    }
    getselectAllProvince().then((res) => {
      if (res.code == 0) {
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
  }
}
</script>
<style lang="less" scoped>
.login {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  opacity: 0.6;
  z-index: 99999;
  margin: auto;
}

.log {
  width: 60px;
  height: 60px;
  position: absolute;
  left: 0;
  right: 0;
  top: 290px;
  margin: auto;
  border-radius: 50%;
  border: 0.19rem solid #1890ff;
  border-right: transparent 0.12rem solid;
  animation: aidemoli 1s linear infinite;
}

@keyframes aidemoli {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.profile-img-container {
  position: relative;
}

.profile-img-container img:hover {
  opacity: 0.5;
}

.profile-img-container img:hover+i {
  display: block;
  z-index: 500;
}

.profile-img-container i {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.orderKeyword {
  font-size: 15px;
  margin: 10px 0px 0px 10px;
}

/deep/ .notshow {
  display: none;
}

/*a{*/
/*text-decoration: none;*/
/*}*/

/**{*/

/*color: #000000;*/
/*}*/
.Shortcutbutton {
  width: 110px;
  height: 40px;
  border-radius: 20px;
  background-color: #6dbcff;
  color: white;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.avatar-uploader>.ant-upload {
  width: 128px;
  height: 128px;
}

.disEvents {
  pointer-events: none;
}

/deep/ .ant-steps-dot .ant-steps-item-content {
  width: 400px;
}

.video {
  width: 130px;
  height: 150px;
  margin: 10px;

  position: relative;
}

.img {
  position: absolute;
  margin-left: -40px;
  margin-top: 23px;
}

.img:hover {
  cursor: pointer;
  color: red;
  z-index: 10000;
}

.video i {
  position: absolute;
  top: 0;
  width: 150px;
  height: 150px;
  background-color: #fff;
  transition: background-color 0.5s;
}

.img:hover i {
  z-index: 1000;
  background-color: rgba(251, 251, 251, 0.3);
}

.one {
  position: relative;
  bottom: 50%;
  top: -100px;
  left: -30px;
}

.two {
  position: fixed;
  bottom: 50%;
  top: -100px;
  left: -30px;
}

.nouserlook {
  // top: -86px !important;
}

/deep/ .ant-table th {
  white-space: nowrap;
}

.disEvents {
  pointer-events: none;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 22px;

  .form-item-v {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.form-label {
  width: 200px;
  margin-right: 15px;
  text-align: right;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  &.required {
    &::before {
      content: '*';
      color: red;
      margin-right: 4px;
    }
  }
}

.form-tips {
  color: brown;
  margin-left: 10px;
}

.form-value {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}

.ant-radio-group {
  display: flex;
  align-items: center;
}

.ant-radio-wrapper {
  margin-right: 24px;
}

/*/deep/ .ant-table td { white-space: nowrap; padding: 4px 16px;}*/
</style>
